var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCare5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 181.58 151.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        opacity: .33;\r\n      }\r\n\r\n      .cls-2, .cls-3, .cls-4 {\r\n        mix-blend-mode: multiply;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #e28079;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #cecece;\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: #f5f3e6;\r\n      }\r\n\r\n      .cls-8 {\r\n        isolation: isolate;\r\n      }\r\n\r\n      .cls-9 {\r\n        clip-path: url(#clippath-17);\r\n      }\r\n\r\n      .cls-10 {\r\n        clip-path: url(#clippath-19);\r\n      }\r\n\r\n      .cls-11 {\r\n        clip-path: url(#clippath-11);\r\n      }\r\n\r\n      .cls-12 {\r\n        clip-path: url(#clippath-16);\r\n      }\r\n\r\n      .cls-13 {\r\n        clip-path: url(#clippath-18);\r\n      }\r\n\r\n      .cls-14 {\r\n        clip-path: url(#clippath-10);\r\n      }\r\n\r\n      .cls-15 {\r\n        clip-path: url(#clippath-15);\r\n      }\r\n\r\n      .cls-16 {\r\n        clip-path: url(#clippath-13);\r\n      }\r\n\r\n      .cls-17 {\r\n        clip-path: url(#clippath-14);\r\n      }\r\n\r\n      .cls-18 {\r\n        clip-path: url(#clippath-12);\r\n      }\r\n\r\n      .cls-19 {\r\n        clip-path: url(#clippath-61);\r\n      }\r\n\r\n      .cls-20 {\r\n        clip-path: url(#clippath-67);\r\n      }\r\n\r\n      .cls-21 {\r\n        clip-path: url(#clippath-68);\r\n      }\r\n\r\n      .cls-22 {\r\n        clip-path: url(#clippath-60);\r\n      }\r\n\r\n      .cls-23 {\r\n        clip-path: url(#clippath-65);\r\n      }\r\n\r\n      .cls-24 {\r\n        clip-path: url(#clippath-62);\r\n      }\r\n\r\n      .cls-25 {\r\n        clip-path: url(#clippath-64);\r\n      }\r\n\r\n      .cls-26 {\r\n        clip-path: url(#clippath-66);\r\n      }\r\n\r\n      .cls-27 {\r\n        clip-path: url(#clippath-63);\r\n      }\r\n\r\n      .cls-28 {\r\n        clip-path: url(#clippath-76);\r\n      }\r\n\r\n      .cls-29 {\r\n        clip-path: url(#clippath-78);\r\n      }\r\n\r\n      .cls-30 {\r\n        clip-path: url(#clippath-75);\r\n      }\r\n\r\n      .cls-31 {\r\n        clip-path: url(#clippath-79);\r\n      }\r\n\r\n      .cls-32 {\r\n        clip-path: url(#clippath-50);\r\n      }\r\n\r\n      .cls-33 {\r\n        clip-path: url(#clippath-55);\r\n      }\r\n\r\n      .cls-34 {\r\n        clip-path: url(#clippath-52);\r\n      }\r\n\r\n      .cls-35 {\r\n        clip-path: url(#clippath-57);\r\n      }\r\n\r\n      .cls-36 {\r\n        clip-path: url(#clippath-54);\r\n      }\r\n\r\n      .cls-37 {\r\n        clip-path: url(#clippath-56);\r\n      }\r\n\r\n      .cls-38 {\r\n        clip-path: url(#clippath-53);\r\n      }\r\n\r\n      .cls-39 {\r\n        clip-path: url(#clippath-70);\r\n      }\r\n\r\n      .cls-40 {\r\n        clip-path: url(#clippath-77);\r\n      }\r\n\r\n      .cls-41 {\r\n        clip-path: url(#clippath-74);\r\n      }\r\n\r\n      .cls-42 {\r\n        clip-path: url(#clippath-71);\r\n      }\r\n\r\n      .cls-43 {\r\n        clip-path: url(#clippath-73);\r\n      }\r\n\r\n      .cls-44 {\r\n        clip-path: url(#clippath-72);\r\n      }\r\n\r\n      .cls-45 {\r\n        clip-path: url(#clippath-51);\r\n      }\r\n\r\n      .cls-46 {\r\n        clip-path: url(#clippath-58);\r\n      }\r\n\r\n      .cls-47 {\r\n        clip-path: url(#clippath-59);\r\n      }\r\n\r\n      .cls-48 {\r\n        clip-path: url(#clippath-31);\r\n      }\r\n\r\n      .cls-49 {\r\n        clip-path: url(#clippath-32);\r\n      }\r\n\r\n      .cls-50 {\r\n        clip-path: url(#clippath-33);\r\n      }\r\n\r\n      .cls-51 {\r\n        clip-path: url(#clippath-34);\r\n      }\r\n\r\n      .cls-52 {\r\n        clip-path: url(#clippath-35);\r\n      }\r\n\r\n      .cls-53 {\r\n        clip-path: url(#clippath-39);\r\n      }\r\n\r\n      .cls-54 {\r\n        clip-path: url(#clippath-30);\r\n      }\r\n\r\n      .cls-55 {\r\n        clip-path: url(#clippath-36);\r\n      }\r\n\r\n      .cls-56 {\r\n        clip-path: url(#clippath-37);\r\n      }\r\n\r\n      .cls-57 {\r\n        clip-path: url(#clippath-38);\r\n      }\r\n\r\n      .cls-58 {\r\n        clip-path: url(#clippath-27);\r\n      }\r\n\r\n      .cls-59 {\r\n        clip-path: url(#clippath-29);\r\n      }\r\n\r\n      .cls-60 {\r\n        clip-path: url(#clippath-26);\r\n      }\r\n\r\n      .cls-61 {\r\n        clip-path: url(#clippath-28);\r\n      }\r\n\r\n      .cls-62 {\r\n        clip-path: url(#clippath-20);\r\n      }\r\n\r\n      .cls-63 {\r\n        clip-path: url(#clippath-21);\r\n      }\r\n\r\n      .cls-64 {\r\n        clip-path: url(#clippath-22);\r\n      }\r\n\r\n      .cls-65 {\r\n        clip-path: url(#clippath-23);\r\n      }\r\n\r\n      .cls-66 {\r\n        clip-path: url(#clippath-24);\r\n      }\r\n\r\n      .cls-67 {\r\n        clip-path: url(#clippath-25);\r\n      }\r\n\r\n      .cls-68 {\r\n        clip-path: url(#clippath-69);\r\n      }\r\n\r\n      .cls-69 {\r\n        clip-path: url(#clippath-41);\r\n      }\r\n\r\n      .cls-70 {\r\n        clip-path: url(#clippath-42);\r\n      }\r\n\r\n      .cls-71 {\r\n        clip-path: url(#clippath-43);\r\n      }\r\n\r\n      .cls-72 {\r\n        clip-path: url(#clippath-44);\r\n      }\r\n\r\n      .cls-73 {\r\n        clip-path: url(#clippath-45);\r\n      }\r\n\r\n      .cls-74 {\r\n        clip-path: url(#clippath-49);\r\n      }\r\n\r\n      .cls-75 {\r\n        clip-path: url(#clippath-40);\r\n      }\r\n\r\n      .cls-76 {\r\n        clip-path: url(#clippath-46);\r\n      }\r\n\r\n      .cls-77 {\r\n        clip-path: url(#clippath-47);\r\n      }\r\n\r\n      .cls-78 {\r\n        clip-path: url(#clippath-48);\r\n      }\r\n\r\n      .cls-79 {\r\n        clip-path: url(#clippath-90);\r\n      }\r\n\r\n      .cls-80 {\r\n        clip-path: url(#clippath-95);\r\n      }\r\n\r\n      .cls-81 {\r\n        clip-path: url(#clippath-93);\r\n      }\r\n\r\n      .cls-82 {\r\n        clip-path: url(#clippath-99);\r\n      }\r\n\r\n      .cls-83 {\r\n        clip-path: url(#clippath-94);\r\n      }\r\n\r\n      .cls-84 {\r\n        clip-path: url(#clippath-96);\r\n      }\r\n\r\n      .cls-85 {\r\n        clip-path: url(#clippath-85);\r\n      }\r\n\r\n      .cls-86 {\r\n        clip-path: url(#clippath-86);\r\n      }\r\n\r\n      .cls-87 {\r\n        clip-path: url(#clippath-87);\r\n      }\r\n\r\n      .cls-88 {\r\n        clip-path: url(#clippath-80);\r\n      }\r\n\r\n      .cls-89 {\r\n        clip-path: url(#clippath-89);\r\n      }\r\n\r\n      .cls-90 {\r\n        clip-path: url(#clippath-81);\r\n      }\r\n\r\n      .cls-91 {\r\n        clip-path: url(#clippath-82);\r\n      }\r\n\r\n      .cls-92 {\r\n        clip-path: url(#clippath-83);\r\n      }\r\n\r\n      .cls-93 {\r\n        clip-path: url(#clippath-84);\r\n      }\r\n\r\n      .cls-94 {\r\n        clip-path: url(#clippath-88);\r\n      }\r\n\r\n      .cls-95 {\r\n        clip-path: url(#clippath-92);\r\n      }\r\n\r\n      .cls-96 {\r\n        clip-path: url(#clippath-97);\r\n      }\r\n\r\n      .cls-97 {\r\n        clip-path: url(#clippath-91);\r\n      }\r\n\r\n      .cls-98 {\r\n        clip-path: url(#clippath-98);\r\n      }\r\n\r\n      .cls-99 {\r\n        clip-path: url(#clippath-1);\r\n      }\r\n\r\n      .cls-100 {\r\n        clip-path: url(#clippath-3);\r\n      }\r\n\r\n      .cls-101 {\r\n        clip-path: url(#clippath-4);\r\n      }\r\n\r\n      .cls-102 {\r\n        clip-path: url(#clippath-2);\r\n      }\r\n\r\n      .cls-103 {\r\n        clip-path: url(#clippath-7);\r\n      }\r\n\r\n      .cls-104 {\r\n        clip-path: url(#clippath-6);\r\n      }\r\n\r\n      .cls-105 {\r\n        clip-path: url(#clippath-9);\r\n      }\r\n\r\n      .cls-106 {\r\n        clip-path: url(#clippath-8);\r\n      }\r\n\r\n      .cls-107 {\r\n        clip-path: url(#clippath-5);\r\n      }\r\n\r\n      .cls-108 {\r\n        clip-path: url(#clippath-163);\r\n      }\r\n\r\n      .cls-109 {\r\n        clip-path: url(#clippath-165);\r\n      }\r\n\r\n      .cls-110 {\r\n        clip-path: url(#clippath-160);\r\n      }\r\n\r\n      .cls-111 {\r\n        clip-path: url(#clippath-161);\r\n      }\r\n\r\n      .cls-112 {\r\n        clip-path: url(#clippath-168);\r\n      }\r\n\r\n      .cls-113 {\r\n        clip-path: url(#clippath-167);\r\n      }\r\n\r\n      .cls-114 {\r\n        clip-path: url(#clippath-162);\r\n      }\r\n\r\n      .cls-115 {\r\n        clip-path: url(#clippath-169);\r\n      }\r\n\r\n      .cls-116 {\r\n        clip-path: url(#clippath-164);\r\n      }\r\n\r\n      .cls-117 {\r\n        clip-path: url(#clippath-166);\r\n      }\r\n\r\n      .cls-118 {\r\n        clip-path: url(#clippath-178);\r\n      }\r\n\r\n      .cls-119 {\r\n        clip-path: url(#clippath-174);\r\n      }\r\n\r\n      .cls-120 {\r\n        clip-path: url(#clippath-172);\r\n      }\r\n\r\n      .cls-121 {\r\n        clip-path: url(#clippath-171);\r\n      }\r\n\r\n      .cls-122 {\r\n        clip-path: url(#clippath-179);\r\n      }\r\n\r\n      .cls-123 {\r\n        clip-path: url(#clippath-173);\r\n      }\r\n\r\n      .cls-124 {\r\n        clip-path: url(#clippath-176);\r\n      }\r\n\r\n      .cls-125 {\r\n        clip-path: url(#clippath-175);\r\n      }\r\n\r\n      .cls-126 {\r\n        clip-path: url(#clippath-182);\r\n      }\r\n\r\n      .cls-127 {\r\n        clip-path: url(#clippath-185);\r\n      }\r\n\r\n      .cls-128 {\r\n        clip-path: url(#clippath-181);\r\n      }\r\n\r\n      .cls-129 {\r\n        clip-path: url(#clippath-184);\r\n      }\r\n\r\n      .cls-130 {\r\n        clip-path: url(#clippath-183);\r\n      }\r\n\r\n      .cls-131 {\r\n        clip-path: url(#clippath-180);\r\n      }\r\n\r\n      .cls-132 {\r\n        clip-path: url(#clippath-102);\r\n      }\r\n\r\n      .cls-133 {\r\n        clip-path: url(#clippath-101);\r\n      }\r\n\r\n      .cls-134 {\r\n        clip-path: url(#clippath-104);\r\n      }\r\n\r\n      .cls-135 {\r\n        clip-path: url(#clippath-109);\r\n      }\r\n\r\n      .cls-136 {\r\n        clip-path: url(#clippath-106);\r\n      }\r\n\r\n      .cls-137 {\r\n        clip-path: url(#clippath-103);\r\n      }\r\n\r\n      .cls-138 {\r\n        clip-path: url(#clippath-105);\r\n      }\r\n\r\n      .cls-139 {\r\n        clip-path: url(#clippath-100);\r\n      }\r\n\r\n      .cls-140 {\r\n        clip-path: url(#clippath-108);\r\n      }\r\n\r\n      .cls-141 {\r\n        clip-path: url(#clippath-107);\r\n      }\r\n\r\n      .cls-142 {\r\n        clip-path: url(#clippath-118);\r\n      }\r\n\r\n      .cls-143 {\r\n        clip-path: url(#clippath-114);\r\n      }\r\n\r\n      .cls-144 {\r\n        clip-path: url(#clippath-119);\r\n      }\r\n\r\n      .cls-145 {\r\n        clip-path: url(#clippath-111);\r\n      }\r\n\r\n      .cls-146 {\r\n        clip-path: url(#clippath-110);\r\n      }\r\n\r\n      .cls-147 {\r\n        clip-path: url(#clippath-113);\r\n      }\r\n\r\n      .cls-148 {\r\n        clip-path: url(#clippath-112);\r\n      }\r\n\r\n      .cls-149 {\r\n        clip-path: url(#clippath-117);\r\n      }\r\n\r\n      .cls-150 {\r\n        clip-path: url(#clippath-115);\r\n      }\r\n\r\n      .cls-151 {\r\n        clip-path: url(#clippath-116);\r\n      }\r\n\r\n      .cls-152 {\r\n        clip-path: url(#clippath-170);\r\n      }\r\n\r\n      .cls-153 {\r\n        clip-path: url(#clippath-177);\r\n      }\r\n\r\n      .cls-154 {\r\n        clip-path: url(#clippath-151);\r\n      }\r\n\r\n      .cls-155 {\r\n        clip-path: url(#clippath-156);\r\n      }\r\n\r\n      .cls-156 {\r\n        clip-path: url(#clippath-159);\r\n      }\r\n\r\n      .cls-157 {\r\n        clip-path: url(#clippath-150);\r\n      }\r\n\r\n      .cls-158 {\r\n        clip-path: url(#clippath-143);\r\n      }\r\n\r\n      .cls-159 {\r\n        clip-path: url(#clippath-144);\r\n      }\r\n\r\n      .cls-160 {\r\n        clip-path: url(#clippath-141);\r\n      }\r\n\r\n      .cls-161 {\r\n        clip-path: url(#clippath-148);\r\n      }\r\n\r\n      .cls-162 {\r\n        clip-path: url(#clippath-142);\r\n      }\r\n\r\n      .cls-163 {\r\n        clip-path: url(#clippath-149);\r\n      }\r\n\r\n      .cls-164 {\r\n        clip-path: url(#clippath-140);\r\n      }\r\n\r\n      .cls-165 {\r\n        clip-path: url(#clippath-145);\r\n      }\r\n\r\n      .cls-166 {\r\n        clip-path: url(#clippath-146);\r\n      }\r\n\r\n      .cls-167 {\r\n        clip-path: url(#clippath-147);\r\n      }\r\n\r\n      .cls-168 {\r\n        clip-path: url(#clippath-153);\r\n      }\r\n\r\n      .cls-169 {\r\n        clip-path: url(#clippath-152);\r\n      }\r\n\r\n      .cls-170 {\r\n        clip-path: url(#clippath-157);\r\n      }\r\n\r\n      .cls-171 {\r\n        clip-path: url(#clippath-154);\r\n      }\r\n\r\n      .cls-172 {\r\n        clip-path: url(#clippath-158);\r\n      }\r\n\r\n      .cls-173 {\r\n        clip-path: url(#clippath-155);\r\n      }\r\n\r\n      .cls-174 {\r\n        clip-path: url(#clippath-120);\r\n      }\r\n\r\n      .cls-175 {\r\n        clip-path: url(#clippath-125);\r\n      }\r\n\r\n      .cls-176 {\r\n        clip-path: url(#clippath-122);\r\n      }\r\n\r\n      .cls-177 {\r\n        clip-path: url(#clippath-121);\r\n      }\r\n\r\n      .cls-178 {\r\n        clip-path: url(#clippath-123);\r\n      }\r\n\r\n      .cls-179 {\r\n        clip-path: url(#clippath-124);\r\n      }\r\n\r\n      .cls-180 {\r\n        clip-path: url(#clippath-129);\r\n      }\r\n\r\n      .cls-181 {\r\n        clip-path: url(#clippath-126);\r\n      }\r\n\r\n      .cls-182 {\r\n        clip-path: url(#clippath-128);\r\n      }\r\n\r\n      .cls-183 {\r\n        clip-path: url(#clippath-127);\r\n      }\r\n\r\n      .cls-184 {\r\n        clip-path: url(#clippath-130);\r\n      }\r\n\r\n      .cls-185 {\r\n        clip-path: url(#clippath-132);\r\n      }\r\n\r\n      .cls-186 {\r\n        clip-path: url(#clippath-131);\r\n      }\r\n\r\n      .cls-187 {\r\n        clip-path: url(#clippath-134);\r\n      }\r\n\r\n      .cls-188 {\r\n        clip-path: url(#clippath-133);\r\n      }\r\n\r\n      .cls-189 {\r\n        clip-path: url(#clippath-136);\r\n      }\r\n\r\n      .cls-190 {\r\n        clip-path: url(#clippath-139);\r\n      }\r\n\r\n      .cls-191 {\r\n        clip-path: url(#clippath-137);\r\n      }\r\n\r\n      .cls-192 {\r\n        clip-path: url(#clippath-138);\r\n      }\r\n\r\n      .cls-193 {\r\n        clip-path: url(#clippath-135);\r\n      }\r\n\r\n      .cls-194 {\r\n        fill: #6a8f7e;\r\n      }\r\n\r\n      .cls-195 {\r\n        fill: #fffffd;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #6fa886;\r\n        opacity: .56;\r\n      }\r\n\r\n      .cls-196 {\r\n        fill: #98b7a9;\r\n      }\r\n\r\n      .cls-197 {\r\n        fill: #2e3331;\r\n      }\r\n\r\n      .cls-198 {\r\n        fill: #ccc49b;\r\n      }\r\n\r\n      .cls-199 {\r\n        clip-path: url(#clippath);\r\n      }\r\n\r\n      .cls-200 {\r\n        fill: #ffc46e;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40.94,
    y: 37.19,
    width: 106.49,
    height: 38.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 38.98,
    y: 30.86,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 38.98,
    y: 42.23,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 38.98,
    y: 53.6,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 38.98,
    y: 64.96,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.39,
    y: 30.86,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.39,
    y: 42.23,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.39,
    y: 53.6,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.39,
    y: 64.96,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 61.79,
    y: 30.86,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 61.79,
    y: 42.23,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 61.79,
    y: 53.6,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 61.79,
    y: 64.96,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.19,
    y: 30.86,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.19,
    y: 42.23,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.19,
    y: 53.6,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.19,
    y: 64.96,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 84.59,
    y: 30.86,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 84.59,
    y: 42.23,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 84.59,
    y: 53.6,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 84.59,
    y: 64.96,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 96,
    y: 30.86,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 96,
    y: 42.23,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-23"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 96,
    y: 53.6,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 96,
    y: 64.96,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 107.4,
    y: 30.86,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-26"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 107.4,
    y: 42.23,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-27"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 107.4,
    y: 53.6,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-28"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 107.4,
    y: 64.96,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-29"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 118.8,
    y: 30.86,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-30"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 118.8,
    y: 42.23,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-31"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 118.8,
    y: 53.6,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-32"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 118.8,
    y: 64.96,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-33"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.2,
    y: 30.86,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-34"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.2,
    y: 42.23,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-35"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.2,
    y: 53.6,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-36"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.2,
    y: 64.96,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-37"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 141.61,
    y: 30.86,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-38"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 141.61,
    y: 42.23,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-39"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 141.61,
    y: 53.6,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-40"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 141.61,
    y: 64.96,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-41"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.71,
    y: 72.59,
    width: 108.27,
    height: 5.73
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-42"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 38.98,
    y: 64.96,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-43"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 38.98,
    y: 76.33,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-44"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.39,
    y: 64.96,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.39,
    y: 76.33,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-46"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 61.79,
    y: 64.96,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-47"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 61.79,
    y: 76.33,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-48"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.19,
    y: 64.96,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-49"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.19,
    y: 76.33,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-50"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 84.59,
    y: 64.96,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-51"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 84.59,
    y: 76.33,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-52"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 96,
    y: 64.96,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-53"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 96,
    y: 76.33,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-54"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 107.4,
    y: 64.96,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-55"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 107.4,
    y: 76.33,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-56"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 118.8,
    y: 64.96,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-57"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 118.8,
    y: 76.33,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-58"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.2,
    y: 64.96,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-59"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.2,
    y: 76.33,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-60"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 141.61,
    y: 64.96,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-61"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 141.61,
    y: 76.33,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-62"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 122.26,
    y: 14.21,
    width: 14.4,
    height: 20.76,
    transform: "translate(258.92 49.18) rotate(180)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-63"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 131.19,
    y: 1.08,
    width: 20.28,
    height: 19.11
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-64"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 131.19,
    y: 20.19,
    width: 20.28,
    height: 19.11
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-65"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 110.92,
    y: 1.08,
    width: 20.28,
    height: 19.11
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-66"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 110.92,
    y: 20.19,
    width: 20.28,
    height: 19.11
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-67"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 86.41,
    y: 81.84,
    width: 76.53,
    height: 42.88,
    transform: "translate(249.35 206.57) rotate(180)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-68"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 157.18,
    y: 76.33,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-69"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 157.18,
    y: 87.7,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-70"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 157.18,
    y: 99.06,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-71"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 157.18,
    y: 110.43,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-72"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 157.18,
    y: 121.8,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-73"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 145.78,
    y: 76.33,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-74"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 145.78,
    y: 87.7,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-75"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 145.78,
    y: 99.06,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-76"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 145.78,
    y: 110.43,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-77"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 145.78,
    y: 121.8,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-78"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 134.37,
    y: 76.33,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-79"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 134.37,
    y: 87.7,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-80"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 134.37,
    y: 99.06,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-81"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 134.37,
    y: 110.43,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-82"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 134.37,
    y: 121.8,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-83"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 122.97,
    y: 76.33,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-84"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 122.97,
    y: 87.7,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-85"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 122.97,
    y: 99.06,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-86"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 122.97,
    y: 110.43,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-87"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 122.97,
    y: 121.8,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-88"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 111.57,
    y: 76.33,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-89"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 111.57,
    y: 87.7,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-90"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 111.57,
    y: 99.06,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-91"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 111.57,
    y: 110.43,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-92"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 111.57,
    y: 121.8,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-93"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 100.17,
    y: 76.33,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-94"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 100.17,
    y: 87.7,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-95"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 100.17,
    y: 99.06,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-96"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 100.17,
    y: 110.43,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-97"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 100.17,
    y: 121.8,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-98"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.76,
    y: 76.33,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-99"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.76,
    y: 87.7,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-100"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.76,
    y: 99.06,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-101"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.76,
    y: 110.43,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-102"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.76,
    y: 121.8,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-103"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 77.36,
    y: 76.33,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-104"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 77.36,
    y: 87.7,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-105"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 77.36,
    y: 99.06,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-106"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 77.36,
    y: 110.43,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-107"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 77.36,
    y: 121.8,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-108"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 86.02,
    y: 121.47,
    width: 77.81,
    height: 6.42,
    transform: "translate(249.84 249.35) rotate(180)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-109"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 157.18,
    y: 110.43,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-110"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 157.18,
    y: 121.8,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-111"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 145.78,
    y: 110.43,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-112"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 145.78,
    y: 121.8,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-113"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 134.37,
    y: 110.43,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-114"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 134.37,
    y: 121.8,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-115"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 122.97,
    y: 110.43,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-116"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 122.97,
    y: 121.8,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-117"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 111.57,
    y: 110.43,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-118"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 111.57,
    y: 121.8,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-119"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 100.17,
    y: 110.43,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-120"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 100.17,
    y: 121.8,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-121"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.76,
    y: 110.43,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-122"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.76,
    y: 121.8,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-123"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 77.36,
    y: 110.43,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-124"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 77.36,
    y: 121.8,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-125"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 14.06,
    y: 76.83,
    width: 74.57,
    height: 52.62,
    transform: "translate(102.69 206.29) rotate(180)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-126"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 85.17,
    y: 72.88,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-127"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 85.17,
    y: 84.25,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-128"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 85.17,
    y: 95.61,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-129"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 85.17,
    y: 106.98,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-130"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 85.17,
    y: 118.35,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-131"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.77,
    y: 72.88,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-132"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.77,
    y: 84.25,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-133"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.77,
    y: 95.61,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-134"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.77,
    y: 106.98,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-135"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.77,
    y: 118.35,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-136"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.37,
    y: 72.88,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-137"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.37,
    y: 84.25,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-138"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.37,
    y: 95.61,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-139"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.37,
    y: 106.98,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-140"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.37,
    y: 118.35,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-141"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.97,
    y: 72.88,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-142"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.97,
    y: 84.25,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-143"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.97,
    y: 95.61,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-144"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.97,
    y: 106.98,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-145"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.97,
    y: 118.35,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-146"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.56,
    y: 72.88,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-147"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.56,
    y: 84.25,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-148"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.56,
    y: 95.61,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-149"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.56,
    y: 106.98,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-150"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.56,
    y: 118.35,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-151"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.16,
    y: 72.88,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-152"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.16,
    y: 84.25,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-153"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.16,
    y: 95.61,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-154"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.16,
    y: 106.98,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-155"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.16,
    y: 118.35,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-156"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 72.88,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-157"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 84.25,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-158"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 95.61,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-159"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 106.98,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-160"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 118.35,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-161"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.36,
    y: 72.88,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-162"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.36,
    y: 84.25,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-163"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.36,
    y: 95.61,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-164"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.36,
    y: 106.98,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-165"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.36,
    y: 118.35,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-166"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.84,
    y: 125.5,
    width: 79.01,
    height: 6.9,
    transform: "translate(102.69 257.91) rotate(180)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-167"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 85.21,
    y: 118.35,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-168"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 85.21,
    y: 129.71,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-169"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.81,
    y: 118.35,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-170"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.81,
    y: 129.71,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-171"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.4,
    y: 118.35,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-172"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.4,
    y: 129.71,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-173"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 51,
    y: 118.35,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-174"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 51,
    y: 129.71,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-175"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.6,
    y: 118.35,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-176"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.6,
    y: 129.71,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-177"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.2,
    y: 118.35,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-178"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.2,
    y: 129.71,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-179"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.79,
    y: 118.35,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-180"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.79,
    y: 129.71,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-181"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.39,
    y: 118.35,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-182"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.39,
    y: 129.71,
    width: 11.4,
    height: 11.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-183"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 56.7,
    y: 19.22,
    width: 9.82,
    height: 14.61,
    transform: "translate(123.23 53.05) rotate(180)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-184"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 53.05,
    y: 11.3,
    width: 13.83,
    height: 13.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-185"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 53.05,
    y: 24.76,
    width: 13.83,
    height: 13.46
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Scene"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_4",
    "data-name": 4
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M1.77,131.28c-2,4.29-2.91,11.72.54,15.35,3.65,3.85,9.69.83,24.05,1.98,9.05.73,7.47,2,17.35,2.97,9.19.9,10.7-.18,28.07,0,9.73.1,9.66.44,14.91.2,13.8-.65,12.79-2.96,20.01-2.38,1.15.09,4.22.4,4.95-.99.7-1.33-1.48-2.81-.99-3.96,1.03-2.41,11.9.89,29.21,1.97.05,0,20.11,1.82,20.98-6.85.04-.38.03-1.13.36-1.97.99-2.51,5.13-2.63,6.72-2.83,6.75-.86,13.75-6.75,13.64-8.94-.14-2.88-13.05-6.65-93.15-7.72-59.31-.79-80.95.88-86.66,13.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M58.54,129.93c-30.89,1.85-52.52,1.56-53.89,8.06-.42,1.99.95,5.1,2.98,6.84,2.94,2.53,7.12,2.08,8.64,1.93,9.57-.91,42.3-1.84,57.47-.13,2.94.33,10.08,1.31,15.87-2.88,1.7-1.23,2.6-2.41,3.16-3.03,6.71-7.61,24.69-5.42,31.18-4.9,23.59,1.91,44.81-6.02,44.72-7.95-.11-2.27-30.07-3.15-55.51-2.34-24.73.78-21.49,2.41-54.62,4.39Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 40.94,
    y: 37.19,
    width: 106.49,
    height: 38.31
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-199"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-99"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 42.64,
    y: 40.5,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.16,
    y: 41.62,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.54,
    y: 41.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.16,
    y: 39.43,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.09,
    y: 39.39,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 42.73,
    y: 41.74,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.16,
    y: 40.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48,
    y: 40.62,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 42.64,
    y: 34.81,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.16,
    y: 35.93,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.54,
    y: 35.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.47,
    y: 38.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 43.18,
    y: 38.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.75,
    y: 37.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.16,
    y: 33.74,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.09,
    y: 33.7,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.18,
    y: 37.14,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 42.73,
    y: 36.06,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.16,
    y: 34.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 38.98,
    y: 37.05,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48,
    y: 34.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 41.5,
    y: 37.41,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.45,
    y: 38.46,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.16,
    y: 30.25,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.54,
    y: 30.22,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.47,
    y: 32.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 43.18,
    y: 32.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.75,
    y: 31.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.18,
    y: 31.46,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 42.73,
    y: 30.37,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 38.98,
    y: 31.37,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 41.5,
    y: 31.73,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.45,
    y: 32.78,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-102"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 42.64,
    y: 51.86,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.16,
    y: 52.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.54,
    y: 52.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.16,
    y: 50.8,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.09,
    y: 50.75,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 42.73,
    y: 53.11,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.16,
    y: 51.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48,
    y: 51.99,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 42.64,
    y: 46.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.16,
    y: 47.3,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.54,
    y: 47.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.47,
    y: 49.78,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 43.18,
    y: 49.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.75,
    y: 48.63,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.16,
    y: 45.11,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.09,
    y: 45.07,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.18,
    y: 48.51,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 42.73,
    y: 47.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.16,
    y: 46.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 38.98,
    y: 48.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48,
    y: 46.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 41.5,
    y: 48.78,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.45,
    y: 49.83,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.16,
    y: 41.62,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.54,
    y: 41.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.47,
    y: 44.1,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 43.18,
    y: 44.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.75,
    y: 42.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.18,
    y: 42.83,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 42.73,
    y: 41.74,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 38.98,
    y: 42.73,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 41.5,
    y: 43.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.45,
    y: 44.14,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-100"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 42.64,
    y: 63.23,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.16,
    y: 64.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.54,
    y: 64.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.16,
    y: 62.16,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.09,
    y: 62.12,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 42.73,
    y: 64.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.16,
    y: 63.35,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48,
    y: 63.35,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 42.64,
    y: 57.55,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.16,
    y: 58.67,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.54,
    y: 58.63,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.47,
    y: 61.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 43.18,
    y: 61.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.75,
    y: 60,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.16,
    y: 56.48,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.09,
    y: 56.44,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.18,
    y: 59.88,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 42.73,
    y: 58.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.16,
    y: 57.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 38.98,
    y: 59.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48,
    y: 57.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 41.5,
    y: 60.15,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.45,
    y: 61.19,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.16,
    y: 52.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.54,
    y: 52.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.47,
    y: 55.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 43.18,
    y: 55.63,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.75,
    y: 54.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.18,
    y: 54.19,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 42.73,
    y: 53.11,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 38.98,
    y: 54.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 41.5,
    y: 54.46,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.45,
    y: 55.51,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-101"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 42.64,
    y: 74.6,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.16,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.54,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.16,
    y: 73.53,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.09,
    y: 73.49,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 42.73,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.16,
    y: 74.72,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48,
    y: 74.72,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 42.64,
    y: 68.91,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.16,
    y: 70.03,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.54,
    y: 70,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.47,
    y: 72.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 43.18,
    y: 72.69,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.75,
    y: 71.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.16,
    y: 67.85,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.09,
    y: 67.8,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.18,
    y: 71.24,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 42.73,
    y: 70.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.16,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 38.98,
    y: 71.15,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 41.5,
    y: 71.51,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.45,
    y: 72.56,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.16,
    y: 64.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.54,
    y: 64.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.47,
    y: 66.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 43.18,
    y: 67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.75,
    y: 65.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.18,
    y: 65.56,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 42.73,
    y: 64.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 38.98,
    y: 65.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 41.5,
    y: 65.83,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.45,
    y: 66.88,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-107"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.04,
    y: 40.5,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.57,
    y: 41.62,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.94,
    y: 41.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.57,
    y: 39.43,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 51.49,
    y: 39.39,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.13,
    y: 41.74,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.56,
    y: 40.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.41,
    y: 40.62,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.04,
    y: 34.81,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.57,
    y: 35.93,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.94,
    y: 35.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.88,
    y: 38.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.58,
    y: 38.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.15,
    y: 37.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.57,
    y: 33.74,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 51.49,
    y: 33.7,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.58,
    y: 37.14,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.13,
    y: 36.06,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.56,
    y: 34.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.39,
    y: 37.05,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.41,
    y: 34.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.9,
    y: 37.41,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.85,
    y: 38.46,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.57,
    y: 30.25,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.94,
    y: 30.22,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.88,
    y: 32.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.58,
    y: 32.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.15,
    y: 31.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.58,
    y: 31.46,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.13,
    y: 30.37,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.39,
    y: 31.37,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.9,
    y: 31.73,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.85,
    y: 32.78,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-104"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.04,
    y: 51.86,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.57,
    y: 52.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.94,
    y: 52.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.57,
    y: 50.8,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 51.49,
    y: 50.75,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.13,
    y: 53.11,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.56,
    y: 51.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.41,
    y: 51.99,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.04,
    y: 46.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.57,
    y: 47.3,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.94,
    y: 47.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.88,
    y: 49.78,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.58,
    y: 49.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.15,
    y: 48.63,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.57,
    y: 45.11,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 51.49,
    y: 45.07,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.58,
    y: 48.51,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.13,
    y: 47.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.56,
    y: 46.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.39,
    y: 48.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.41,
    y: 46.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.9,
    y: 48.78,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.85,
    y: 49.83,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.57,
    y: 41.62,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.94,
    y: 41.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.88,
    y: 44.1,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.58,
    y: 44.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.15,
    y: 42.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.58,
    y: 42.83,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.13,
    y: 41.74,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.39,
    y: 42.73,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.9,
    y: 43.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.85,
    y: 44.14,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-103"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.04,
    y: 63.23,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.57,
    y: 64.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.94,
    y: 64.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.57,
    y: 62.16,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 51.49,
    y: 62.12,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.13,
    y: 64.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.56,
    y: 63.35,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.41,
    y: 63.35,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.04,
    y: 57.55,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.57,
    y: 58.67,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.94,
    y: 58.63,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.88,
    y: 61.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.58,
    y: 61.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.15,
    y: 60,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.57,
    y: 56.48,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 51.49,
    y: 56.44,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.58,
    y: 59.88,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.13,
    y: 58.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.56,
    y: 57.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.39,
    y: 59.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.41,
    y: 57.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.9,
    y: 60.15,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.85,
    y: 61.19,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.57,
    y: 52.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.94,
    y: 52.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.88,
    y: 55.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.58,
    y: 55.63,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.15,
    y: 54.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.58,
    y: 54.19,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.13,
    y: 53.11,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.39,
    y: 54.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.9,
    y: 54.46,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.85,
    y: 55.51,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-106"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.04,
    y: 74.6,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.57,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.94,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.57,
    y: 73.53,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 51.49,
    y: 73.49,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.13,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.56,
    y: 74.72,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.41,
    y: 74.72,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.04,
    y: 68.91,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.57,
    y: 70.03,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.94,
    y: 70,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.88,
    y: 72.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.58,
    y: 72.69,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.15,
    y: 71.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.57,
    y: 67.85,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 51.49,
    y: 67.8,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.58,
    y: 71.24,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.13,
    y: 70.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.56,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.39,
    y: 71.15,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.41,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.9,
    y: 71.51,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.85,
    y: 72.56,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.57,
    y: 64.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.94,
    y: 64.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.88,
    y: 66.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.58,
    y: 67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.15,
    y: 65.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.58,
    y: 65.56,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.13,
    y: 64.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.39,
    y: 65.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.9,
    y: 65.83,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.85,
    y: 66.88,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-105"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.45,
    y: 40.5,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.97,
    y: 41.62,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.35,
    y: 41.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.97,
    y: 39.43,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.9,
    y: 39.39,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.53,
    y: 41.74,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 61.96,
    y: 40.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.81,
    y: 40.62,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.45,
    y: 34.81,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.97,
    y: 35.93,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.35,
    y: 35.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.28,
    y: 38.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.98,
    y: 38.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.55,
    y: 37.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.97,
    y: 33.74,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.9,
    y: 33.7,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.99,
    y: 37.14,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.53,
    y: 36.06,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 61.96,
    y: 34.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 61.79,
    y: 37.05,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.81,
    y: 34.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 64.3,
    y: 37.41,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.25,
    y: 38.46,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.97,
    y: 30.25,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.35,
    y: 30.22,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.28,
    y: 32.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.98,
    y: 32.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.55,
    y: 31.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.99,
    y: 31.46,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.53,
    y: 30.37,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 61.79,
    y: 31.37,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 64.3,
    y: 31.73,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.25,
    y: 32.78,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.45,
    y: 51.86,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.97,
    y: 52.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.35,
    y: 52.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.97,
    y: 50.8,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.9,
    y: 50.75,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.53,
    y: 53.11,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 61.96,
    y: 51.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.81,
    y: 51.99,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.45,
    y: 46.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.97,
    y: 47.3,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.35,
    y: 47.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.28,
    y: 49.78,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.98,
    y: 49.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.55,
    y: 48.63,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.97,
    y: 45.11,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.9,
    y: 45.07,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.99,
    y: 48.51,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.53,
    y: 47.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 61.96,
    y: 46.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 61.79,
    y: 48.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.81,
    y: 46.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 64.3,
    y: 48.78,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.25,
    y: 49.83,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.97,
    y: 41.62,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.35,
    y: 41.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.28,
    y: 44.1,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.98,
    y: 44.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.55,
    y: 42.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.99,
    y: 42.83,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.53,
    y: 41.74,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 61.79,
    y: 42.73,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 64.3,
    y: 43.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.25,
    y: 44.14,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.45,
    y: 63.23,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.97,
    y: 64.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.35,
    y: 64.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.97,
    y: 62.16,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.9,
    y: 62.12,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.53,
    y: 64.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 61.96,
    y: 63.35,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.81,
    y: 63.35,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.45,
    y: 57.55,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.97,
    y: 58.67,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.35,
    y: 58.63,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.28,
    y: 61.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.98,
    y: 61.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.55,
    y: 60,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.97,
    y: 56.48,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.9,
    y: 56.44,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.99,
    y: 59.88,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.53,
    y: 58.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 61.96,
    y: 57.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 61.79,
    y: 59.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.81,
    y: 57.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 64.3,
    y: 60.15,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.25,
    y: 61.19,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.97,
    y: 52.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.35,
    y: 52.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.28,
    y: 55.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.98,
    y: 55.63,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.55,
    y: 54.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.99,
    y: 54.19,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.53,
    y: 53.11,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 61.79,
    y: 54.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 64.3,
    y: 54.46,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.25,
    y: 55.51,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.45,
    y: 74.6,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.97,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.35,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.97,
    y: 73.53,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.9,
    y: 73.49,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.53,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 61.96,
    y: 74.72,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.81,
    y: 74.72,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.45,
    y: 68.91,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.97,
    y: 70.03,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.35,
    y: 70,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.28,
    y: 72.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.98,
    y: 72.69,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.55,
    y: 71.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.97,
    y: 67.85,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.9,
    y: 67.8,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.99,
    y: 71.24,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.53,
    y: 70.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 61.96,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 61.79,
    y: 71.15,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.81,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 64.3,
    y: 71.51,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.25,
    y: 72.56,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.97,
    y: 64.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.35,
    y: 64.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.28,
    y: 66.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.98,
    y: 67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.55,
    y: 65.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.99,
    y: 65.56,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.53,
    y: 64.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 61.79,
    y: 65.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 64.3,
    y: 65.83,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.25,
    y: 66.88,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 76.85,
    y: 40.5,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.37,
    y: 41.62,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.75,
    y: 41.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.37,
    y: 39.43,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.3,
    y: 39.39,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 76.94,
    y: 41.74,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.37,
    y: 40.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 82.21,
    y: 40.62,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 76.85,
    y: 34.81,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.37,
    y: 35.93,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.75,
    y: 35.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.68,
    y: 38.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.39,
    y: 38.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.95,
    y: 37.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.37,
    y: 33.74,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.3,
    y: 33.7,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.39,
    y: 37.14,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 76.94,
    y: 36.06,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.37,
    y: 34.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.19,
    y: 37.05,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 82.21,
    y: 34.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.7,
    y: 37.41,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.66,
    y: 38.46,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.37,
    y: 30.25,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.75,
    y: 30.22,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.68,
    y: 32.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.39,
    y: 32.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.95,
    y: 31.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.39,
    y: 31.46,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 76.94,
    y: 30.37,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.19,
    y: 31.37,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.7,
    y: 31.73,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.66,
    y: 32.78,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 76.85,
    y: 51.86,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.37,
    y: 52.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.75,
    y: 52.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.37,
    y: 50.8,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.3,
    y: 50.75,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 76.94,
    y: 53.11,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.37,
    y: 51.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 82.21,
    y: 51.99,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 76.85,
    y: 46.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.37,
    y: 47.3,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.75,
    y: 47.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.68,
    y: 49.78,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.39,
    y: 49.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.95,
    y: 48.63,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.37,
    y: 45.11,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.3,
    y: 45.07,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.39,
    y: 48.51,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 76.94,
    y: 47.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.37,
    y: 46.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.19,
    y: 48.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 82.21,
    y: 46.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.7,
    y: 48.78,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.66,
    y: 49.83,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.37,
    y: 41.62,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.75,
    y: 41.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.68,
    y: 44.1,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.39,
    y: 44.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.95,
    y: 42.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.39,
    y: 42.83,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 76.94,
    y: 41.74,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.19,
    y: 42.73,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.7,
    y: 43.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.66,
    y: 44.14,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 76.85,
    y: 63.23,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.37,
    y: 64.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.75,
    y: 64.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.37,
    y: 62.16,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.3,
    y: 62.12,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 76.94,
    y: 64.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.37,
    y: 63.35,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 82.21,
    y: 63.35,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 76.85,
    y: 57.55,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.37,
    y: 58.67,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.75,
    y: 58.63,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.68,
    y: 61.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.39,
    y: 61.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.95,
    y: 60,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.37,
    y: 56.48,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.3,
    y: 56.44,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.39,
    y: 59.88,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 76.94,
    y: 58.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.37,
    y: 57.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.19,
    y: 59.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 82.21,
    y: 57.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.7,
    y: 60.15,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.66,
    y: 61.19,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.37,
    y: 52.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.75,
    y: 52.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.68,
    y: 55.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.39,
    y: 55.63,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.95,
    y: 54.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.39,
    y: 54.19,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 76.94,
    y: 53.11,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.19,
    y: 54.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.7,
    y: 54.46,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.66,
    y: 55.51,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 76.85,
    y: 74.6,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.37,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.75,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.37,
    y: 73.53,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.3,
    y: 73.49,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 76.94,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.37,
    y: 74.72,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 82.21,
    y: 74.72,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 76.85,
    y: 68.91,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.37,
    y: 70.03,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.75,
    y: 70,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.68,
    y: 72.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.39,
    y: 72.69,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.95,
    y: 71.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.37,
    y: 67.85,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.3,
    y: 67.8,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.39,
    y: 71.24,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 76.94,
    y: 70.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.37,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.19,
    y: 71.15,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 82.21,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.7,
    y: 71.51,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.66,
    y: 72.56,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.37,
    y: 64.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.75,
    y: 64.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.68,
    y: 66.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.39,
    y: 67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.95,
    y: 65.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.39,
    y: 65.56,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 76.94,
    y: 64.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.19,
    y: 65.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.7,
    y: 65.83,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.66,
    y: 66.88,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.25,
    y: 40.5,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 91.77,
    y: 41.62,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.15,
    y: 41.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 91.77,
    y: 39.43,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.7,
    y: 39.39,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.34,
    y: 41.74,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.77,
    y: 40.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.61,
    y: 40.62,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.25,
    y: 34.81,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 91.77,
    y: 35.93,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.15,
    y: 35.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.08,
    y: 38.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.79,
    y: 38.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.36,
    y: 37.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 91.77,
    y: 33.74,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.7,
    y: 33.7,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.79,
    y: 37.14,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.34,
    y: 36.06,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.77,
    y: 34.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.59,
    y: 37.05,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.61,
    y: 34.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 87.11,
    y: 37.41,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.06,
    y: 38.46,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 91.77,
    y: 30.25,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.15,
    y: 30.22,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.08,
    y: 32.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.79,
    y: 32.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.36,
    y: 31.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.79,
    y: 31.46,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.34,
    y: 30.37,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.59,
    y: 31.37,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 87.11,
    y: 31.73,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.06,
    y: 32.78,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.25,
    y: 51.86,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 91.77,
    y: 52.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.15,
    y: 52.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 91.77,
    y: 50.8,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.7,
    y: 50.75,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.34,
    y: 53.11,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.77,
    y: 51.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.61,
    y: 51.99,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.25,
    y: 46.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 91.77,
    y: 47.3,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.15,
    y: 47.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.08,
    y: 49.78,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.79,
    y: 49.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.36,
    y: 48.63,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 91.77,
    y: 45.11,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.7,
    y: 45.07,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.79,
    y: 48.51,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.34,
    y: 47.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.77,
    y: 46.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.59,
    y: 48.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.61,
    y: 46.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 87.11,
    y: 48.78,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.06,
    y: 49.83,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 91.77,
    y: 41.62,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.15,
    y: 41.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.08,
    y: 44.1,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.79,
    y: 44.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.36,
    y: 42.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.79,
    y: 42.83,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.34,
    y: 41.74,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.59,
    y: 42.73,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 87.11,
    y: 43.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.06,
    y: 44.14,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.25,
    y: 63.23,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 91.77,
    y: 64.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.15,
    y: 64.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 91.77,
    y: 62.16,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.7,
    y: 62.12,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.34,
    y: 64.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.77,
    y: 63.35,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.61,
    y: 63.35,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.25,
    y: 57.55,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 91.77,
    y: 58.67,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.15,
    y: 58.63,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.08,
    y: 61.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.79,
    y: 61.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.36,
    y: 60,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 91.77,
    y: 56.48,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.7,
    y: 56.44,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.79,
    y: 59.88,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.34,
    y: 58.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.77,
    y: 57.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.59,
    y: 59.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.61,
    y: 57.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 87.11,
    y: 60.15,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.06,
    y: 61.19,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 91.77,
    y: 52.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.15,
    y: 52.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.08,
    y: 55.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.79,
    y: 55.63,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.36,
    y: 54.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.79,
    y: 54.19,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.34,
    y: 53.11,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.59,
    y: 54.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 87.11,
    y: 54.46,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.06,
    y: 55.51,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.25,
    y: 74.6,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 91.77,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.15,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 91.77,
    y: 73.53,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.7,
    y: 73.49,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.34,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.77,
    y: 74.72,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.61,
    y: 74.72,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.25,
    y: 68.91,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 91.77,
    y: 70.03,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.15,
    y: 70,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.08,
    y: 72.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.79,
    y: 72.69,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.36,
    y: 71.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 91.77,
    y: 67.85,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.7,
    y: 67.8,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.79,
    y: 71.24,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.34,
    y: 70.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.77,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.59,
    y: 71.15,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.61,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 87.11,
    y: 71.51,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.06,
    y: 72.56,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 91.77,
    y: 64.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.15,
    y: 64.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.08,
    y: 66.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.79,
    y: 67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.36,
    y: 65.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.79,
    y: 65.56,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.34,
    y: 64.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.59,
    y: 65.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 87.11,
    y: 65.83,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.06,
    y: 66.88,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 99.65,
    y: 40.5,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.18,
    y: 41.62,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.55,
    y: 41.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.18,
    y: 39.43,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 97.1,
    y: 39.39,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 99.74,
    y: 41.74,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.17,
    y: 40.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 105.02,
    y: 40.62,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 99.65,
    y: 34.81,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.18,
    y: 35.93,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.55,
    y: 35.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.49,
    y: 38.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.19,
    y: 38.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.76,
    y: 37.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.18,
    y: 33.74,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 97.1,
    y: 33.7,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.19,
    y: 37.14,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 99.74,
    y: 36.06,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.17,
    y: 34.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96,
    y: 37.05,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 105.02,
    y: 34.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.51,
    y: 37.41,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.46,
    y: 38.46,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.18,
    y: 30.25,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.55,
    y: 30.22,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.49,
    y: 32.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.19,
    y: 32.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.76,
    y: 31.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.19,
    y: 31.46,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 99.74,
    y: 30.37,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96,
    y: 31.37,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.51,
    y: 31.73,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.46,
    y: 32.78,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-64"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 99.65,
    y: 51.86,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.18,
    y: 52.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.55,
    y: 52.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.18,
    y: 50.8,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 97.1,
    y: 50.75,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 99.74,
    y: 53.11,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.17,
    y: 51.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 105.02,
    y: 51.99,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 99.65,
    y: 46.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.18,
    y: 47.3,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.55,
    y: 47.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.49,
    y: 49.78,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.19,
    y: 49.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.76,
    y: 48.63,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.18,
    y: 45.11,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 97.1,
    y: 45.07,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.19,
    y: 48.51,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 99.74,
    y: 47.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.17,
    y: 46.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96,
    y: 48.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 105.02,
    y: 46.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.51,
    y: 48.78,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.46,
    y: 49.83,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.18,
    y: 41.62,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.55,
    y: 41.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.49,
    y: 44.1,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.19,
    y: 44.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.76,
    y: 42.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.19,
    y: 42.83,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 99.74,
    y: 41.74,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96,
    y: 42.73,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.51,
    y: 43.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.46,
    y: 44.14,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 99.65,
    y: 63.23,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.18,
    y: 64.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.55,
    y: 64.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.18,
    y: 62.16,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 97.1,
    y: 62.12,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 99.74,
    y: 64.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.17,
    y: 63.35,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 105.02,
    y: 63.35,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 99.65,
    y: 57.55,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.18,
    y: 58.67,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.55,
    y: 58.63,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.49,
    y: 61.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.19,
    y: 61.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.76,
    y: 60,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.18,
    y: 56.48,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 97.1,
    y: 56.44,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.19,
    y: 59.88,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 99.74,
    y: 58.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.17,
    y: 57.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96,
    y: 59.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 105.02,
    y: 57.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.51,
    y: 60.15,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.46,
    y: 61.19,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.18,
    y: 52.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.55,
    y: 52.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.49,
    y: 55.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.19,
    y: 55.63,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.76,
    y: 54.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.19,
    y: 54.19,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 99.74,
    y: 53.11,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96,
    y: 54.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.51,
    y: 54.46,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.46,
    y: 55.51,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-66"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 99.65,
    y: 74.6,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.18,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.55,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.18,
    y: 73.53,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 97.1,
    y: 73.49,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 99.74,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.17,
    y: 74.72,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 105.02,
    y: 74.72,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 99.65,
    y: 68.91,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.18,
    y: 70.03,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.55,
    y: 70,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.49,
    y: 72.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.19,
    y: 72.69,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.76,
    y: 71.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.18,
    y: 67.85,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 97.1,
    y: 67.8,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.19,
    y: 71.24,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 99.74,
    y: 70.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.17,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96,
    y: 71.15,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 105.02,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.51,
    y: 71.51,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.46,
    y: 72.56,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.18,
    y: 64.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.55,
    y: 64.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.49,
    y: 66.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.19,
    y: 67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.76,
    y: 65.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.19,
    y: 65.56,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 99.74,
    y: 64.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96,
    y: 65.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.51,
    y: 65.83,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.46,
    y: 66.88,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.06,
    y: 40.5,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.58,
    y: 41.62,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.96,
    y: 41.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.58,
    y: 39.43,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.51,
    y: 39.39,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.14,
    y: 41.74,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.57,
    y: 40.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.42,
    y: 40.62,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.06,
    y: 34.81,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.58,
    y: 35.93,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.96,
    y: 35.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.89,
    y: 38.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.59,
    y: 38.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.16,
    y: 37.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.58,
    y: 33.74,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.51,
    y: 33.7,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.6,
    y: 37.14,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.14,
    y: 36.06,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.57,
    y: 34.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.4,
    y: 37.05,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.42,
    y: 34.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.91,
    y: 37.41,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.86,
    y: 38.46,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.58,
    y: 30.25,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.96,
    y: 30.22,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.89,
    y: 32.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.59,
    y: 32.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.16,
    y: 31.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.6,
    y: 31.46,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.14,
    y: 30.37,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.4,
    y: 31.37,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.91,
    y: 31.73,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.86,
    y: 32.78,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.06,
    y: 51.86,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.58,
    y: 52.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.96,
    y: 52.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.58,
    y: 50.8,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.51,
    y: 50.75,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.14,
    y: 53.11,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.57,
    y: 51.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.42,
    y: 51.99,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.06,
    y: 46.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.58,
    y: 47.3,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.96,
    y: 47.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.89,
    y: 49.78,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.59,
    y: 49.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.16,
    y: 48.63,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.58,
    y: 45.11,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.51,
    y: 45.07,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.6,
    y: 48.51,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.14,
    y: 47.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.57,
    y: 46.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.4,
    y: 48.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.42,
    y: 46.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.91,
    y: 48.78,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.86,
    y: 49.83,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.58,
    y: 41.62,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.96,
    y: 41.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.89,
    y: 44.1,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.59,
    y: 44.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.16,
    y: 42.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.6,
    y: 42.83,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.14,
    y: 41.74,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.4,
    y: 42.73,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.91,
    y: 43.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.86,
    y: 44.14,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.06,
    y: 63.23,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.58,
    y: 64.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.96,
    y: 64.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.58,
    y: 62.16,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.51,
    y: 62.12,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.14,
    y: 64.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.57,
    y: 63.35,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.42,
    y: 63.35,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.06,
    y: 57.55,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.58,
    y: 58.67,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.96,
    y: 58.63,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.89,
    y: 61.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.59,
    y: 61.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.16,
    y: 60,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.58,
    y: 56.48,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.51,
    y: 56.44,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.6,
    y: 59.88,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.14,
    y: 58.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.57,
    y: 57.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.4,
    y: 59.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.42,
    y: 57.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.91,
    y: 60.15,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.86,
    y: 61.19,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.58,
    y: 52.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.96,
    y: 52.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.89,
    y: 55.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.59,
    y: 55.63,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.16,
    y: 54.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.6,
    y: 54.19,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.14,
    y: 53.11,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.4,
    y: 54.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.91,
    y: 54.46,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.86,
    y: 55.51,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.06,
    y: 74.6,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.58,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.96,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.58,
    y: 73.53,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.51,
    y: 73.49,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.14,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.57,
    y: 74.72,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.42,
    y: 74.72,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.06,
    y: 68.91,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.58,
    y: 70.03,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.96,
    y: 70,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.89,
    y: 72.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.59,
    y: 72.69,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.16,
    y: 71.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.58,
    y: 67.85,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.51,
    y: 67.8,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.6,
    y: 71.24,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.14,
    y: 70.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.57,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.4,
    y: 71.15,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.42,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.91,
    y: 71.51,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.86,
    y: 72.56,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.58,
    y: 64.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.96,
    y: 64.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.89,
    y: 66.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.59,
    y: 67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.16,
    y: 65.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.6,
    y: 65.56,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.14,
    y: 64.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.4,
    y: 65.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.91,
    y: 65.83,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.86,
    y: 66.88,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.46,
    y: 40.5,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.98,
    y: 41.62,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.36,
    y: 41.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.98,
    y: 39.43,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.91,
    y: 39.39,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.55,
    y: 41.74,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.98,
    y: 40.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.82,
    y: 40.62,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.46,
    y: 34.81,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.98,
    y: 35.93,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.36,
    y: 35.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.29,
    y: 38.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 123,
    y: 38.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.56,
    y: 37.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.98,
    y: 33.74,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.91,
    y: 33.7,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124,
    y: 37.14,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.55,
    y: 36.06,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.98,
    y: 34.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.8,
    y: 37.05,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.82,
    y: 34.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 121.31,
    y: 37.41,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 126.27,
    y: 38.46,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.98,
    y: 30.25,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.36,
    y: 30.22,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.29,
    y: 32.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 123,
    y: 32.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.56,
    y: 31.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124,
    y: 31.46,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.55,
    y: 30.37,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.8,
    y: 31.37,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 121.31,
    y: 31.73,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 126.27,
    y: 32.78,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.46,
    y: 51.86,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.98,
    y: 52.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.36,
    y: 52.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.98,
    y: 50.8,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.91,
    y: 50.75,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.55,
    y: 53.11,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.98,
    y: 51.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.82,
    y: 51.99,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.46,
    y: 46.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.98,
    y: 47.3,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.36,
    y: 47.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.29,
    y: 49.78,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 123,
    y: 49.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.56,
    y: 48.63,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.98,
    y: 45.11,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.91,
    y: 45.07,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124,
    y: 48.51,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.55,
    y: 47.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.98,
    y: 46.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.8,
    y: 48.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.82,
    y: 46.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 121.31,
    y: 48.78,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 126.27,
    y: 49.83,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.98,
    y: 41.62,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.36,
    y: 41.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.29,
    y: 44.1,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 123,
    y: 44.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.56,
    y: 42.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124,
    y: 42.83,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.55,
    y: 41.74,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.8,
    y: 42.73,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 121.31,
    y: 43.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 126.27,
    y: 44.14,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.46,
    y: 63.23,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.98,
    y: 64.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.36,
    y: 64.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.98,
    y: 62.16,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.91,
    y: 62.12,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.55,
    y: 64.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.98,
    y: 63.35,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.82,
    y: 63.35,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.46,
    y: 57.55,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.98,
    y: 58.67,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.36,
    y: 58.63,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.29,
    y: 61.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 123,
    y: 61.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.56,
    y: 60,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.98,
    y: 56.48,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.91,
    y: 56.44,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124,
    y: 59.88,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.55,
    y: 58.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.98,
    y: 57.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.8,
    y: 59.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.82,
    y: 57.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 121.31,
    y: 60.15,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 126.27,
    y: 61.19,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.98,
    y: 52.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.36,
    y: 52.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.29,
    y: 55.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 123,
    y: 55.63,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.56,
    y: 54.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124,
    y: 54.19,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.55,
    y: 53.11,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.8,
    y: 54.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 121.31,
    y: 54.46,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 126.27,
    y: 55.51,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.46,
    y: 74.6,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.98,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.36,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.98,
    y: 73.53,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.91,
    y: 73.49,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.55,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.98,
    y: 74.72,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.82,
    y: 74.72,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.46,
    y: 68.91,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.98,
    y: 70.03,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.36,
    y: 70,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.29,
    y: 72.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 123,
    y: 72.69,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.56,
    y: 71.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.98,
    y: 67.85,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.91,
    y: 67.8,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124,
    y: 71.24,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.55,
    y: 70.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.98,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.8,
    y: 71.15,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.82,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 121.31,
    y: 71.51,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 126.27,
    y: 72.56,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.98,
    y: 64.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.36,
    y: 64.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.29,
    y: 66.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 123,
    y: 67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.56,
    y: 65.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124,
    y: 65.56,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.55,
    y: 64.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.8,
    y: 65.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 121.31,
    y: 65.83,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 126.27,
    y: 66.88,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.86,
    y: 40.5,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.38,
    y: 41.62,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.76,
    y: 41.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.38,
    y: 39.43,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.31,
    y: 39.39,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.95,
    y: 41.74,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.38,
    y: 40.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 139.22,
    y: 40.62,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.86,
    y: 34.81,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.38,
    y: 35.93,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.76,
    y: 35.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.7,
    y: 38.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.4,
    y: 38.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.97,
    y: 37.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.38,
    y: 33.74,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.31,
    y: 33.7,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.4,
    y: 37.14,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.95,
    y: 36.06,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.38,
    y: 34.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.2,
    y: 37.05,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 139.22,
    y: 34.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.72,
    y: 37.41,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.67,
    y: 38.46,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.38,
    y: 30.25,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.76,
    y: 30.22,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.7,
    y: 32.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.4,
    y: 32.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.97,
    y: 31.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.4,
    y: 31.46,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.95,
    y: 30.37,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.2,
    y: 31.37,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.72,
    y: 31.73,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.67,
    y: 32.78,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.86,
    y: 51.86,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.38,
    y: 52.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.76,
    y: 52.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.38,
    y: 50.8,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.31,
    y: 50.75,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.95,
    y: 53.11,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.38,
    y: 51.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 139.22,
    y: 51.99,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.86,
    y: 46.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.38,
    y: 47.3,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.76,
    y: 47.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.7,
    y: 49.78,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.4,
    y: 49.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.97,
    y: 48.63,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.38,
    y: 45.11,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.31,
    y: 45.07,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.4,
    y: 48.51,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.95,
    y: 47.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.38,
    y: 46.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.2,
    y: 48.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 139.22,
    y: 46.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.72,
    y: 48.78,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.67,
    y: 49.83,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.38,
    y: 41.62,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.76,
    y: 41.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.7,
    y: 44.1,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.4,
    y: 44.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.97,
    y: 42.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.4,
    y: 42.83,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.95,
    y: 41.74,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.2,
    y: 42.73,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.72,
    y: 43.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.67,
    y: 44.14,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.86,
    y: 63.23,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.38,
    y: 64.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.76,
    y: 64.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.38,
    y: 62.16,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.31,
    y: 62.12,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.95,
    y: 64.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.38,
    y: 63.35,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 139.22,
    y: 63.35,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.86,
    y: 57.55,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.38,
    y: 58.67,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.76,
    y: 58.63,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.7,
    y: 61.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.4,
    y: 61.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.97,
    y: 60,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.38,
    y: 56.48,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.31,
    y: 56.44,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.4,
    y: 59.88,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.95,
    y: 58.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.38,
    y: 57.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.2,
    y: 59.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 139.22,
    y: 57.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.72,
    y: 60.15,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.67,
    y: 61.19,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.38,
    y: 52.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.76,
    y: 52.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.7,
    y: 55.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.4,
    y: 55.63,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.97,
    y: 54.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.4,
    y: 54.19,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.95,
    y: 53.11,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.2,
    y: 54.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.72,
    y: 54.46,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.67,
    y: 55.51,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.86,
    y: 74.6,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.38,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.76,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.38,
    y: 73.53,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.31,
    y: 73.49,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.95,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.38,
    y: 74.72,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 139.22,
    y: 74.72,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.86,
    y: 68.91,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.38,
    y: 70.03,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.76,
    y: 70,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.7,
    y: 72.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.4,
    y: 72.69,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.97,
    y: 71.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.38,
    y: 67.85,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.31,
    y: 67.8,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.4,
    y: 71.24,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.95,
    y: 70.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.38,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.2,
    y: 71.15,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 139.22,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.72,
    y: 71.51,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.67,
    y: 72.56,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.38,
    y: 64.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.76,
    y: 64.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.7,
    y: 66.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.4,
    y: 67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.97,
    y: 65.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.4,
    y: 65.56,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.95,
    y: 64.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.2,
    y: 65.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.72,
    y: 65.83,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.67,
    y: 66.88,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.26,
    y: 40.5,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 148.79,
    y: 41.62,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.16,
    y: 41.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 148.79,
    y: 39.43,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.71,
    y: 39.39,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.35,
    y: 41.74,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.78,
    y: 40.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.63,
    y: 40.62,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.26,
    y: 34.81,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 148.79,
    y: 35.93,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.16,
    y: 35.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.1,
    y: 38.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.8,
    y: 38.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.37,
    y: 37.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 148.79,
    y: 33.74,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.71,
    y: 33.7,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.8,
    y: 37.14,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.35,
    y: 36.06,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.78,
    y: 34.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.61,
    y: 37.05,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.63,
    y: 34.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 144.12,
    y: 37.41,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 149.07,
    y: 38.46,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 148.79,
    y: 30.25,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.16,
    y: 30.22,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.1,
    y: 32.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.8,
    y: 32.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.37,
    y: 31.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.8,
    y: 31.46,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.35,
    y: 30.37,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.61,
    y: 31.37,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 144.12,
    y: 31.73,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 149.07,
    y: 32.78,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.26,
    y: 51.86,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 148.79,
    y: 52.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.16,
    y: 52.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 148.79,
    y: 50.8,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.71,
    y: 50.75,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.35,
    y: 53.11,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.78,
    y: 51.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.63,
    y: 51.99,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.26,
    y: 46.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 148.79,
    y: 47.3,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.16,
    y: 47.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.1,
    y: 49.78,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.8,
    y: 49.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.37,
    y: 48.63,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 148.79,
    y: 45.11,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.71,
    y: 45.07,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.8,
    y: 48.51,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.35,
    y: 47.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.78,
    y: 46.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.61,
    y: 48.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.63,
    y: 46.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 144.12,
    y: 48.78,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 149.07,
    y: 49.83,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 148.79,
    y: 41.62,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.16,
    y: 41.58,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.1,
    y: 44.1,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.8,
    y: 44.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.37,
    y: 42.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.8,
    y: 42.83,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.35,
    y: 41.74,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.61,
    y: 42.73,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 144.12,
    y: 43.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 149.07,
    y: 44.14,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.26,
    y: 63.23,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 148.79,
    y: 64.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.16,
    y: 64.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 148.79,
    y: 62.16,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.71,
    y: 62.12,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.35,
    y: 64.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.78,
    y: 63.35,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.63,
    y: 63.35,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.26,
    y: 57.55,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 148.79,
    y: 58.67,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.16,
    y: 58.63,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.1,
    y: 61.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.8,
    y: 61.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.37,
    y: 60,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 148.79,
    y: 56.48,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.71,
    y: 56.44,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.8,
    y: 59.88,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.35,
    y: 58.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.78,
    y: 57.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.61,
    y: 59.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.63,
    y: 57.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 144.12,
    y: 60.15,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 149.07,
    y: 61.19,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 148.79,
    y: 52.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.16,
    y: 52.95,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.1,
    y: 55.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.8,
    y: 55.63,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.37,
    y: 54.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.8,
    y: 54.19,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.35,
    y: 53.11,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.61,
    y: 54.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 144.12,
    y: 54.46,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 149.07,
    y: 55.51,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-75"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.26,
    y: 74.6,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 148.79,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.16,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 148.79,
    y: 73.53,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.71,
    y: 73.49,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.35,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.78,
    y: 74.72,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.63,
    y: 74.72,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.26,
    y: 68.91,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 148.79,
    y: 70.03,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.16,
    y: 70,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.1,
    y: 72.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.8,
    y: 72.69,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.37,
    y: 71.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 148.79,
    y: 67.85,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.71,
    y: 67.8,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.8,
    y: 71.24,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.35,
    y: 70.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.78,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.61,
    y: 71.15,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.63,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 144.12,
    y: 71.51,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 149.07,
    y: 72.56,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 148.79,
    y: 64.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.16,
    y: 64.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.1,
    y: 66.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.8,
    y: 67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.37,
    y: 65.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.8,
    y: 65.56,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.35,
    y: 64.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.61,
    y: 65.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 144.12,
    y: 65.83,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 149.07,
    y: 66.88,
    width: 1.98,
    height: 0.72
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M95.57,44.07h4.63c2.39,0,4.33,1.94,4.33,4.33v21.64h-13.28v-21.64c0-2.39,1.94-4.33,4.33-4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M90.89,47.66c0-2.15,1.97-3.9,4.38-3.9h5.22c2.42,0,4.38,1.75,4.38,3.9v22.69h-13.98v-22.69ZM104.17,47.66c0-1.81-1.65-3.28-3.68-3.28h-5.22c-2.03,0-3.68,1.47-3.68,3.28v22.07h12.58v-22.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 91.24,
    y: 52,
    width: 13.28,
    height: 0.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 97.53,
    y: 52.5,
    width: 0.7,
    height: 17.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 91.24,
    y: 57.33,
    width: 13.28,
    height: 0.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 91.24,
    y: 63.61,
    width: 13.28,
    height: 0.62
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M120.16,44.07h4.63c2.39,0,4.33,1.94,4.33,4.33v21.64h-13.28v-21.64c0-2.39,1.94-4.33,4.33-4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M115.48,47.66c0-2.15,1.97-3.9,4.38-3.9h5.22c2.42,0,4.38,1.75,4.38,3.9v22.69h-13.98v-22.69ZM128.76,47.66c0-1.81-1.65-3.28-3.68-3.28h-5.22c-2.03,0-3.68,1.47-3.68,3.28v22.07h12.58v-22.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 115.83,
    y: 52,
    width: 13.28,
    height: 0.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 122.12,
    y: 52.5,
    width: 0.7,
    height: 17.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 115.83,
    y: 57.33,
    width: 13.28,
    height: 0.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 115.83,
    y: 63.61,
    width: 13.28,
    height: 0.62
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 39.71,
    y: 72.59,
    width: 108.27,
    height: 5.73
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-69"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 42.64,
    y: 74.6,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.16,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.54,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.16,
    y: 73.53,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.09,
    y: 73.49,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 42.73,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.16,
    y: 74.72,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48,
    y: 74.72,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 42.64,
    y: 68.91,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.16,
    y: 70.03,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.54,
    y: 70,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.47,
    y: 72.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 43.18,
    y: 72.69,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.75,
    y: 71.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.16,
    y: 67.85,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.09,
    y: 67.8,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.18,
    y: 71.24,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 42.73,
    y: 70.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.16,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 38.98,
    y: 71.15,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 41.5,
    y: 71.51,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.45,
    y: 72.56,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.16,
    y: 64.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.54,
    y: 64.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.47,
    y: 66.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 43.18,
    y: 67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.75,
    y: 65.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.18,
    y: 65.56,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 42.73,
    y: 64.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 38.98,
    y: 65.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 41.5,
    y: 65.83,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.45,
    y: 66.88,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-71"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 42.64,
    y: 85.96,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.16,
    y: 87.08,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.54,
    y: 87.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.16,
    y: 84.9,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.09,
    y: 84.85,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 42.73,
    y: 87.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.16,
    y: 86.09,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48,
    y: 86.09,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 42.64,
    y: 80.28,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.16,
    y: 81.4,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.54,
    y: 81.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.47,
    y: 83.89,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 43.18,
    y: 84.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.75,
    y: 82.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.16,
    y: 79.21,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.09,
    y: 79.17,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.18,
    y: 82.61,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 42.73,
    y: 81.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.16,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 38.98,
    y: 82.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 41.5,
    y: 82.88,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.45,
    y: 83.93,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.16,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.54,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.47,
    y: 78.2,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 43.18,
    y: 78.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.75,
    y: 77.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.18,
    y: 76.93,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 42.73,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 38.98,
    y: 76.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 41.5,
    y: 77.2,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.45,
    y: 78.24,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-72"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.04,
    y: 74.6,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.57,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.94,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.57,
    y: 73.53,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 51.49,
    y: 73.49,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.13,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.56,
    y: 74.72,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.41,
    y: 74.72,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.04,
    y: 68.91,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.57,
    y: 70.03,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.94,
    y: 70,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.88,
    y: 72.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.58,
    y: 72.69,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.15,
    y: 71.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.57,
    y: 67.85,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 51.49,
    y: 67.8,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.58,
    y: 71.24,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.13,
    y: 70.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.56,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.39,
    y: 71.15,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.41,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.9,
    y: 71.51,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.85,
    y: 72.56,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.57,
    y: 64.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.94,
    y: 64.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.88,
    y: 66.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.58,
    y: 67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.15,
    y: 65.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.58,
    y: 65.56,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.13,
    y: 64.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.39,
    y: 65.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.9,
    y: 65.83,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.85,
    y: 66.88,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-73"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.04,
    y: 85.96,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.57,
    y: 87.08,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.94,
    y: 87.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.57,
    y: 84.9,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 51.49,
    y: 84.85,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.13,
    y: 87.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.56,
    y: 86.09,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.41,
    y: 86.09,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.04,
    y: 80.28,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.57,
    y: 81.4,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.94,
    y: 81.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.88,
    y: 83.89,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.58,
    y: 84.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.15,
    y: 82.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.57,
    y: 79.21,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 51.49,
    y: 79.17,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.58,
    y: 82.61,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.13,
    y: 81.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.56,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.39,
    y: 82.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.41,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.9,
    y: 82.88,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.85,
    y: 83.93,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.57,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.94,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.88,
    y: 78.2,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.58,
    y: 78.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.15,
    y: 77.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.58,
    y: 76.93,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.13,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.39,
    y: 76.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.9,
    y: 77.2,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.85,
    y: 78.24,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-76"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.45,
    y: 74.6,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.97,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.35,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.97,
    y: 73.53,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.9,
    y: 73.49,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.53,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 61.96,
    y: 74.72,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.81,
    y: 74.72,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.45,
    y: 68.91,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.97,
    y: 70.03,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.35,
    y: 70,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.28,
    y: 72.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.98,
    y: 72.69,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.55,
    y: 71.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.97,
    y: 67.85,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.9,
    y: 67.8,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.99,
    y: 71.24,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.53,
    y: 70.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 61.96,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 61.79,
    y: 71.15,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.81,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 64.3,
    y: 71.51,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.25,
    y: 72.56,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.97,
    y: 64.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.35,
    y: 64.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.28,
    y: 66.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.98,
    y: 67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.55,
    y: 65.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.99,
    y: 65.56,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.53,
    y: 64.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 61.79,
    y: 65.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 64.3,
    y: 65.83,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.25,
    y: 66.88,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-77"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.45,
    y: 85.96,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.97,
    y: 87.08,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.35,
    y: 87.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.97,
    y: 84.9,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.9,
    y: 84.85,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.53,
    y: 87.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 61.96,
    y: 86.09,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.81,
    y: 86.09,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.45,
    y: 80.28,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.97,
    y: 81.4,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.35,
    y: 81.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.28,
    y: 83.89,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.98,
    y: 84.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.55,
    y: 82.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.97,
    y: 79.21,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.9,
    y: 79.17,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.99,
    y: 82.61,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.53,
    y: 81.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 61.96,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 61.79,
    y: 82.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.81,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 64.3,
    y: 82.88,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.25,
    y: 83.93,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.97,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.35,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.28,
    y: 78.2,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.98,
    y: 78.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.55,
    y: 77.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.99,
    y: 76.93,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 65.53,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 61.79,
    y: 76.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 64.3,
    y: 77.2,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.25,
    y: 78.24,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-78"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 76.85,
    y: 74.6,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.37,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.75,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.37,
    y: 73.53,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.3,
    y: 73.49,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 76.94,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.37,
    y: 74.72,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 82.21,
    y: 74.72,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 76.85,
    y: 68.91,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.37,
    y: 70.03,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.75,
    y: 70,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.68,
    y: 72.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.39,
    y: 72.69,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.95,
    y: 71.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.37,
    y: 67.85,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.3,
    y: 67.8,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.39,
    y: 71.24,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 76.94,
    y: 70.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.37,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.19,
    y: 71.15,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 82.21,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.7,
    y: 71.51,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.66,
    y: 72.56,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.37,
    y: 64.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.75,
    y: 64.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.68,
    y: 66.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.39,
    y: 67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.95,
    y: 65.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.39,
    y: 65.56,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 76.94,
    y: 64.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.19,
    y: 65.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.7,
    y: 65.83,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.66,
    y: 66.88,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 76.85,
    y: 85.96,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.37,
    y: 87.08,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.75,
    y: 87.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.37,
    y: 84.9,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.3,
    y: 84.85,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 76.94,
    y: 87.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.37,
    y: 86.09,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 82.21,
    y: 86.09,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 76.85,
    y: 80.28,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.37,
    y: 81.4,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.75,
    y: 81.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.68,
    y: 83.89,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.39,
    y: 84.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.95,
    y: 82.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.37,
    y: 79.21,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.3,
    y: 79.17,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.39,
    y: 82.61,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 76.94,
    y: 81.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.37,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.19,
    y: 82.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 82.21,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.7,
    y: 82.88,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.66,
    y: 83.93,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.37,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.75,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.68,
    y: 78.2,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.39,
    y: 78.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.95,
    y: 77.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.39,
    y: 76.93,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 76.94,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.19,
    y: 76.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.7,
    y: 77.2,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.66,
    y: 78.24,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.25,
    y: 74.6,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 91.77,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.15,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 91.77,
    y: 73.53,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.7,
    y: 73.49,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.34,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.77,
    y: 74.72,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.61,
    y: 74.72,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.25,
    y: 68.91,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 91.77,
    y: 70.03,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.15,
    y: 70,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.08,
    y: 72.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.79,
    y: 72.69,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.36,
    y: 71.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 91.77,
    y: 67.85,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.7,
    y: 67.8,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.79,
    y: 71.24,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.34,
    y: 70.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.77,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.59,
    y: 71.15,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.61,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 87.11,
    y: 71.51,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.06,
    y: 72.56,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 91.77,
    y: 64.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.15,
    y: 64.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.08,
    y: 66.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.79,
    y: 67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.36,
    y: 65.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.79,
    y: 65.56,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.34,
    y: 64.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.59,
    y: 65.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 87.11,
    y: 65.83,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.06,
    y: 66.88,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.25,
    y: 85.96,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 91.77,
    y: 87.08,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.15,
    y: 87.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 91.77,
    y: 84.9,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.7,
    y: 84.85,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.34,
    y: 87.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.77,
    y: 86.09,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.61,
    y: 86.09,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.25,
    y: 80.28,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 91.77,
    y: 81.4,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.15,
    y: 81.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.08,
    y: 83.89,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.79,
    y: 84.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.36,
    y: 82.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 91.77,
    y: 79.21,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.7,
    y: 79.17,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.79,
    y: 82.61,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.34,
    y: 81.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.77,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.59,
    y: 82.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.61,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 87.11,
    y: 82.88,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.06,
    y: 83.93,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 91.77,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.15,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.08,
    y: 78.2,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.79,
    y: 78.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.36,
    y: 77.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.79,
    y: 76.93,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.34,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.59,
    y: 76.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 87.11,
    y: 77.2,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.06,
    y: 78.24,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 99.65,
    y: 74.6,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.18,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.55,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.18,
    y: 73.53,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 97.1,
    y: 73.49,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 99.74,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.17,
    y: 74.72,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 105.02,
    y: 74.72,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 99.65,
    y: 68.91,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.18,
    y: 70.03,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.55,
    y: 70,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.49,
    y: 72.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.19,
    y: 72.69,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.76,
    y: 71.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.18,
    y: 67.85,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 97.1,
    y: 67.8,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.19,
    y: 71.24,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 99.74,
    y: 70.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.17,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96,
    y: 71.15,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 105.02,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.51,
    y: 71.51,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.46,
    y: 72.56,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.18,
    y: 64.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.55,
    y: 64.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.49,
    y: 66.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.19,
    y: 67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.76,
    y: 65.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.19,
    y: 65.56,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 99.74,
    y: 64.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96,
    y: 65.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.51,
    y: 65.83,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.46,
    y: 66.88,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 99.65,
    y: 85.96,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.18,
    y: 87.08,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.55,
    y: 87.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.18,
    y: 84.9,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 97.1,
    y: 84.85,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 99.74,
    y: 87.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.17,
    y: 86.09,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 105.02,
    y: 86.09,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 99.65,
    y: 80.28,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.18,
    y: 81.4,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.55,
    y: 81.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.49,
    y: 83.89,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.19,
    y: 84.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.76,
    y: 82.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.18,
    y: 79.21,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 97.1,
    y: 79.17,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.19,
    y: 82.61,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 99.74,
    y: 81.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.17,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96,
    y: 82.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 105.02,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.51,
    y: 82.88,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.46,
    y: 83.93,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.18,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.55,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.49,
    y: 78.2,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.19,
    y: 78.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.76,
    y: 77.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.19,
    y: 76.93,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 99.74,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96,
    y: 76.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.51,
    y: 77.2,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 103.46,
    y: 78.24,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.06,
    y: 74.6,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.58,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.96,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.58,
    y: 73.53,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.51,
    y: 73.49,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.14,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.57,
    y: 74.72,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.42,
    y: 74.72,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.06,
    y: 68.91,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.58,
    y: 70.03,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.96,
    y: 70,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.89,
    y: 72.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.59,
    y: 72.69,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.16,
    y: 71.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.58,
    y: 67.85,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.51,
    y: 67.8,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.6,
    y: 71.24,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.14,
    y: 70.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.57,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.4,
    y: 71.15,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.42,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.91,
    y: 71.51,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.86,
    y: 72.56,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.58,
    y: 64.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.96,
    y: 64.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.89,
    y: 66.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.59,
    y: 67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.16,
    y: 65.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.6,
    y: 65.56,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.14,
    y: 64.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.4,
    y: 65.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.91,
    y: 65.83,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.86,
    y: 66.88,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.06,
    y: 85.96,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.58,
    y: 87.08,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.96,
    y: 87.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.58,
    y: 84.9,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.51,
    y: 84.85,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.14,
    y: 87.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.57,
    y: 86.09,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.42,
    y: 86.09,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.06,
    y: 80.28,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.58,
    y: 81.4,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.96,
    y: 81.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.89,
    y: 83.89,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.59,
    y: 84.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.16,
    y: 82.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.58,
    y: 79.21,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.51,
    y: 79.17,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.6,
    y: 82.61,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.14,
    y: 81.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.57,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.4,
    y: 82.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.42,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.91,
    y: 82.88,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.86,
    y: 83.93,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.58,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.96,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.89,
    y: 78.2,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.59,
    y: 78.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.16,
    y: 77.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.6,
    y: 76.93,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.14,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.4,
    y: 76.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.91,
    y: 77.2,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.86,
    y: 78.24,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.46,
    y: 74.6,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.98,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.36,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.98,
    y: 73.53,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.91,
    y: 73.49,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.55,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.98,
    y: 74.72,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.82,
    y: 74.72,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.46,
    y: 68.91,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.98,
    y: 70.03,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.36,
    y: 70,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.29,
    y: 72.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 123,
    y: 72.69,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.56,
    y: 71.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.98,
    y: 67.85,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.91,
    y: 67.8,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124,
    y: 71.24,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.55,
    y: 70.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.98,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.8,
    y: 71.15,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.82,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 121.31,
    y: 71.51,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 126.27,
    y: 72.56,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.98,
    y: 64.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.36,
    y: 64.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.29,
    y: 66.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 123,
    y: 67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.56,
    y: 65.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124,
    y: 65.56,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.55,
    y: 64.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.8,
    y: 65.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 121.31,
    y: 65.83,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 126.27,
    y: 66.88,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.46,
    y: 85.96,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.98,
    y: 87.08,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.36,
    y: 87.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.98,
    y: 84.9,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.91,
    y: 84.85,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.55,
    y: 87.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.98,
    y: 86.09,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.82,
    y: 86.09,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.46,
    y: 80.28,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.98,
    y: 81.4,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.36,
    y: 81.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.29,
    y: 83.89,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 123,
    y: 84.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.56,
    y: 82.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.98,
    y: 79.21,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.91,
    y: 79.17,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124,
    y: 82.61,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.55,
    y: 81.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.98,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.8,
    y: 82.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.82,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 121.31,
    y: 82.88,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 126.27,
    y: 83.93,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.98,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.36,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.29,
    y: 78.2,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 123,
    y: 78.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.56,
    y: 77.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124,
    y: 76.93,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.55,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.8,
    y: 76.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 121.31,
    y: 77.2,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 126.27,
    y: 78.24,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.86,
    y: 74.6,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.38,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.76,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.38,
    y: 73.53,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.31,
    y: 73.49,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.95,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.38,
    y: 74.72,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 139.22,
    y: 74.72,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.86,
    y: 68.91,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.38,
    y: 70.03,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.76,
    y: 70,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.7,
    y: 72.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.4,
    y: 72.69,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.97,
    y: 71.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.38,
    y: 67.85,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.31,
    y: 67.8,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.4,
    y: 71.24,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.95,
    y: 70.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.38,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.2,
    y: 71.15,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 139.22,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.72,
    y: 71.51,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.67,
    y: 72.56,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.38,
    y: 64.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.76,
    y: 64.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.7,
    y: 66.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.4,
    y: 67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.97,
    y: 65.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.4,
    y: 65.56,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.95,
    y: 64.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.2,
    y: 65.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.72,
    y: 65.83,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.67,
    y: 66.88,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.86,
    y: 85.96,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.38,
    y: 87.08,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.76,
    y: 87.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.38,
    y: 84.9,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.31,
    y: 84.85,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.95,
    y: 87.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.38,
    y: 86.09,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 139.22,
    y: 86.09,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.86,
    y: 80.28,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.38,
    y: 81.4,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.76,
    y: 81.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.7,
    y: 83.89,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.4,
    y: 84.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.97,
    y: 82.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.38,
    y: 79.21,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.31,
    y: 79.17,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.4,
    y: 82.61,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.95,
    y: 81.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.38,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.2,
    y: 82.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 139.22,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.72,
    y: 82.88,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.67,
    y: 83.93,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.38,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.76,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.7,
    y: 78.2,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.4,
    y: 78.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.97,
    y: 77.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.4,
    y: 76.93,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.95,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.2,
    y: 76.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.72,
    y: 77.2,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 137.67,
    y: 78.24,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.26,
    y: 74.6,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 148.79,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.16,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 148.79,
    y: 73.53,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.71,
    y: 73.49,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.35,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.78,
    y: 74.72,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.63,
    y: 74.72,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.26,
    y: 68.91,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 148.79,
    y: 70.03,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.16,
    y: 70,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.1,
    y: 72.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.8,
    y: 72.69,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.37,
    y: 71.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 148.79,
    y: 67.85,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.71,
    y: 67.8,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.8,
    y: 71.24,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.35,
    y: 70.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.78,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.61,
    y: 71.15,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.63,
    y: 69.04,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 144.12,
    y: 71.51,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 149.07,
    y: 72.56,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 148.79,
    y: 64.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.16,
    y: 64.32,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.1,
    y: 66.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.8,
    y: 67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.37,
    y: 65.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.8,
    y: 65.56,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.35,
    y: 64.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.61,
    y: 65.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 144.12,
    y: 65.83,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 149.07,
    y: 66.88,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.26,
    y: 85.96,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 148.79,
    y: 87.08,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.16,
    y: 87.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 148.79,
    y: 84.9,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.71,
    y: 84.85,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.35,
    y: 87.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.78,
    y: 86.09,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.63,
    y: 86.09,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.26,
    y: 80.28,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 148.79,
    y: 81.4,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.16,
    y: 81.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.1,
    y: 83.89,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.8,
    y: 84.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.37,
    y: 82.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 148.79,
    y: 79.21,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.71,
    y: 79.17,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.8,
    y: 82.61,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.35,
    y: 81.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.78,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.61,
    y: 82.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.63,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 144.12,
    y: 82.88,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 149.07,
    y: 83.93,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 148.79,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.16,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.1,
    y: 78.2,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.8,
    y: 78.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.37,
    y: 77.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.8,
    y: 76.93,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.35,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.61,
    y: 76.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 144.12,
    y: 77.2,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 149.07,
    y: 78.24,
    width: 1.98,
    height: 0.72
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-196",
    points: "156.28 41.83 31.41 41.83 40.27 28.68 147.41 28.68 156.28 41.83"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 122.26,
    y: 14.21,
    width: 14.4,
    height: 20.76,
    transform: "translate(258.92 49.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 139.32,
    y: 17.28,
    width: 5.65,
    height: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.06,
    y: 19.16,
    width: 5.65,
    height: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.78,
    y: 19.11,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.54,
    y: 15.48,
    width: 5.16,
    height: 1.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.85,
    y: 15.42,
    width: 5.65,
    height: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.29,
    y: 19.37,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.64,
    y: 17.49,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.9,
    y: 17.49,
    width: 3.52,
    height: 1.21
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 139.32,
    y: 7.73,
    width: 5.65,
    height: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.06,
    y: 9.61,
    width: 5.65,
    height: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.78,
    y: 9.55,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.9,
    y: 13.79,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 139.32,
    y: 14.07,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.19,
    y: 11.85,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.54,
    y: 5.93,
    width: 5.16,
    height: 1.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.85,
    y: 5.86,
    width: 5.65,
    height: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.7,
    y: 11.64,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.29,
    y: 9.81,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.64,
    y: 7.93,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.95,
    y: 11.49,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.9,
    y: 7.93,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.48,
    y: 12.1,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.67,
    y: 13.85,
    width: 3.52,
    height: 1.21
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.06,
    y: 0.05,
    width: 5.65,
    height: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.78,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.9,
    y: 4.23,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 139.32,
    y: 4.51,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.19,
    y: 2.3,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.7,
    y: 2.09,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.29,
    y: 0.26,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.95,
    y: 1.93,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.48,
    y: 2.54,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.67,
    y: 4.3,
    width: 3.52,
    height: 1.21
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 139.32,
    y: 36.39,
    width: 5.65,
    height: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.06,
    y: 38.27,
    width: 5.65,
    height: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.78,
    y: 38.22,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.54,
    y: 34.59,
    width: 5.16,
    height: 1.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.85,
    y: 34.52,
    width: 5.65,
    height: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.29,
    y: 38.48,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.64,
    y: 36.6,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.9,
    y: 36.6,
    width: 3.52,
    height: 1.21
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 139.32,
    y: 26.84,
    width: 5.65,
    height: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.06,
    y: 28.72,
    width: 5.65,
    height: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.78,
    y: 28.66,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.9,
    y: 32.9,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 139.32,
    y: 33.18,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.19,
    y: 30.96,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.54,
    y: 25.04,
    width: 5.16,
    height: 1.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.85,
    y: 24.97,
    width: 5.65,
    height: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.7,
    y: 30.75,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.29,
    y: 28.92,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.64,
    y: 27.04,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.95,
    y: 30.6,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.9,
    y: 27.04,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.48,
    y: 31.2,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.67,
    y: 32.96,
    width: 3.52,
    height: 1.21
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 133.06,
    y: 19.16,
    width: 5.65,
    height: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.78,
    y: 19.11,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.9,
    y: 23.34,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 139.32,
    y: 23.62,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.19,
    y: 21.41,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.7,
    y: 21.2,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.29,
    y: 19.37,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.95,
    y: 21.04,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.48,
    y: 21.65,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.67,
    y: 23.41,
    width: 3.52,
    height: 1.21
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.04,
    y: 17.28,
    width: 5.65,
    height: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.78,
    y: 19.16,
    width: 5.65,
    height: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.51,
    y: 19.11,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 113.26,
    y: 15.48,
    width: 5.16,
    height: 1.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 123.58,
    y: 15.42,
    width: 5.65,
    height: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 121.01,
    y: 19.37,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.36,
    y: 17.49,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.63,
    y: 17.49,
    width: 3.52,
    height: 1.21
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.04,
    y: 7.73,
    width: 5.65,
    height: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.78,
    y: 9.61,
    width: 5.65,
    height: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.51,
    y: 9.55,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.63,
    y: 13.79,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.04,
    y: 14.07,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 110.92,
    y: 11.85,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 113.26,
    y: 5.93,
    width: 5.16,
    height: 1.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 123.58,
    y: 5.86,
    width: 5.65,
    height: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.43,
    y: 11.64,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 121.01,
    y: 9.81,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.36,
    y: 7.93,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.67,
    y: 11.49,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.63,
    y: 7.93,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 123.2,
    y: 12.1,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.39,
    y: 13.85,
    width: 3.52,
    height: 1.21
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.78,
    y: 0.05,
    width: 5.65,
    height: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.51,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.63,
    y: 4.23,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.04,
    y: 4.51,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 110.92,
    y: 2.3,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.43,
    y: 2.09,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 121.01,
    y: 0.26,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.67,
    y: 1.93,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 123.2,
    y: 2.54,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.39,
    y: 4.3,
    width: 3.52,
    height: 1.21
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.04,
    y: 36.39,
    width: 5.65,
    height: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.78,
    y: 38.27,
    width: 5.65,
    height: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.51,
    y: 38.22,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 113.26,
    y: 34.59,
    width: 5.16,
    height: 1.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 123.58,
    y: 34.52,
    width: 5.65,
    height: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 121.01,
    y: 38.48,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.36,
    y: 36.6,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.63,
    y: 36.6,
    width: 3.52,
    height: 1.21
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.04,
    y: 26.84,
    width: 5.65,
    height: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.78,
    y: 28.72,
    width: 5.65,
    height: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.51,
    y: 28.66,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.63,
    y: 32.9,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.04,
    y: 33.18,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 110.92,
    y: 30.96,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 113.26,
    y: 25.04,
    width: 5.16,
    height: 1.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 123.58,
    y: 24.97,
    width: 5.65,
    height: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.43,
    y: 30.75,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 121.01,
    y: 28.92,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.36,
    y: 27.04,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.67,
    y: 30.6,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.63,
    y: 27.04,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 123.2,
    y: 31.2,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.39,
    y: 32.96,
    width: 3.52,
    height: 1.21
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.78,
    y: 19.16,
    width: 5.65,
    height: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.51,
    y: 19.11,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 125.63,
    y: 23.34,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.04,
    y: 23.62,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 110.92,
    y: 21.41,
    width: 4.69,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.43,
    y: 21.2,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 121.01,
    y: 19.37,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.67,
    y: 21.04,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 123.2,
    y: 21.65,
    width: 3.52,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 114.39,
    y: 23.41,
    width: 3.52,
    height: 1.21
  })))))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 118.33,
    y: 12.51,
    width: 22.26,
    height: 4.23,
    transform: "translate(258.92 29.25) rotate(180)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 86.41,
    y: 81.84,
    width: 76.53,
    height: 42.88,
    transform: "translate(249.35 206.57) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.75,
    y: 85.96,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 158.22,
    y: 87.08,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 165.38,
    y: 87.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 158.5,
    y: 84.9,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 164.3,
    y: 84.85,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 162.85,
    y: 87.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 166.42,
    y: 86.09,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 157.58,
    y: 86.09,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.75,
    y: 80.28,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 158.22,
    y: 81.4,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 165.38,
    y: 81.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 165.45,
    y: 83.89,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.75,
    y: 84.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 157.18,
    y: 82.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 158.5,
    y: 79.21,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 164.3,
    y: 79.17,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.4,
    y: 82.61,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 162.85,
    y: 81.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 166.42,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 166.6,
    y: 82.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 157.58,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 164.09,
    y: 82.88,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 159.13,
    y: 83.93,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 158.22,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 165.38,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 165.45,
    y: 78.2,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.75,
    y: 78.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 157.18,
    y: 77.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.4,
    y: 76.93,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 162.85,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 166.6,
    y: 76.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 164.09,
    y: 77.2,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 159.13,
    y: 78.24,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.75,
    y: 97.33,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 158.22,
    y: 98.45,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 165.38,
    y: 98.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 158.5,
    y: 96.26,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 164.3,
    y: 96.22,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 162.85,
    y: 98.57,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 166.42,
    y: 97.45,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 157.58,
    y: 97.45,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.75,
    y: 91.65,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 158.22,
    y: 92.77,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 165.38,
    y: 92.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 165.45,
    y: 95.25,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.75,
    y: 95.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 157.18,
    y: 94.1,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 158.5,
    y: 90.58,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 164.3,
    y: 90.54,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.4,
    y: 93.98,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 162.85,
    y: 92.89,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 166.42,
    y: 91.77,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 166.6,
    y: 93.89,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 157.58,
    y: 91.77,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 164.09,
    y: 94.25,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 159.13,
    y: 95.29,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 158.22,
    y: 87.08,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 165.38,
    y: 87.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 165.45,
    y: 89.57,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.75,
    y: 89.74,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 157.18,
    y: 88.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.4,
    y: 88.29,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 162.85,
    y: 87.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 166.6,
    y: 88.2,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 164.09,
    y: 88.56,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 159.13,
    y: 89.61,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.75,
    y: 108.7,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 158.22,
    y: 109.82,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 165.38,
    y: 109.79,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 158.5,
    y: 107.63,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 164.3,
    y: 107.59,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 162.85,
    y: 109.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 166.42,
    y: 108.82,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 157.58,
    y: 108.82,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.75,
    y: 103.01,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 158.22,
    y: 104.13,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 165.38,
    y: 104.1,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 165.45,
    y: 106.62,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.75,
    y: 106.79,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 157.18,
    y: 105.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 158.5,
    y: 101.95,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 164.3,
    y: 101.9,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.4,
    y: 105.34,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 162.85,
    y: 104.26,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 166.42,
    y: 103.14,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 166.6,
    y: 105.25,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 157.58,
    y: 103.14,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 164.09,
    y: 105.61,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 159.13,
    y: 106.66,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 158.22,
    y: 98.45,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 165.38,
    y: 98.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 165.45,
    y: 100.94,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.75,
    y: 101.1,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 157.18,
    y: 99.78,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.4,
    y: 99.66,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 162.85,
    y: 98.57,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 166.6,
    y: 99.57,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 164.09,
    y: 99.93,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 159.13,
    y: 100.98,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.75,
    y: 120.06,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 158.22,
    y: 121.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 165.38,
    y: 121.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 158.5,
    y: 119,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 164.3,
    y: 118.95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 162.85,
    y: 121.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 166.42,
    y: 120.19,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 157.58,
    y: 120.19,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.75,
    y: 114.38,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 158.22,
    y: 115.5,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 165.38,
    y: 115.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 165.45,
    y: 117.99,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.75,
    y: 118.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 157.18,
    y: 116.83,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 158.5,
    y: 113.31,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 164.3,
    y: 113.27,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.4,
    y: 116.71,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 162.85,
    y: 115.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 166.42,
    y: 114.5,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 166.6,
    y: 116.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 157.58,
    y: 114.5,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 164.09,
    y: 116.98,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 159.13,
    y: 118.03,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 158.22,
    y: 109.82,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 165.38,
    y: 109.79,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 165.45,
    y: 112.3,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.75,
    y: 112.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 157.18,
    y: 111.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.4,
    y: 111.03,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 162.85,
    y: 109.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 166.6,
    y: 110.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 164.09,
    y: 111.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 159.13,
    y: 112.34,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.75,
    y: 131.43,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 158.22,
    y: 132.55,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 165.38,
    y: 132.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 158.5,
    y: 130.36,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 164.3,
    y: 130.32,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 162.85,
    y: 132.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 166.42,
    y: 131.55,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 157.58,
    y: 131.55,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.75,
    y: 125.75,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 158.22,
    y: 126.87,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 165.38,
    y: 126.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 165.45,
    y: 129.35,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.75,
    y: 129.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 157.18,
    y: 128.2,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 158.5,
    y: 124.68,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 164.3,
    y: 124.64,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.4,
    y: 128.08,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 162.85,
    y: 126.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 166.42,
    y: 125.87,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 166.6,
    y: 127.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 157.58,
    y: 125.87,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 164.09,
    y: 128.35,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 159.13,
    y: 129.39,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 158.22,
    y: 121.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 165.38,
    y: 121.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 165.45,
    y: 123.67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.75,
    y: 123.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 157.18,
    y: 122.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.4,
    y: 122.39,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 162.85,
    y: 121.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 166.6,
    y: 122.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 164.09,
    y: 122.66,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 159.13,
    y: 123.71,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.34,
    y: 85.96,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.82,
    y: 87.08,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 153.98,
    y: 87.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.09,
    y: 84.9,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 152.89,
    y: 84.85,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 151.45,
    y: 87.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 155.02,
    y: 86.09,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.18,
    y: 86.09,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.34,
    y: 80.28,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.82,
    y: 81.4,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 153.98,
    y: 81.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 154.05,
    y: 83.89,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.34,
    y: 84.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.78,
    y: 82.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.09,
    y: 79.21,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 152.89,
    y: 79.17,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150,
    y: 82.61,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 151.45,
    y: 81.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 155.02,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 155.2,
    y: 82.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.18,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 152.68,
    y: 82.88,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.73,
    y: 83.93,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.82,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 153.98,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 154.05,
    y: 78.2,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.34,
    y: 78.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.78,
    y: 77.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150,
    y: 76.93,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 151.45,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 155.2,
    y: 76.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 152.68,
    y: 77.2,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.73,
    y: 78.24,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.34,
    y: 97.33,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.82,
    y: 98.45,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 153.98,
    y: 98.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.09,
    y: 96.26,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 152.89,
    y: 96.22,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 151.45,
    y: 98.57,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 155.02,
    y: 97.45,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.18,
    y: 97.45,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.34,
    y: 91.65,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.82,
    y: 92.77,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 153.98,
    y: 92.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 154.05,
    y: 95.25,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.34,
    y: 95.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.78,
    y: 94.1,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.09,
    y: 90.58,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 152.89,
    y: 90.54,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150,
    y: 93.98,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 151.45,
    y: 92.89,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 155.02,
    y: 91.77,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 155.2,
    y: 93.89,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.18,
    y: 91.77,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 152.68,
    y: 94.25,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.73,
    y: 95.29,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.82,
    y: 87.08,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 153.98,
    y: 87.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 154.05,
    y: 89.57,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.34,
    y: 89.74,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.78,
    y: 88.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150,
    y: 88.29,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 151.45,
    y: 87.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 155.2,
    y: 88.2,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 152.68,
    y: 88.56,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.73,
    y: 89.61,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.34,
    y: 108.7,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.82,
    y: 109.82,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 153.98,
    y: 109.79,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.09,
    y: 107.63,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 152.89,
    y: 107.59,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 151.45,
    y: 109.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 155.02,
    y: 108.82,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.18,
    y: 108.82,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.34,
    y: 103.01,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.82,
    y: 104.13,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 153.98,
    y: 104.1,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 154.05,
    y: 106.62,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.34,
    y: 106.79,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.78,
    y: 105.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.09,
    y: 101.95,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 152.89,
    y: 101.9,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150,
    y: 105.34,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 151.45,
    y: 104.26,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 155.02,
    y: 103.14,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 155.2,
    y: 105.25,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.18,
    y: 103.14,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 152.68,
    y: 105.61,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.73,
    y: 106.66,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.82,
    y: 98.45,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 153.98,
    y: 98.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 154.05,
    y: 100.94,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.34,
    y: 101.1,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.78,
    y: 99.78,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150,
    y: 99.66,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 151.45,
    y: 98.57,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 155.2,
    y: 99.57,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 152.68,
    y: 99.93,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.73,
    y: 100.98,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.34,
    y: 120.06,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.82,
    y: 121.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 153.98,
    y: 121.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.09,
    y: 119,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 152.89,
    y: 118.95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 151.45,
    y: 121.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 155.02,
    y: 120.19,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.18,
    y: 120.19,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.34,
    y: 114.38,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.82,
    y: 115.5,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 153.98,
    y: 115.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 154.05,
    y: 117.99,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.34,
    y: 118.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.78,
    y: 116.83,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.09,
    y: 113.31,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 152.89,
    y: 113.27,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150,
    y: 116.71,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 151.45,
    y: 115.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 155.02,
    y: 114.5,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 155.2,
    y: 116.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.18,
    y: 114.5,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 152.68,
    y: 116.98,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.73,
    y: 118.03,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.82,
    y: 109.82,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 153.98,
    y: 109.79,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 154.05,
    y: 112.3,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.34,
    y: 112.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.78,
    y: 111.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150,
    y: 111.03,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 151.45,
    y: 109.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 155.2,
    y: 110.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 152.68,
    y: 111.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.73,
    y: 112.34,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.34,
    y: 131.43,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.82,
    y: 132.55,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 153.98,
    y: 132.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.09,
    y: 130.36,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 152.89,
    y: 130.32,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 151.45,
    y: 132.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 155.02,
    y: 131.55,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.18,
    y: 131.55,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.34,
    y: 125.75,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.82,
    y: 126.87,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 153.98,
    y: 126.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 154.05,
    y: 129.35,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.34,
    y: 129.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.78,
    y: 128.2,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.09,
    y: 124.68,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 152.89,
    y: 124.64,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150,
    y: 128.08,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 151.45,
    y: 126.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 155.02,
    y: 125.87,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 155.2,
    y: 127.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.18,
    y: 125.87,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 152.68,
    y: 128.35,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.73,
    y: 129.39,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.82,
    y: 121.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 153.98,
    y: 121.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 154.05,
    y: 123.67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.34,
    y: 123.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.78,
    y: 122.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150,
    y: 122.39,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 151.45,
    y: 121.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 155.2,
    y: 122.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 152.68,
    y: 122.66,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.73,
    y: 123.71,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.94,
    y: 85.96,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.42,
    y: 87.08,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.58,
    y: 87.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.69,
    y: 84.9,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.49,
    y: 84.85,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 140.05,
    y: 87.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.62,
    y: 86.09,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.77,
    y: 86.09,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.94,
    y: 80.28,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.42,
    y: 81.4,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.58,
    y: 81.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.64,
    y: 83.89,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.94,
    y: 84.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.37,
    y: 82.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.69,
    y: 79.21,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.49,
    y: 79.17,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.6,
    y: 82.61,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 140.05,
    y: 81.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.62,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.79,
    y: 82.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.77,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.28,
    y: 82.88,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 136.33,
    y: 83.93,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.42,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.58,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.64,
    y: 78.2,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.94,
    y: 78.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.37,
    y: 77.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.6,
    y: 76.93,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 140.05,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.79,
    y: 76.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.28,
    y: 77.2,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 136.33,
    y: 78.24,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.94,
    y: 97.33,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.42,
    y: 98.45,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.58,
    y: 98.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.69,
    y: 96.26,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.49,
    y: 96.22,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 140.05,
    y: 98.57,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.62,
    y: 97.45,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.77,
    y: 97.45,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.94,
    y: 91.65,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.42,
    y: 92.77,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.58,
    y: 92.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.64,
    y: 95.25,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.94,
    y: 95.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.37,
    y: 94.1,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.69,
    y: 90.58,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.49,
    y: 90.54,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.6,
    y: 93.98,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 140.05,
    y: 92.89,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.62,
    y: 91.77,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.79,
    y: 93.89,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.77,
    y: 91.77,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.28,
    y: 94.25,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 136.33,
    y: 95.29,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.42,
    y: 87.08,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.58,
    y: 87.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.64,
    y: 89.57,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.94,
    y: 89.74,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.37,
    y: 88.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.6,
    y: 88.29,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 140.05,
    y: 87.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.79,
    y: 88.2,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.28,
    y: 88.56,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 136.33,
    y: 89.61,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-88"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.94,
    y: 108.7,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.42,
    y: 109.82,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.58,
    y: 109.79,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.69,
    y: 107.63,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.49,
    y: 107.59,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 140.05,
    y: 109.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.62,
    y: 108.82,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.77,
    y: 108.82,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.94,
    y: 103.01,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.42,
    y: 104.13,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.58,
    y: 104.1,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.64,
    y: 106.62,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.94,
    y: 106.79,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.37,
    y: 105.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.69,
    y: 101.95,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.49,
    y: 101.9,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.6,
    y: 105.34,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 140.05,
    y: 104.26,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.62,
    y: 103.14,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.79,
    y: 105.25,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.77,
    y: 103.14,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.28,
    y: 105.61,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 136.33,
    y: 106.66,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.42,
    y: 98.45,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.58,
    y: 98.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.64,
    y: 100.94,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.94,
    y: 101.1,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.37,
    y: 99.78,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.6,
    y: 99.66,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 140.05,
    y: 98.57,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.79,
    y: 99.57,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.28,
    y: 99.93,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 136.33,
    y: 100.98,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-90"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.94,
    y: 120.06,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.42,
    y: 121.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.58,
    y: 121.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.69,
    y: 119,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.49,
    y: 118.95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 140.05,
    y: 121.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.62,
    y: 120.19,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.77,
    y: 120.19,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.94,
    y: 114.38,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.42,
    y: 115.5,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.58,
    y: 115.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.64,
    y: 117.99,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.94,
    y: 118.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.37,
    y: 116.83,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.69,
    y: 113.31,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.49,
    y: 113.27,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.6,
    y: 116.71,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 140.05,
    y: 115.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.62,
    y: 114.5,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.79,
    y: 116.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.77,
    y: 114.5,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.28,
    y: 116.98,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 136.33,
    y: 118.03,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.42,
    y: 109.82,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.58,
    y: 109.79,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.64,
    y: 112.3,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.94,
    y: 112.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.37,
    y: 111.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.6,
    y: 111.03,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 140.05,
    y: 109.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.79,
    y: 110.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.28,
    y: 111.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 136.33,
    y: 112.34,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-91"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.94,
    y: 131.43,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.42,
    y: 132.55,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.58,
    y: 132.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.69,
    y: 130.36,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.49,
    y: 130.32,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 140.05,
    y: 132.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.62,
    y: 131.55,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.77,
    y: 131.55,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.94,
    y: 125.75,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.42,
    y: 126.87,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.58,
    y: 126.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.64,
    y: 129.35,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.94,
    y: 129.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.37,
    y: 128.2,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.69,
    y: 124.68,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.49,
    y: 124.64,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.6,
    y: 128.08,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 140.05,
    y: 126.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.62,
    y: 125.87,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.79,
    y: 127.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.77,
    y: 125.87,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.28,
    y: 128.35,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 136.33,
    y: 129.39,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.42,
    y: 121.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.58,
    y: 121.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.64,
    y: 123.67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.94,
    y: 123.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.37,
    y: 122.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.6,
    y: 122.39,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 140.05,
    y: 121.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.79,
    y: 122.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.28,
    y: 122.66,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 136.33,
    y: 123.71,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.54,
    y: 85.96,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.02,
    y: 87.08,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.18,
    y: 87.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.29,
    y: 84.9,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.09,
    y: 84.85,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 128.65,
    y: 87.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.22,
    y: 86.09,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 123.37,
    y: 86.09,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.54,
    y: 80.28,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.02,
    y: 81.4,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.18,
    y: 81.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.24,
    y: 83.89,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.54,
    y: 84.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.97,
    y: 82.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.29,
    y: 79.21,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.09,
    y: 79.17,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.19,
    y: 82.61,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 128.65,
    y: 81.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.22,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.39,
    y: 82.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 123.37,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 129.88,
    y: 82.88,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.93,
    y: 83.93,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.02,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.18,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.24,
    y: 78.2,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.54,
    y: 78.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.97,
    y: 77.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.19,
    y: 76.93,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 128.65,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.39,
    y: 76.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 129.88,
    y: 77.2,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.93,
    y: 78.24,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-93"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.54,
    y: 97.33,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.02,
    y: 98.45,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.18,
    y: 98.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.29,
    y: 96.26,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.09,
    y: 96.22,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 128.65,
    y: 98.57,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.22,
    y: 97.45,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 123.37,
    y: 97.45,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.54,
    y: 91.65,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.02,
    y: 92.77,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.18,
    y: 92.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.24,
    y: 95.25,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.54,
    y: 95.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.97,
    y: 94.1,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.29,
    y: 90.58,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.09,
    y: 90.54,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.19,
    y: 93.98,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 128.65,
    y: 92.89,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.22,
    y: 91.77,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.39,
    y: 93.89,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 123.37,
    y: 91.77,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 129.88,
    y: 94.25,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.93,
    y: 95.29,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.02,
    y: 87.08,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.18,
    y: 87.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.24,
    y: 89.57,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.54,
    y: 89.74,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.97,
    y: 88.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.19,
    y: 88.29,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 128.65,
    y: 87.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.39,
    y: 88.2,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 129.88,
    y: 88.56,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.93,
    y: 89.61,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-85"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.54,
    y: 108.7,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.02,
    y: 109.82,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.18,
    y: 109.79,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.29,
    y: 107.63,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.09,
    y: 107.59,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 128.65,
    y: 109.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.22,
    y: 108.82,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 123.37,
    y: 108.82,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.54,
    y: 103.01,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.02,
    y: 104.13,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.18,
    y: 104.1,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.24,
    y: 106.62,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.54,
    y: 106.79,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.97,
    y: 105.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.29,
    y: 101.95,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.09,
    y: 101.9,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.19,
    y: 105.34,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 128.65,
    y: 104.26,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.22,
    y: 103.14,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.39,
    y: 105.25,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 123.37,
    y: 103.14,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 129.88,
    y: 105.61,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.93,
    y: 106.66,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.02,
    y: 98.45,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.18,
    y: 98.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.24,
    y: 100.94,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.54,
    y: 101.1,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.97,
    y: 99.78,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.19,
    y: 99.66,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 128.65,
    y: 98.57,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.39,
    y: 99.57,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 129.88,
    y: 99.93,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.93,
    y: 100.98,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-86"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.54,
    y: 120.06,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.02,
    y: 121.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.18,
    y: 121.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.29,
    y: 119,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.09,
    y: 118.95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 128.65,
    y: 121.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.22,
    y: 120.19,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 123.37,
    y: 120.19,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.54,
    y: 114.38,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.02,
    y: 115.5,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.18,
    y: 115.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.24,
    y: 117.99,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.54,
    y: 118.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.97,
    y: 116.83,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.29,
    y: 113.31,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.09,
    y: 113.27,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.19,
    y: 116.71,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 128.65,
    y: 115.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.22,
    y: 114.5,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.39,
    y: 116.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 123.37,
    y: 114.5,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 129.88,
    y: 116.98,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.93,
    y: 118.03,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.02,
    y: 109.82,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.18,
    y: 109.79,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.24,
    y: 112.3,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.54,
    y: 112.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.97,
    y: 111.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.19,
    y: 111.03,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 128.65,
    y: 109.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.39,
    y: 110.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 129.88,
    y: 111.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.93,
    y: 112.34,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-87"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.54,
    y: 131.43,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.02,
    y: 132.55,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.18,
    y: 132.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.29,
    y: 130.36,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.09,
    y: 130.32,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 128.65,
    y: 132.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.22,
    y: 131.55,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 123.37,
    y: 131.55,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.54,
    y: 125.75,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.02,
    y: 126.87,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.18,
    y: 126.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.24,
    y: 129.35,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.54,
    y: 129.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.97,
    y: 128.2,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.29,
    y: 124.68,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.09,
    y: 124.64,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.19,
    y: 128.08,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 128.65,
    y: 126.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.22,
    y: 125.87,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.39,
    y: 127.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 123.37,
    y: 125.87,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 129.88,
    y: 128.35,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.93,
    y: 129.39,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.02,
    y: 121.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.18,
    y: 121.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.24,
    y: 123.67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.54,
    y: 123.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.97,
    y: 122.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.19,
    y: 122.39,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 128.65,
    y: 121.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.39,
    y: 122.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 129.88,
    y: 122.66,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.93,
    y: 123.71,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-94"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.14,
    y: 85.96,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.61,
    y: 87.08,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.77,
    y: 87.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.89,
    y: 84.9,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.69,
    y: 84.85,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 117.24,
    y: 87.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 120.81,
    y: 86.09,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.97,
    y: 86.09,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.14,
    y: 80.28,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.61,
    y: 81.4,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.77,
    y: 81.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.84,
    y: 83.89,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.14,
    y: 84.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.57,
    y: 82.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.89,
    y: 79.21,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.69,
    y: 79.17,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 115.79,
    y: 82.61,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 117.24,
    y: 81.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 120.81,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 120.99,
    y: 82.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.97,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.48,
    y: 82.88,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 113.52,
    y: 83.93,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.61,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.77,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.84,
    y: 78.2,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.14,
    y: 78.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.57,
    y: 77.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 115.79,
    y: 76.93,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 117.24,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 120.99,
    y: 76.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.48,
    y: 77.2,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 113.52,
    y: 78.24,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-89"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.14,
    y: 97.33,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.61,
    y: 98.45,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.77,
    y: 98.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.89,
    y: 96.26,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.69,
    y: 96.22,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 117.24,
    y: 98.57,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 120.81,
    y: 97.45,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.97,
    y: 97.45,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.14,
    y: 91.65,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.61,
    y: 92.77,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.77,
    y: 92.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.84,
    y: 95.25,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.14,
    y: 95.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.57,
    y: 94.1,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.89,
    y: 90.58,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.69,
    y: 90.54,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 115.79,
    y: 93.98,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 117.24,
    y: 92.89,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 120.81,
    y: 91.77,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 120.99,
    y: 93.89,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.97,
    y: 91.77,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.48,
    y: 94.25,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 113.52,
    y: 95.29,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.61,
    y: 87.08,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.77,
    y: 87.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.84,
    y: 89.57,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.14,
    y: 89.74,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.57,
    y: 88.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 115.79,
    y: 88.29,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 117.24,
    y: 87.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 120.99,
    y: 88.2,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.48,
    y: 88.56,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 113.52,
    y: 89.61,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-79"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.14,
    y: 108.7,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.61,
    y: 109.82,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.77,
    y: 109.79,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.89,
    y: 107.63,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.69,
    y: 107.59,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 117.24,
    y: 109.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 120.81,
    y: 108.82,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.97,
    y: 108.82,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.14,
    y: 103.01,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.61,
    y: 104.13,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.77,
    y: 104.1,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.84,
    y: 106.62,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.14,
    y: 106.79,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.57,
    y: 105.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.89,
    y: 101.95,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.69,
    y: 101.9,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 115.79,
    y: 105.34,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 117.24,
    y: 104.26,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 120.81,
    y: 103.14,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 120.99,
    y: 105.25,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.97,
    y: 103.14,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.48,
    y: 105.61,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 113.52,
    y: 106.66,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.61,
    y: 98.45,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.77,
    y: 98.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.84,
    y: 100.94,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.14,
    y: 101.1,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.57,
    y: 99.78,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 115.79,
    y: 99.66,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 117.24,
    y: 98.57,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 120.99,
    y: 99.57,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.48,
    y: 99.93,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 113.52,
    y: 100.98,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-97"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.14,
    y: 120.06,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.61,
    y: 121.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.77,
    y: 121.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.89,
    y: 119,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.69,
    y: 118.95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 117.24,
    y: 121.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 120.81,
    y: 120.19,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.97,
    y: 120.19,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.14,
    y: 114.38,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.61,
    y: 115.5,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.77,
    y: 115.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.84,
    y: 117.99,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.14,
    y: 118.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.57,
    y: 116.83,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.89,
    y: 113.31,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.69,
    y: 113.27,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 115.79,
    y: 116.71,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 117.24,
    y: 115.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 120.81,
    y: 114.5,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 120.99,
    y: 116.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.97,
    y: 114.5,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.48,
    y: 116.98,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 113.52,
    y: 118.03,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.61,
    y: 109.82,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.77,
    y: 109.79,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.84,
    y: 112.3,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.14,
    y: 112.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.57,
    y: 111.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 115.79,
    y: 111.03,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 117.24,
    y: 109.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 120.99,
    y: 110.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.48,
    y: 111.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 113.52,
    y: 112.34,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-95"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.14,
    y: 131.43,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.61,
    y: 132.55,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.77,
    y: 132.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.89,
    y: 130.36,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.69,
    y: 130.32,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 117.24,
    y: 132.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 120.81,
    y: 131.55,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.97,
    y: 131.55,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.14,
    y: 125.75,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.61,
    y: 126.87,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.77,
    y: 126.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.84,
    y: 129.35,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.14,
    y: 129.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.57,
    y: 128.2,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.89,
    y: 124.68,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.69,
    y: 124.64,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 115.79,
    y: 128.08,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 117.24,
    y: 126.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 120.81,
    y: 125.87,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 120.99,
    y: 127.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.97,
    y: 125.87,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.48,
    y: 128.35,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 113.52,
    y: 129.39,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.61,
    y: 121.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.77,
    y: 121.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.84,
    y: 123.67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.14,
    y: 123.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.57,
    y: 122.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 115.79,
    y: 122.39,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 117.24,
    y: 121.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 120.99,
    y: 122.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.48,
    y: 122.66,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 113.52,
    y: 123.71,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-81"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.73,
    y: 85.96,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.21,
    y: 87.08,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.37,
    y: 87.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.48,
    y: 84.9,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.28,
    y: 84.85,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 105.84,
    y: 87.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.41,
    y: 86.09,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.57,
    y: 86.09,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.73,
    y: 80.28,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.21,
    y: 81.4,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.37,
    y: 81.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.44,
    y: 83.89,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.73,
    y: 84.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.17,
    y: 82.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.48,
    y: 79.21,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.28,
    y: 79.17,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.39,
    y: 82.61,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 105.84,
    y: 81.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.41,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.59,
    y: 82.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.57,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.07,
    y: 82.88,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 102.12,
    y: 83.93,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.21,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.37,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.44,
    y: 78.2,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.73,
    y: 78.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.17,
    y: 77.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.39,
    y: 76.93,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 105.84,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.59,
    y: 76.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.07,
    y: 77.2,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 102.12,
    y: 78.24,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-83"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.73,
    y: 97.33,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.21,
    y: 98.45,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.37,
    y: 98.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.48,
    y: 96.26,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.28,
    y: 96.22,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 105.84,
    y: 98.57,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.41,
    y: 97.45,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.57,
    y: 97.45,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.73,
    y: 91.65,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.21,
    y: 92.77,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.37,
    y: 92.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.44,
    y: 95.25,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.73,
    y: 95.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.17,
    y: 94.1,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.48,
    y: 90.58,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.28,
    y: 90.54,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.39,
    y: 93.98,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 105.84,
    y: 92.89,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.41,
    y: 91.77,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.59,
    y: 93.89,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.57,
    y: 91.77,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.07,
    y: 94.25,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 102.12,
    y: 95.29,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.21,
    y: 87.08,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.37,
    y: 87.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.44,
    y: 89.57,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.73,
    y: 89.74,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.17,
    y: 88.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.39,
    y: 88.29,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 105.84,
    y: 87.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.59,
    y: 88.2,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.07,
    y: 88.56,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 102.12,
    y: 89.61,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-80"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.73,
    y: 108.7,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.21,
    y: 109.82,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.37,
    y: 109.79,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.48,
    y: 107.63,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.28,
    y: 107.59,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 105.84,
    y: 109.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.41,
    y: 108.82,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.57,
    y: 108.82,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.73,
    y: 103.01,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.21,
    y: 104.13,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.37,
    y: 104.1,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.44,
    y: 106.62,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.73,
    y: 106.79,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.17,
    y: 105.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.48,
    y: 101.95,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.28,
    y: 101.9,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.39,
    y: 105.34,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 105.84,
    y: 104.26,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.41,
    y: 103.14,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.59,
    y: 105.25,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.57,
    y: 103.14,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.07,
    y: 105.61,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 102.12,
    y: 106.66,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.21,
    y: 98.45,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.37,
    y: 98.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.44,
    y: 100.94,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.73,
    y: 101.1,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.17,
    y: 99.78,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.39,
    y: 99.66,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 105.84,
    y: 98.57,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.59,
    y: 99.57,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.07,
    y: 99.93,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 102.12,
    y: 100.98,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-84"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.73,
    y: 120.06,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.21,
    y: 121.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.37,
    y: 121.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.48,
    y: 119,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.28,
    y: 118.95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 105.84,
    y: 121.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.41,
    y: 120.19,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.57,
    y: 120.19,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.73,
    y: 114.38,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.21,
    y: 115.5,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.37,
    y: 115.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.44,
    y: 117.99,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.73,
    y: 118.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.17,
    y: 116.83,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.48,
    y: 113.31,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.28,
    y: 113.27,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.39,
    y: 116.71,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 105.84,
    y: 115.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.41,
    y: 114.5,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.59,
    y: 116.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.57,
    y: 114.5,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.07,
    y: 116.98,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 102.12,
    y: 118.03,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.21,
    y: 109.82,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.37,
    y: 109.79,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.44,
    y: 112.3,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.73,
    y: 112.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.17,
    y: 111.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.39,
    y: 111.03,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 105.84,
    y: 109.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.59,
    y: 110.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.07,
    y: 111.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 102.12,
    y: 112.34,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-96"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.73,
    y: 131.43,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.21,
    y: 132.55,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.37,
    y: 132.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.48,
    y: 130.36,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.28,
    y: 130.32,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 105.84,
    y: 132.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.41,
    y: 131.55,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.57,
    y: 131.55,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.73,
    y: 125.75,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.21,
    y: 126.87,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.37,
    y: 126.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.44,
    y: 129.35,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.73,
    y: 129.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.17,
    y: 128.2,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.48,
    y: 124.68,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.28,
    y: 124.64,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.39,
    y: 128.08,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 105.84,
    y: 126.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.41,
    y: 125.87,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.59,
    y: 127.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.57,
    y: 125.87,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.07,
    y: 128.35,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 102.12,
    y: 129.39,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.21,
    y: 121.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.37,
    y: 121.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.44,
    y: 123.67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.73,
    y: 123.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.17,
    y: 122.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.39,
    y: 122.39,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 105.84,
    y: 121.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.59,
    y: 122.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.07,
    y: 122.66,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 102.12,
    y: 123.71,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-98"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.33,
    y: 85.96,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.81,
    y: 87.08,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.97,
    y: 87.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.08,
    y: 84.9,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 95.88,
    y: 84.85,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.44,
    y: 87.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.01,
    y: 86.09,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.16,
    y: 86.09,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.33,
    y: 80.28,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.81,
    y: 81.4,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.97,
    y: 81.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 97.03,
    y: 83.89,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.33,
    y: 84.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.76,
    y: 82.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.08,
    y: 79.21,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 95.88,
    y: 79.17,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.99,
    y: 82.61,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.44,
    y: 81.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.01,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.18,
    y: 82.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.16,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 95.67,
    y: 82.88,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.72,
    y: 83.93,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.81,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.97,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 97.03,
    y: 78.2,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.33,
    y: 78.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.76,
    y: 77.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.99,
    y: 76.93,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.44,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.18,
    y: 76.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 95.67,
    y: 77.2,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.72,
    y: 78.24,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-82"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.33,
    y: 97.33,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.81,
    y: 98.45,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.97,
    y: 98.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.08,
    y: 96.26,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 95.88,
    y: 96.22,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.44,
    y: 98.57,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.01,
    y: 97.45,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.16,
    y: 97.45,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.33,
    y: 91.65,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.81,
    y: 92.77,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.97,
    y: 92.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 97.03,
    y: 95.25,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.33,
    y: 95.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.76,
    y: 94.1,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.08,
    y: 90.58,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 95.88,
    y: 90.54,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.99,
    y: 93.98,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.44,
    y: 92.89,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.01,
    y: 91.77,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.18,
    y: 93.89,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.16,
    y: 91.77,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 95.67,
    y: 94.25,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.72,
    y: 95.29,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.81,
    y: 87.08,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.97,
    y: 87.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 97.03,
    y: 89.57,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.33,
    y: 89.74,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.76,
    y: 88.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.99,
    y: 88.29,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.44,
    y: 87.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.18,
    y: 88.2,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 95.67,
    y: 88.56,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.72,
    y: 89.61,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-139"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.33,
    y: 108.7,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.81,
    y: 109.82,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.97,
    y: 109.79,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.08,
    y: 107.63,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 95.88,
    y: 107.59,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.44,
    y: 109.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.01,
    y: 108.82,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.16,
    y: 108.82,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.33,
    y: 103.01,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.81,
    y: 104.13,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.97,
    y: 104.1,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 97.03,
    y: 106.62,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.33,
    y: 106.79,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.76,
    y: 105.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.08,
    y: 101.95,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 95.88,
    y: 101.9,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.99,
    y: 105.34,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.44,
    y: 104.26,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.01,
    y: 103.14,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.18,
    y: 105.25,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.16,
    y: 103.14,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 95.67,
    y: 105.61,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.72,
    y: 106.66,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.81,
    y: 98.45,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.97,
    y: 98.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 97.03,
    y: 100.94,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.33,
    y: 101.1,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.76,
    y: 99.78,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.99,
    y: 99.66,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.44,
    y: 98.57,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.18,
    y: 99.57,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 95.67,
    y: 99.93,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.72,
    y: 100.98,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-133"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.33,
    y: 120.06,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.81,
    y: 121.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.97,
    y: 121.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.08,
    y: 119,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 95.88,
    y: 118.95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.44,
    y: 121.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.01,
    y: 120.19,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.16,
    y: 120.19,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.33,
    y: 114.38,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.81,
    y: 115.5,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.97,
    y: 115.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 97.03,
    y: 117.99,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.33,
    y: 118.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.76,
    y: 116.83,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.08,
    y: 113.31,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 95.88,
    y: 113.27,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.99,
    y: 116.71,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.44,
    y: 115.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.01,
    y: 114.5,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.18,
    y: 116.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.16,
    y: 114.5,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 95.67,
    y: 116.98,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.72,
    y: 118.03,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.81,
    y: 109.82,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.97,
    y: 109.79,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 97.03,
    y: 112.3,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.33,
    y: 112.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.76,
    y: 111.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.99,
    y: 111.03,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.44,
    y: 109.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.18,
    y: 110.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 95.67,
    y: 111.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.72,
    y: 112.34,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-132"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.33,
    y: 131.43,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.81,
    y: 132.55,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.97,
    y: 132.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.08,
    y: 130.36,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 95.88,
    y: 130.32,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.44,
    y: 132.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.01,
    y: 131.55,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.16,
    y: 131.55,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.33,
    y: 125.75,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.81,
    y: 126.87,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.97,
    y: 126.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 97.03,
    y: 129.35,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.33,
    y: 129.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.76,
    y: 128.2,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.08,
    y: 124.68,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 95.88,
    y: 124.64,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.99,
    y: 128.08,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.44,
    y: 126.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.01,
    y: 125.87,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.18,
    y: 127.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.16,
    y: 125.87,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 95.67,
    y: 128.35,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.72,
    y: 129.39,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.81,
    y: 121.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.97,
    y: 121.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 97.03,
    y: 123.67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.33,
    y: 123.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.76,
    y: 122.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.99,
    y: 122.39,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.44,
    y: 121.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.18,
    y: 122.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 95.67,
    y: 122.66,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.72,
    y: 123.71,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-137"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.93,
    y: 85.96,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.41,
    y: 87.08,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.57,
    y: 87.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.68,
    y: 84.9,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.48,
    y: 84.85,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.04,
    y: 87.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.61,
    y: 86.09,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.76,
    y: 86.09,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.93,
    y: 80.28,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.41,
    y: 81.4,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.57,
    y: 81.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.63,
    y: 83.89,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.93,
    y: 84.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.36,
    y: 82.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.68,
    y: 79.21,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.48,
    y: 79.17,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.58,
    y: 82.61,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.04,
    y: 81.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.61,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.78,
    y: 82.52,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.76,
    y: 80.4,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.27,
    y: 82.88,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 79.32,
    y: 83.93,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.41,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.57,
    y: 75.68,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.63,
    y: 78.2,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.93,
    y: 78.37,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.36,
    y: 77.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.58,
    y: 76.93,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.04,
    y: 75.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.78,
    y: 76.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.27,
    y: 77.2,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 79.32,
    y: 78.24,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-134"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.93,
    y: 97.33,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.41,
    y: 98.45,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.57,
    y: 98.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.68,
    y: 96.26,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.48,
    y: 96.22,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.04,
    y: 98.57,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.61,
    y: 97.45,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.76,
    y: 97.45,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.93,
    y: 91.65,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.41,
    y: 92.77,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.57,
    y: 92.73,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.63,
    y: 95.25,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.93,
    y: 95.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.36,
    y: 94.1,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.68,
    y: 90.58,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.48,
    y: 90.54,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.58,
    y: 93.98,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.04,
    y: 92.89,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.61,
    y: 91.77,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.78,
    y: 93.89,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.76,
    y: 91.77,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.27,
    y: 94.25,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 79.32,
    y: 95.29,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.41,
    y: 87.08,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.57,
    y: 87.05,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.63,
    y: 89.57,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.93,
    y: 89.74,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.36,
    y: 88.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.58,
    y: 88.29,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.04,
    y: 87.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.78,
    y: 88.2,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.27,
    y: 88.56,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 79.32,
    y: 89.61,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-138"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.93,
    y: 108.7,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.41,
    y: 109.82,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.57,
    y: 109.79,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.68,
    y: 107.63,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.48,
    y: 107.59,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.04,
    y: 109.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.61,
    y: 108.82,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.76,
    y: 108.82,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.93,
    y: 103.01,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.41,
    y: 104.13,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.57,
    y: 104.1,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.63,
    y: 106.62,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.93,
    y: 106.79,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.36,
    y: 105.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.68,
    y: 101.95,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.48,
    y: 101.9,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.58,
    y: 105.34,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.04,
    y: 104.26,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.61,
    y: 103.14,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.78,
    y: 105.25,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.76,
    y: 103.14,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.27,
    y: 105.61,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 79.32,
    y: 106.66,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.41,
    y: 98.45,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.57,
    y: 98.42,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.63,
    y: 100.94,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.93,
    y: 101.1,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.36,
    y: 99.78,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.58,
    y: 99.66,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.04,
    y: 98.57,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.78,
    y: 99.57,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.27,
    y: 99.93,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 79.32,
    y: 100.98,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-136"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.93,
    y: 120.06,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.41,
    y: 121.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.57,
    y: 121.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.68,
    y: 119,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.48,
    y: 118.95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.04,
    y: 121.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.61,
    y: 120.19,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.76,
    y: 120.19,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.93,
    y: 114.38,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.41,
    y: 115.5,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.57,
    y: 115.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.63,
    y: 117.99,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.93,
    y: 118.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.36,
    y: 116.83,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.68,
    y: 113.31,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.48,
    y: 113.27,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.58,
    y: 116.71,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.04,
    y: 115.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.61,
    y: 114.5,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.78,
    y: 116.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.76,
    y: 114.5,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.27,
    y: 116.98,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 79.32,
    y: 118.03,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.41,
    y: 109.82,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.57,
    y: 109.79,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.63,
    y: 112.3,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.93,
    y: 112.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.36,
    y: 111.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.58,
    y: 111.03,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.04,
    y: 109.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.78,
    y: 110.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.27,
    y: 111.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 79.32,
    y: 112.34,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-141"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.93,
    y: 131.43,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.41,
    y: 132.55,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.57,
    y: 132.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.68,
    y: 130.36,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.48,
    y: 130.32,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.04,
    y: 132.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.61,
    y: 131.55,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.76,
    y: 131.55,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.93,
    y: 125.75,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.41,
    y: 126.87,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.57,
    y: 126.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.63,
    y: 129.35,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.93,
    y: 129.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.36,
    y: 128.2,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.68,
    y: 124.68,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.48,
    y: 124.64,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.58,
    y: 128.08,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.04,
    y: 126.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.61,
    y: 125.87,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.78,
    y: 127.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.76,
    y: 125.87,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.27,
    y: 128.35,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 79.32,
    y: 129.39,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.41,
    y: 121.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.57,
    y: 121.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.63,
    y: 123.67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.93,
    y: 123.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.36,
    y: 122.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.58,
    y: 122.39,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.04,
    y: 121.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.78,
    y: 122.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.27,
    y: 122.66,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 79.32,
    y: 123.71,
    width: 1.98,
    height: 0.72
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M140.96,88.75h13.28v24.74c0,2.39-1.94,4.33-4.33,4.33h-4.63c-2.39,0-4.33-1.94-4.33-4.33v-24.74h0Z",
    transform: "translate(295.19 206.57) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M140.61,92.77c0-2.41,1.97-4.37,4.38-4.37h5.22c2.42,0,4.38,1.96,4.38,4.37v25.4h-13.98v-25.4ZM153.89,92.77c0-2.02-1.65-3.67-3.68-3.67h-5.22c-2.03,0-3.68,1.65-3.68,3.67v24.7h12.58v-24.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 140.96,
    y: 97.62,
    width: 13.28,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 147.25,
    y: 98.19,
    width: 0.7,
    height: 19.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 140.96,
    y: 103.6,
    width: 13.28,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 140.96,
    y: 110.63,
    width: 13.28,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M95.11,88.75h13.28v24.74c0,2.39-1.94,4.33-4.33,4.33h-4.63c-2.39,0-4.33-1.94-4.33-4.33v-24.74h0Z",
    transform: "translate(203.5 206.57) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M94.76,92.77c0-2.41,1.97-4.37,4.38-4.37h5.22c2.42,0,4.38,1.96,4.38,4.37v25.4h-13.98v-25.4ZM108.04,92.77c0-2.02-1.65-3.67-3.68-3.67h-5.22c-2.03,0-3.68,1.65-3.68,3.67v24.7h12.58v-24.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 95.11,
    y: 97.62,
    width: 13.28,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 101.4,
    y: 98.19,
    width: 0.7,
    height: 19.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 95.11,
    y: 103.6,
    width: 13.28,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 95.11,
    y: 110.63,
    width: 13.28,
    height: 0.7
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 86.02,
    y: 121.47,
    width: 77.81,
    height: 6.42,
    transform: "translate(249.84 249.35) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-140"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-135"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.75,
    y: 120.06,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 158.22,
    y: 121.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 165.38,
    y: 121.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 158.5,
    y: 119,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 164.3,
    y: 118.95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 162.85,
    y: 121.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 166.42,
    y: 120.19,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 157.58,
    y: 120.19,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.75,
    y: 114.38,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 158.22,
    y: 115.5,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 165.38,
    y: 115.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 165.45,
    y: 117.99,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.75,
    y: 118.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 157.18,
    y: 116.83,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 158.5,
    y: 113.31,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 164.3,
    y: 113.27,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.4,
    y: 116.71,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 162.85,
    y: 115.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 166.42,
    y: 114.5,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 166.6,
    y: 116.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 157.58,
    y: 114.5,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 164.09,
    y: 116.98,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 159.13,
    y: 118.03,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 158.22,
    y: 109.82,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 165.38,
    y: 109.79,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 165.45,
    y: 112.3,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.75,
    y: 112.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 157.18,
    y: 111.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.4,
    y: 111.03,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 162.85,
    y: 109.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 166.6,
    y: 110.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 164.09,
    y: 111.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 159.13,
    y: 112.34,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-146"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.75,
    y: 131.43,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 158.22,
    y: 132.55,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 165.38,
    y: 132.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 158.5,
    y: 130.36,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 164.3,
    y: 130.32,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 162.85,
    y: 132.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 166.42,
    y: 131.55,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 157.58,
    y: 131.55,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.75,
    y: 125.75,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 158.22,
    y: 126.87,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 165.38,
    y: 126.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 165.45,
    y: 129.35,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.75,
    y: 129.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 157.18,
    y: 128.2,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 158.5,
    y: 124.68,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 164.3,
    y: 124.64,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.4,
    y: 128.08,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 162.85,
    y: 126.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 166.42,
    y: 125.87,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 166.6,
    y: 127.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 157.58,
    y: 125.87,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 164.09,
    y: 128.35,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 159.13,
    y: 129.39,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 158.22,
    y: 121.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 165.38,
    y: 121.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 165.45,
    y: 123.67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.75,
    y: 123.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 157.18,
    y: 122.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 161.4,
    y: 122.39,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 162.85,
    y: 121.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 166.6,
    y: 122.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 164.09,
    y: 122.66,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 159.13,
    y: 123.71,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-145"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.34,
    y: 120.06,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.82,
    y: 121.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 153.98,
    y: 121.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.09,
    y: 119,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 152.89,
    y: 118.95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 151.45,
    y: 121.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 155.02,
    y: 120.19,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.18,
    y: 120.19,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.34,
    y: 114.38,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.82,
    y: 115.5,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 153.98,
    y: 115.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 154.05,
    y: 117.99,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.34,
    y: 118.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.78,
    y: 116.83,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.09,
    y: 113.31,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 152.89,
    y: 113.27,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150,
    y: 116.71,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 151.45,
    y: 115.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 155.02,
    y: 114.5,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 155.2,
    y: 116.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.18,
    y: 114.5,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 152.68,
    y: 116.98,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.73,
    y: 118.03,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.82,
    y: 109.82,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 153.98,
    y: 109.79,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 154.05,
    y: 112.3,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.34,
    y: 112.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.78,
    y: 111.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150,
    y: 111.03,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 151.45,
    y: 109.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 155.2,
    y: 110.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 152.68,
    y: 111.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.73,
    y: 112.34,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-148"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.34,
    y: 131.43,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.82,
    y: 132.55,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 153.98,
    y: 132.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.09,
    y: 130.36,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 152.89,
    y: 130.32,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 151.45,
    y: 132.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 155.02,
    y: 131.55,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.18,
    y: 131.55,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.34,
    y: 125.75,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.82,
    y: 126.87,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 153.98,
    y: 126.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 154.05,
    y: 129.35,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.34,
    y: 129.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.78,
    y: 128.2,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.09,
    y: 124.68,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 152.89,
    y: 124.64,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150,
    y: 128.08,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 151.45,
    y: 126.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 155.02,
    y: 125.87,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 155.2,
    y: 127.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.18,
    y: 125.87,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 152.68,
    y: 128.35,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.73,
    y: 129.39,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 146.82,
    y: 121.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 153.98,
    y: 121.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 154.05,
    y: 123.67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150.34,
    y: 123.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 145.78,
    y: 122.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 150,
    y: 122.39,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 151.45,
    y: 121.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 155.2,
    y: 122.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 152.68,
    y: 122.66,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 147.73,
    y: 123.71,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-147"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.94,
    y: 120.06,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.42,
    y: 121.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.58,
    y: 121.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.69,
    y: 119,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.49,
    y: 118.95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 140.05,
    y: 121.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.62,
    y: 120.19,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.77,
    y: 120.19,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.94,
    y: 114.38,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.42,
    y: 115.5,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.58,
    y: 115.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.64,
    y: 117.99,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.94,
    y: 118.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.37,
    y: 116.83,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.69,
    y: 113.31,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.49,
    y: 113.27,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.6,
    y: 116.71,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 140.05,
    y: 115.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.62,
    y: 114.5,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.79,
    y: 116.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.77,
    y: 114.5,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.28,
    y: 116.98,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 136.33,
    y: 118.03,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.42,
    y: 109.82,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.58,
    y: 109.79,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.64,
    y: 112.3,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.94,
    y: 112.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.37,
    y: 111.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.6,
    y: 111.03,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 140.05,
    y: 109.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.79,
    y: 110.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.28,
    y: 111.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 136.33,
    y: 112.34,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-143"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.94,
    y: 131.43,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.42,
    y: 132.55,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.58,
    y: 132.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.69,
    y: 130.36,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.49,
    y: 130.32,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 140.05,
    y: 132.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.62,
    y: 131.55,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.77,
    y: 131.55,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.94,
    y: 125.75,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.42,
    y: 126.87,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.58,
    y: 126.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.64,
    y: 129.35,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.94,
    y: 129.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.37,
    y: 128.2,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.69,
    y: 124.68,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.49,
    y: 124.64,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.6,
    y: 128.08,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 140.05,
    y: 126.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.62,
    y: 125.87,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.79,
    y: 127.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.77,
    y: 125.87,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.28,
    y: 128.35,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 136.33,
    y: 129.39,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 135.42,
    y: 121.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.58,
    y: 121.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 142.64,
    y: 123.67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.94,
    y: 123.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 134.37,
    y: 122.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.6,
    y: 122.39,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 140.05,
    y: 121.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 143.79,
    y: 122.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 141.28,
    y: 122.66,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 136.33,
    y: 123.71,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-150"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.54,
    y: 120.06,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.02,
    y: 121.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.18,
    y: 121.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.29,
    y: 119,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.09,
    y: 118.95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 128.65,
    y: 121.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.22,
    y: 120.19,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 123.37,
    y: 120.19,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.54,
    y: 114.38,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.02,
    y: 115.5,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.18,
    y: 115.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.24,
    y: 117.99,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.54,
    y: 118.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.97,
    y: 116.83,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.29,
    y: 113.31,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.09,
    y: 113.27,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.19,
    y: 116.71,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 128.65,
    y: 115.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.22,
    y: 114.5,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.39,
    y: 116.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 123.37,
    y: 114.5,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 129.88,
    y: 116.98,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.93,
    y: 118.03,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.02,
    y: 109.82,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.18,
    y: 109.79,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.24,
    y: 112.3,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.54,
    y: 112.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.97,
    y: 111.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.19,
    y: 111.03,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 128.65,
    y: 109.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.39,
    y: 110.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 129.88,
    y: 111.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.93,
    y: 112.34,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-151"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.54,
    y: 131.43,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.02,
    y: 132.55,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.18,
    y: 132.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.29,
    y: 130.36,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.09,
    y: 130.32,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 128.65,
    y: 132.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.22,
    y: 131.55,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 123.37,
    y: 131.55,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.54,
    y: 125.75,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.02,
    y: 126.87,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.18,
    y: 126.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.24,
    y: 129.35,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.54,
    y: 129.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.97,
    y: 128.2,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.29,
    y: 124.68,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 130.09,
    y: 124.64,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.19,
    y: 128.08,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 128.65,
    y: 126.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.22,
    y: 125.87,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.39,
    y: 127.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 123.37,
    y: 125.87,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 129.88,
    y: 128.35,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.93,
    y: 129.39,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.02,
    y: 121.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.18,
    y: 121.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 131.24,
    y: 123.67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.54,
    y: 123.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 122.97,
    y: 122.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 127.19,
    y: 122.39,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 128.65,
    y: 121.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.39,
    y: 122.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 129.88,
    y: 122.66,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 124.93,
    y: 123.71,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-149"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.14,
    y: 120.06,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.61,
    y: 121.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.77,
    y: 121.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.89,
    y: 119,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.69,
    y: 118.95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 117.24,
    y: 121.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 120.81,
    y: 120.19,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.97,
    y: 120.19,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.14,
    y: 114.38,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.61,
    y: 115.5,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.77,
    y: 115.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.84,
    y: 117.99,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.14,
    y: 118.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.57,
    y: 116.83,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.89,
    y: 113.31,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.69,
    y: 113.27,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 115.79,
    y: 116.71,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 117.24,
    y: 115.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 120.81,
    y: 114.5,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 120.99,
    y: 116.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.97,
    y: 114.5,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.48,
    y: 116.98,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 113.52,
    y: 118.03,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.61,
    y: 109.82,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.77,
    y: 109.79,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.84,
    y: 112.3,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.14,
    y: 112.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.57,
    y: 111.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 115.79,
    y: 111.03,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 117.24,
    y: 109.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 120.99,
    y: 110.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.48,
    y: 111.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 113.52,
    y: 112.34,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-142"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.14,
    y: 131.43,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.61,
    y: 132.55,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.77,
    y: 132.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.89,
    y: 130.36,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.69,
    y: 130.32,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 117.24,
    y: 132.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 120.81,
    y: 131.55,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.97,
    y: 131.55,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.14,
    y: 125.75,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.61,
    y: 126.87,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.77,
    y: 126.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.84,
    y: 129.35,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.14,
    y: 129.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.57,
    y: 128.2,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.89,
    y: 124.68,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.69,
    y: 124.64,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 115.79,
    y: 128.08,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 117.24,
    y: 126.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 120.81,
    y: 125.87,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 120.99,
    y: 127.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.97,
    y: 125.87,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.48,
    y: 128.35,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 113.52,
    y: 129.39,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 112.61,
    y: 121.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.77,
    y: 121.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 119.84,
    y: 123.67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 116.14,
    y: 123.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 111.57,
    y: 122.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 115.79,
    y: 122.39,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 117.24,
    y: 121.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 120.99,
    y: 122.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 118.48,
    y: 122.66,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 113.52,
    y: 123.71,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-144"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.73,
    y: 120.06,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.21,
    y: 121.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.37,
    y: 121.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.48,
    y: 119,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.28,
    y: 118.95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 105.84,
    y: 121.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.41,
    y: 120.19,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.57,
    y: 120.19,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.73,
    y: 114.38,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.21,
    y: 115.5,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.37,
    y: 115.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.44,
    y: 117.99,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.73,
    y: 118.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.17,
    y: 116.83,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.48,
    y: 113.31,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.28,
    y: 113.27,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.39,
    y: 116.71,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 105.84,
    y: 115.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.41,
    y: 114.5,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.59,
    y: 116.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.57,
    y: 114.5,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.07,
    y: 116.98,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 102.12,
    y: 118.03,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.21,
    y: 109.82,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.37,
    y: 109.79,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.44,
    y: 112.3,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.73,
    y: 112.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.17,
    y: 111.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.39,
    y: 111.03,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 105.84,
    y: 109.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.59,
    y: 110.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.07,
    y: 111.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 102.12,
    y: 112.34,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-174"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.73,
    y: 131.43,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.21,
    y: 132.55,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.37,
    y: 132.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.48,
    y: 130.36,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.28,
    y: 130.32,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 105.84,
    y: 132.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.41,
    y: 131.55,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.57,
    y: 131.55,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.73,
    y: 125.75,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.21,
    y: 126.87,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.37,
    y: 126.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.44,
    y: 129.35,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.73,
    y: 129.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.17,
    y: 128.2,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.48,
    y: 124.68,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.28,
    y: 124.64,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.39,
    y: 128.08,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 105.84,
    y: 126.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.41,
    y: 125.87,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.59,
    y: 127.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.57,
    y: 125.87,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.07,
    y: 128.35,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 102.12,
    y: 129.39,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 101.21,
    y: 121.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.37,
    y: 121.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 108.44,
    y: 123.67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.73,
    y: 123.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 100.17,
    y: 122.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 104.39,
    y: 122.39,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 105.84,
    y: 121.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 109.59,
    y: 122.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 107.07,
    y: 122.66,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 102.12,
    y: 123.71,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-177"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.33,
    y: 120.06,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.81,
    y: 121.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.97,
    y: 121.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.08,
    y: 119,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 95.88,
    y: 118.95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.44,
    y: 121.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.01,
    y: 120.19,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.16,
    y: 120.19,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.33,
    y: 114.38,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.81,
    y: 115.5,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.97,
    y: 115.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 97.03,
    y: 117.99,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.33,
    y: 118.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.76,
    y: 116.83,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.08,
    y: 113.31,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 95.88,
    y: 113.27,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.99,
    y: 116.71,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.44,
    y: 115.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.01,
    y: 114.5,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.18,
    y: 116.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.16,
    y: 114.5,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 95.67,
    y: 116.98,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.72,
    y: 118.03,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.81,
    y: 109.82,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.97,
    y: 109.79,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 97.03,
    y: 112.3,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.33,
    y: 112.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.76,
    y: 111.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.99,
    y: 111.03,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.44,
    y: 109.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.18,
    y: 110.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 95.67,
    y: 111.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.72,
    y: 112.34,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-176"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.33,
    y: 131.43,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.81,
    y: 132.55,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.97,
    y: 132.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.08,
    y: 130.36,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 95.88,
    y: 130.32,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.44,
    y: 132.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.01,
    y: 131.55,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.16,
    y: 131.55,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.33,
    y: 125.75,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.81,
    y: 126.87,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.97,
    y: 126.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 97.03,
    y: 129.35,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.33,
    y: 129.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.76,
    y: 128.2,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.08,
    y: 124.68,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 95.88,
    y: 124.64,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.99,
    y: 128.08,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.44,
    y: 126.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.01,
    y: 125.87,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.18,
    y: 127.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.16,
    y: 125.87,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 95.67,
    y: 128.35,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.72,
    y: 129.39,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.81,
    y: 121.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 96.97,
    y: 121.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 97.03,
    y: 123.67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.33,
    y: 123.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.76,
    y: 122.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.99,
    y: 122.39,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.44,
    y: 121.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 98.18,
    y: 122.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 95.67,
    y: 122.66,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.72,
    y: 123.71,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-178"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.93,
    y: 120.06,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.41,
    y: 121.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.57,
    y: 121.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.68,
    y: 119,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.48,
    y: 118.95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.04,
    y: 121.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.61,
    y: 120.19,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.76,
    y: 120.19,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.93,
    y: 114.38,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.41,
    y: 115.5,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.57,
    y: 115.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.63,
    y: 117.99,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.93,
    y: 118.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.36,
    y: 116.83,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.68,
    y: 113.31,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.48,
    y: 113.27,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.58,
    y: 116.71,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.04,
    y: 115.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.61,
    y: 114.5,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.78,
    y: 116.62,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.76,
    y: 114.5,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.27,
    y: 116.98,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 79.32,
    y: 118.03,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.41,
    y: 109.82,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.57,
    y: 109.79,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.63,
    y: 112.3,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.93,
    y: 112.47,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.36,
    y: 111.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.58,
    y: 111.03,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.04,
    y: 109.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.78,
    y: 110.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.27,
    y: 111.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 79.32,
    y: 112.34,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-179"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.93,
    y: 131.43,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.41,
    y: 132.55,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.57,
    y: 132.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.68,
    y: 130.36,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.48,
    y: 130.32,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.04,
    y: 132.67,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.61,
    y: 131.55,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.76,
    y: 131.55,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.93,
    y: 125.75,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.41,
    y: 126.87,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.57,
    y: 126.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.63,
    y: 129.35,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.93,
    y: 129.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.36,
    y: 128.2,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.68,
    y: 124.68,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.48,
    y: 124.64,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.58,
    y: 128.08,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.04,
    y: 126.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.61,
    y: 125.87,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.78,
    y: 127.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.76,
    y: 125.87,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.27,
    y: 128.35,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 79.32,
    y: 129.39,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.41,
    y: 121.18,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.57,
    y: 121.15,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.63,
    y: 123.67,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.93,
    y: 123.84,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.36,
    y: 122.52,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.58,
    y: 122.39,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.04,
    y: 121.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.78,
    y: 122.3,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.27,
    y: 122.66,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 79.32,
    y: 123.71,
    width: 1.98,
    height: 0.72
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-196",
    points: "80.05 87.03 169.79 87.03 163.42 72.31 86.42 72.31 80.05 87.03"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 14.06,
    y: 76.83,
    width: 74.57,
    height: 52.62,
    transform: "translate(102.69 206.29) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-175"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-181"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.74,
    y: 82.51,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.22,
    y: 83.63,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.38,
    y: 83.6,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.49,
    y: 81.45,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.29,
    y: 81.4,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.85,
    y: 83.76,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.42,
    y: 82.64,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.57,
    y: 82.64,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.74,
    y: 76.83,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.22,
    y: 77.95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.38,
    y: 77.92,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.45,
    y: 80.44,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.74,
    y: 80.6,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.17,
    y: 79.28,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.49,
    y: 75.76,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.29,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.4,
    y: 79.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.85,
    y: 78.07,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.42,
    y: 76.95,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.59,
    y: 79.07,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.57,
    y: 76.95,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.08,
    y: 79.43,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 87.13,
    y: 80.48,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.22,
    y: 72.27,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.38,
    y: 72.24,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.45,
    y: 74.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.74,
    y: 74.92,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.17,
    y: 73.6,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.4,
    y: 73.48,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.85,
    y: 72.39,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.59,
    y: 73.39,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.08,
    y: 73.75,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 87.13,
    y: 74.79,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-183"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.74,
    y: 93.88,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.22,
    y: 95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.38,
    y: 94.97,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.49,
    y: 92.81,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.29,
    y: 92.77,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.85,
    y: 95.12,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.42,
    y: 94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.57,
    y: 94,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.74,
    y: 88.2,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.22,
    y: 89.32,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.38,
    y: 89.29,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.45,
    y: 91.8,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.74,
    y: 91.97,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.17,
    y: 90.65,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.49,
    y: 87.13,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.29,
    y: 87.09,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.4,
    y: 90.53,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.85,
    y: 89.44,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.42,
    y: 88.32,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.59,
    y: 90.44,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.57,
    y: 88.32,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.08,
    y: 90.8,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 87.13,
    y: 91.84,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.22,
    y: 83.63,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.38,
    y: 83.6,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.45,
    y: 86.12,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.74,
    y: 86.29,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.17,
    y: 84.97,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.4,
    y: 84.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.85,
    y: 83.76,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.59,
    y: 84.75,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.08,
    y: 85.11,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 87.13,
    y: 86.16,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-182"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.74,
    y: 105.25,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.22,
    y: 106.37,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.38,
    y: 106.34,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.49,
    y: 104.18,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.29,
    y: 104.14,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.85,
    y: 106.49,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.42,
    y: 105.37,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.57,
    y: 105.37,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.74,
    y: 99.57,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.22,
    y: 100.68,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.38,
    y: 100.65,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.45,
    y: 103.17,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.74,
    y: 103.34,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.17,
    y: 102.02,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.49,
    y: 98.5,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.29,
    y: 98.45,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.4,
    y: 101.89,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.85,
    y: 100.81,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.42,
    y: 99.69,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.59,
    y: 101.8,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.57,
    y: 99.69,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.08,
    y: 102.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 87.13,
    y: 103.21,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.22,
    y: 95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.38,
    y: 94.97,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.45,
    y: 97.49,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.74,
    y: 97.65,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.17,
    y: 96.34,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.4,
    y: 96.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.85,
    y: 95.12,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.59,
    y: 96.12,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.08,
    y: 96.48,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 87.13,
    y: 97.53,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-180"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.74,
    y: 116.62,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.22,
    y: 117.74,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.38,
    y: 117.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.49,
    y: 115.55,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.29,
    y: 115.51,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.85,
    y: 117.86,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.42,
    y: 116.74,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.57,
    y: 116.74,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.74,
    y: 110.93,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.22,
    y: 112.05,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.38,
    y: 112.02,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.45,
    y: 114.54,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.74,
    y: 114.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.17,
    y: 113.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.49,
    y: 109.86,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.29,
    y: 109.82,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.4,
    y: 113.26,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.85,
    y: 112.17,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.42,
    y: 111.05,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.59,
    y: 113.17,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.57,
    y: 111.05,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.08,
    y: 113.53,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 87.13,
    y: 114.58,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.22,
    y: 106.37,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.38,
    y: 106.34,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.45,
    y: 108.85,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.74,
    y: 109.02,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.17,
    y: 107.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.4,
    y: 107.58,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.85,
    y: 106.49,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.59,
    y: 107.49,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.08,
    y: 107.85,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 87.13,
    y: 108.89,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-184"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.74,
    y: 127.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.22,
    y: 129.1,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.38,
    y: 129.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.49,
    y: 126.91,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.29,
    y: 126.87,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.85,
    y: 129.22,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.42,
    y: 128.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.57,
    y: 128.1,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.74,
    y: 122.3,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.22,
    y: 123.42,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.38,
    y: 123.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.45,
    y: 125.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.74,
    y: 126.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.17,
    y: 124.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.49,
    y: 121.23,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.29,
    y: 121.19,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.4,
    y: 124.63,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.85,
    y: 123.54,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.42,
    y: 122.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.59,
    y: 124.54,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.57,
    y: 122.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.08,
    y: 124.9,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 87.13,
    y: 125.94,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.22,
    y: 117.74,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.38,
    y: 117.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.45,
    y: 120.22,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.74,
    y: 120.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.17,
    y: 119.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.4,
    y: 118.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.85,
    y: 117.86,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.59,
    y: 118.85,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.08,
    y: 119.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 87.13,
    y: 120.26,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-186"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.34,
    y: 82.51,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.82,
    y: 83.63,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.98,
    y: 83.6,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.09,
    y: 81.45,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.89,
    y: 81.4,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 79.45,
    y: 83.76,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.02,
    y: 82.64,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.17,
    y: 82.64,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.34,
    y: 76.83,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.82,
    y: 77.95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.98,
    y: 77.92,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 82.04,
    y: 80.44,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.34,
    y: 80.6,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.77,
    y: 79.28,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.09,
    y: 75.76,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.89,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.99,
    y: 79.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 79.45,
    y: 78.07,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.02,
    y: 76.95,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.19,
    y: 79.07,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.17,
    y: 76.95,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.68,
    y: 79.43,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.73,
    y: 80.48,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.82,
    y: 72.27,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.98,
    y: 72.24,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 82.04,
    y: 74.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.34,
    y: 74.92,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.77,
    y: 73.6,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.99,
    y: 73.48,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 79.45,
    y: 72.39,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.19,
    y: 73.39,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.68,
    y: 73.75,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.73,
    y: 74.79,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-185"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.34,
    y: 93.88,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.82,
    y: 95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.98,
    y: 94.97,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.09,
    y: 92.81,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.89,
    y: 92.77,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 79.45,
    y: 95.12,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.02,
    y: 94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.17,
    y: 94,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.34,
    y: 88.2,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.82,
    y: 89.32,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.98,
    y: 89.29,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 82.04,
    y: 91.8,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.34,
    y: 91.97,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.77,
    y: 90.65,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.09,
    y: 87.13,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.89,
    y: 87.09,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.99,
    y: 90.53,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 79.45,
    y: 89.44,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.02,
    y: 88.32,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.19,
    y: 90.44,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.17,
    y: 88.32,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.68,
    y: 90.8,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.73,
    y: 91.84,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.82,
    y: 83.63,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.98,
    y: 83.6,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 82.04,
    y: 86.12,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.34,
    y: 86.29,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.77,
    y: 84.97,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.99,
    y: 84.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 79.45,
    y: 83.76,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.19,
    y: 84.75,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.68,
    y: 85.11,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.73,
    y: 86.16,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-188"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.34,
    y: 105.25,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.82,
    y: 106.37,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.98,
    y: 106.34,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.09,
    y: 104.18,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.89,
    y: 104.14,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 79.45,
    y: 106.49,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.02,
    y: 105.37,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.17,
    y: 105.37,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.34,
    y: 99.57,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.82,
    y: 100.68,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.98,
    y: 100.65,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 82.04,
    y: 103.17,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.34,
    y: 103.34,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.77,
    y: 102.02,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.09,
    y: 98.5,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.89,
    y: 98.45,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.99,
    y: 101.89,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 79.45,
    y: 100.81,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.02,
    y: 99.69,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.19,
    y: 101.8,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.17,
    y: 99.69,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.68,
    y: 102.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.73,
    y: 103.21,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.82,
    y: 95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.98,
    y: 94.97,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 82.04,
    y: 97.49,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.34,
    y: 97.65,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.77,
    y: 96.34,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.99,
    y: 96.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 79.45,
    y: 95.12,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.19,
    y: 96.12,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.68,
    y: 96.48,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.73,
    y: 97.53,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-187"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.34,
    y: 116.62,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.82,
    y: 117.74,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.98,
    y: 117.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.09,
    y: 115.55,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.89,
    y: 115.51,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 79.45,
    y: 117.86,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.02,
    y: 116.74,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.17,
    y: 116.74,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.34,
    y: 110.93,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.82,
    y: 112.05,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.98,
    y: 112.02,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 82.04,
    y: 114.54,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.34,
    y: 114.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.77,
    y: 113.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.09,
    y: 109.86,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.89,
    y: 109.82,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.99,
    y: 113.26,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 79.45,
    y: 112.17,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.02,
    y: 111.05,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.19,
    y: 113.17,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.17,
    y: 111.05,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.68,
    y: 113.53,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.73,
    y: 114.58,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.82,
    y: 106.37,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.98,
    y: 106.34,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 82.04,
    y: 108.85,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.34,
    y: 109.02,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.77,
    y: 107.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.99,
    y: 107.58,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 79.45,
    y: 106.49,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.19,
    y: 107.49,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.68,
    y: 107.85,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.73,
    y: 108.89,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-193"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.34,
    y: 127.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.82,
    y: 129.1,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.98,
    y: 129.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.09,
    y: 126.91,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.89,
    y: 126.87,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 79.45,
    y: 129.22,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.02,
    y: 128.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.17,
    y: 128.1,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.34,
    y: 122.3,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.82,
    y: 123.42,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.98,
    y: 123.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 82.04,
    y: 125.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.34,
    y: 126.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.77,
    y: 124.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.09,
    y: 121.23,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.89,
    y: 121.19,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.99,
    y: 124.63,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 79.45,
    y: 123.54,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.02,
    y: 122.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.19,
    y: 124.54,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.17,
    y: 122.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.68,
    y: 124.9,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.73,
    y: 125.94,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.82,
    y: 117.74,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 81.98,
    y: 117.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 82.04,
    y: 120.22,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.34,
    y: 120.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.77,
    y: 119.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 77.99,
    y: 118.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 79.45,
    y: 117.86,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.19,
    y: 118.85,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.68,
    y: 119.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.73,
    y: 120.26,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-189"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.94,
    y: 82.51,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.41,
    y: 83.63,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.57,
    y: 83.6,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.69,
    y: 81.45,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.49,
    y: 81.4,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.04,
    y: 83.76,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 71.61,
    y: 82.64,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.77,
    y: 82.64,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.94,
    y: 76.83,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.41,
    y: 77.95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.57,
    y: 77.92,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.64,
    y: 80.44,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.94,
    y: 80.6,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.37,
    y: 79.28,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.69,
    y: 75.76,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.49,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.59,
    y: 79.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.04,
    y: 78.07,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 71.61,
    y: 76.95,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 71.79,
    y: 79.07,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.77,
    y: 76.95,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.28,
    y: 79.43,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 64.32,
    y: 80.48,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.41,
    y: 72.27,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.57,
    y: 72.24,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.64,
    y: 74.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.94,
    y: 74.92,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.37,
    y: 73.6,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.59,
    y: 73.48,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.04,
    y: 72.39,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 71.79,
    y: 73.39,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.28,
    y: 73.75,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 64.32,
    y: 74.79,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-191"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.94,
    y: 93.88,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.41,
    y: 95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.57,
    y: 94.97,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.69,
    y: 92.81,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.49,
    y: 92.77,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.04,
    y: 95.12,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 71.61,
    y: 94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.77,
    y: 94,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.94,
    y: 88.2,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.41,
    y: 89.32,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.57,
    y: 89.29,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.64,
    y: 91.8,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.94,
    y: 91.97,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.37,
    y: 90.65,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.69,
    y: 87.13,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.49,
    y: 87.09,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.59,
    y: 90.53,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.04,
    y: 89.44,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 71.61,
    y: 88.32,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 71.79,
    y: 90.44,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.77,
    y: 88.32,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.28,
    y: 90.8,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 64.32,
    y: 91.84,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.41,
    y: 83.63,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.57,
    y: 83.6,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.64,
    y: 86.12,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.94,
    y: 86.29,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.37,
    y: 84.97,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.59,
    y: 84.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.04,
    y: 83.76,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 71.79,
    y: 84.75,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.28,
    y: 85.11,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 64.32,
    y: 86.16,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-192"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.94,
    y: 105.25,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.41,
    y: 106.37,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.57,
    y: 106.34,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.69,
    y: 104.18,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.49,
    y: 104.14,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.04,
    y: 106.49,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 71.61,
    y: 105.37,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.77,
    y: 105.37,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.94,
    y: 99.57,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.41,
    y: 100.68,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.57,
    y: 100.65,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.64,
    y: 103.17,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.94,
    y: 103.34,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.37,
    y: 102.02,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.69,
    y: 98.5,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.49,
    y: 98.45,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.59,
    y: 101.89,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.04,
    y: 100.81,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 71.61,
    y: 99.69,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 71.79,
    y: 101.8,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.77,
    y: 99.69,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.28,
    y: 102.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 64.32,
    y: 103.21,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.41,
    y: 95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.57,
    y: 94.97,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.64,
    y: 97.49,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.94,
    y: 97.65,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.37,
    y: 96.34,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.59,
    y: 96.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.04,
    y: 95.12,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 71.79,
    y: 96.12,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.28,
    y: 96.48,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 64.32,
    y: 97.53,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-190"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.94,
    y: 116.62,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.41,
    y: 117.74,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.57,
    y: 117.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.69,
    y: 115.55,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.49,
    y: 115.51,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.04,
    y: 117.86,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 71.61,
    y: 116.74,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.77,
    y: 116.74,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.94,
    y: 110.93,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.41,
    y: 112.05,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.57,
    y: 112.02,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.64,
    y: 114.54,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.94,
    y: 114.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.37,
    y: 113.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.69,
    y: 109.86,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.49,
    y: 109.82,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.59,
    y: 113.26,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.04,
    y: 112.17,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 71.61,
    y: 111.05,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 71.79,
    y: 113.17,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.77,
    y: 111.05,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.28,
    y: 113.53,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 64.32,
    y: 114.58,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.41,
    y: 106.37,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.57,
    y: 106.34,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.64,
    y: 108.85,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.94,
    y: 109.02,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.37,
    y: 107.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.59,
    y: 107.58,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.04,
    y: 106.49,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 71.79,
    y: 107.49,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.28,
    y: 107.85,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 64.32,
    y: 108.89,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-164"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.94,
    y: 127.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.41,
    y: 129.1,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.57,
    y: 129.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.69,
    y: 126.91,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.49,
    y: 126.87,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.04,
    y: 129.22,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 71.61,
    y: 128.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.77,
    y: 128.1,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.94,
    y: 122.3,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.41,
    y: 123.42,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.57,
    y: 123.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.64,
    y: 125.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.94,
    y: 126.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.37,
    y: 124.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.69,
    y: 121.23,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.49,
    y: 121.19,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.59,
    y: 124.63,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.04,
    y: 123.54,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 71.61,
    y: 122.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 71.79,
    y: 124.54,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.77,
    y: 122.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.28,
    y: 124.9,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 64.32,
    y: 125.94,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.41,
    y: 117.74,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.57,
    y: 117.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.64,
    y: 120.22,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.94,
    y: 120.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.37,
    y: 119.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.59,
    y: 118.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.04,
    y: 117.86,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 71.79,
    y: 118.85,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.28,
    y: 119.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 64.32,
    y: 120.26,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-160"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.53,
    y: 82.51,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.01,
    y: 83.63,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.17,
    y: 83.6,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.29,
    y: 81.45,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 58.08,
    y: 81.4,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 56.64,
    y: 83.76,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 60.21,
    y: 82.64,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 51.37,
    y: 82.64,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.53,
    y: 76.83,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.01,
    y: 77.95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.17,
    y: 77.92,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.24,
    y: 80.44,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.53,
    y: 80.6,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.97,
    y: 79.28,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.29,
    y: 75.76,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 58.08,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.19,
    y: 79.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 56.64,
    y: 78.07,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 60.21,
    y: 76.95,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 60.39,
    y: 79.07,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 51.37,
    y: 76.95,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.87,
    y: 79.43,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.92,
    y: 80.48,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.01,
    y: 72.27,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.17,
    y: 72.24,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.24,
    y: 74.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.53,
    y: 74.92,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.97,
    y: 73.6,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.19,
    y: 73.48,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 56.64,
    y: 72.39,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 60.39,
    y: 73.39,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.87,
    y: 73.75,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.92,
    y: 74.79,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-162"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.53,
    y: 93.88,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.01,
    y: 95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.17,
    y: 94.97,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.29,
    y: 92.81,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 58.08,
    y: 92.77,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 56.64,
    y: 95.12,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 60.21,
    y: 94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 51.37,
    y: 94,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.53,
    y: 88.2,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.01,
    y: 89.32,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.17,
    y: 89.29,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.24,
    y: 91.8,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.53,
    y: 91.97,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.97,
    y: 90.65,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.29,
    y: 87.13,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 58.08,
    y: 87.09,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.19,
    y: 90.53,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 56.64,
    y: 89.44,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 60.21,
    y: 88.32,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 60.39,
    y: 90.44,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 51.37,
    y: 88.32,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.87,
    y: 90.8,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.92,
    y: 91.84,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.01,
    y: 83.63,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.17,
    y: 83.6,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.24,
    y: 86.12,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.53,
    y: 86.29,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.97,
    y: 84.97,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.19,
    y: 84.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 56.64,
    y: 83.76,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 60.39,
    y: 84.75,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.87,
    y: 85.11,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.92,
    y: 86.16,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-158"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.53,
    y: 105.25,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.01,
    y: 106.37,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.17,
    y: 106.34,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.29,
    y: 104.18,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 58.08,
    y: 104.14,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 56.64,
    y: 106.49,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 60.21,
    y: 105.37,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 51.37,
    y: 105.37,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.53,
    y: 99.57,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.01,
    y: 100.68,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.17,
    y: 100.65,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.24,
    y: 103.17,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.53,
    y: 103.34,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.97,
    y: 102.02,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.29,
    y: 98.5,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 58.08,
    y: 98.45,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.19,
    y: 101.89,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 56.64,
    y: 100.81,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 60.21,
    y: 99.69,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 60.39,
    y: 101.8,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 51.37,
    y: 99.69,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.87,
    y: 102.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.92,
    y: 103.21,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.01,
    y: 95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.17,
    y: 94.97,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.24,
    y: 97.49,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.53,
    y: 97.65,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.97,
    y: 96.34,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.19,
    y: 96.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 56.64,
    y: 95.12,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 60.39,
    y: 96.12,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.87,
    y: 96.48,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.92,
    y: 97.53,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-159"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.53,
    y: 116.62,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.01,
    y: 117.74,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.17,
    y: 117.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.29,
    y: 115.55,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 58.08,
    y: 115.51,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 56.64,
    y: 117.86,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 60.21,
    y: 116.74,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 51.37,
    y: 116.74,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.53,
    y: 110.93,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.01,
    y: 112.05,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.17,
    y: 112.02,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.24,
    y: 114.54,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.53,
    y: 114.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.97,
    y: 113.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.29,
    y: 109.86,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 58.08,
    y: 109.82,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.19,
    y: 113.26,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 56.64,
    y: 112.17,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 60.21,
    y: 111.05,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 60.39,
    y: 113.17,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 51.37,
    y: 111.05,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.87,
    y: 113.53,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.92,
    y: 114.58,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.01,
    y: 106.37,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.17,
    y: 106.34,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.24,
    y: 108.85,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.53,
    y: 109.02,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.97,
    y: 107.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.19,
    y: 107.58,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 56.64,
    y: 106.49,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 60.39,
    y: 107.49,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.87,
    y: 107.85,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.92,
    y: 108.89,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-165"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.53,
    y: 127.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.01,
    y: 129.1,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.17,
    y: 129.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.29,
    y: 126.91,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 58.08,
    y: 126.87,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 56.64,
    y: 129.22,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 60.21,
    y: 128.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 51.37,
    y: 128.1,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.53,
    y: 122.3,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.01,
    y: 123.42,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.17,
    y: 123.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.24,
    y: 125.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.53,
    y: 126.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.97,
    y: 124.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.29,
    y: 121.23,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 58.08,
    y: 121.19,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.19,
    y: 124.63,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 56.64,
    y: 123.54,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 60.21,
    y: 122.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 60.39,
    y: 124.54,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 51.37,
    y: 122.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.87,
    y: 124.9,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.92,
    y: 125.94,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.01,
    y: 117.74,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.17,
    y: 117.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.24,
    y: 120.22,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.53,
    y: 120.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 50.97,
    y: 119.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.19,
    y: 118.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 56.64,
    y: 117.86,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 60.39,
    y: 118.85,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.87,
    y: 119.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.92,
    y: 120.26,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-166"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.13,
    y: 82.51,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.61,
    y: 83.63,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.77,
    y: 83.6,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.88,
    y: 81.45,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.68,
    y: 81.4,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 45.24,
    y: 83.76,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48.81,
    y: 82.64,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.96,
    y: 82.64,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.13,
    y: 76.83,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.61,
    y: 77.95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.77,
    y: 77.92,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.83,
    y: 80.44,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.13,
    y: 80.6,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.56,
    y: 79.28,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.88,
    y: 75.76,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.68,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 43.79,
    y: 79.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 45.24,
    y: 78.07,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48.81,
    y: 76.95,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48.98,
    y: 79.07,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.96,
    y: 76.95,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.47,
    y: 79.43,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 41.52,
    y: 80.48,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.61,
    y: 72.27,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.77,
    y: 72.24,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.83,
    y: 74.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.13,
    y: 74.92,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.56,
    y: 73.6,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 43.79,
    y: 73.48,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 45.24,
    y: 72.39,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48.98,
    y: 73.39,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.47,
    y: 73.75,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 41.52,
    y: 74.79,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-167"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.13,
    y: 93.88,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.61,
    y: 95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.77,
    y: 94.97,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.88,
    y: 92.81,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.68,
    y: 92.77,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 45.24,
    y: 95.12,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48.81,
    y: 94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.96,
    y: 94,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.13,
    y: 88.2,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.61,
    y: 89.32,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.77,
    y: 89.29,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.83,
    y: 91.8,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.13,
    y: 91.97,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.56,
    y: 90.65,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.88,
    y: 87.13,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.68,
    y: 87.09,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 43.79,
    y: 90.53,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 45.24,
    y: 89.44,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48.81,
    y: 88.32,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48.98,
    y: 90.44,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.96,
    y: 88.32,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.47,
    y: 90.8,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 41.52,
    y: 91.84,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.61,
    y: 83.63,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.77,
    y: 83.6,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.83,
    y: 86.12,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.13,
    y: 86.29,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.56,
    y: 84.97,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 43.79,
    y: 84.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 45.24,
    y: 83.76,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48.98,
    y: 84.75,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.47,
    y: 85.11,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 41.52,
    y: 86.16,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-161"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.13,
    y: 105.25,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.61,
    y: 106.37,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.77,
    y: 106.34,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.88,
    y: 104.18,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.68,
    y: 104.14,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 45.24,
    y: 106.49,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48.81,
    y: 105.37,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.96,
    y: 105.37,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.13,
    y: 99.57,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.61,
    y: 100.68,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.77,
    y: 100.65,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.83,
    y: 103.17,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.13,
    y: 103.34,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.56,
    y: 102.02,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.88,
    y: 98.5,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.68,
    y: 98.45,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 43.79,
    y: 101.89,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 45.24,
    y: 100.81,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48.81,
    y: 99.69,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48.98,
    y: 101.8,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.96,
    y: 99.69,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.47,
    y: 102.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 41.52,
    y: 103.21,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.61,
    y: 95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.77,
    y: 94.97,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.83,
    y: 97.49,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.13,
    y: 97.65,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.56,
    y: 96.34,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 43.79,
    y: 96.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 45.24,
    y: 95.12,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48.98,
    y: 96.12,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.47,
    y: 96.48,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 41.52,
    y: 97.53,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-163"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.13,
    y: 116.62,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.61,
    y: 117.74,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.77,
    y: 117.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.88,
    y: 115.55,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.68,
    y: 115.51,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 45.24,
    y: 117.86,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48.81,
    y: 116.74,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.96,
    y: 116.74,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.13,
    y: 110.93,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.61,
    y: 112.05,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.77,
    y: 112.02,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.83,
    y: 114.54,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.13,
    y: 114.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.56,
    y: 113.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.88,
    y: 109.86,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.68,
    y: 109.82,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 43.79,
    y: 113.26,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 45.24,
    y: 112.17,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48.81,
    y: 111.05,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48.98,
    y: 113.17,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.96,
    y: 111.05,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.47,
    y: 113.53,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 41.52,
    y: 114.58,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.61,
    y: 106.37,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.77,
    y: 106.34,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.83,
    y: 108.85,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.13,
    y: 109.02,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.56,
    y: 107.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 43.79,
    y: 107.58,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 45.24,
    y: 106.49,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48.98,
    y: 107.49,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.47,
    y: 107.85,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 41.52,
    y: 108.89,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-157"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.13,
    y: 127.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.61,
    y: 129.1,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.77,
    y: 129.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.88,
    y: 126.91,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.68,
    y: 126.87,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 45.24,
    y: 129.22,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48.81,
    y: 128.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.96,
    y: 128.1,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.13,
    y: 122.3,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.61,
    y: 123.42,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.77,
    y: 123.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.83,
    y: 125.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.13,
    y: 126.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.56,
    y: 124.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.88,
    y: 121.23,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.68,
    y: 121.19,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 43.79,
    y: 124.63,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 45.24,
    y: 123.54,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48.81,
    y: 122.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48.98,
    y: 124.54,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.96,
    y: 122.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.47,
    y: 124.9,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 41.52,
    y: 125.94,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.61,
    y: 117.74,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.77,
    y: 117.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.83,
    y: 120.22,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.13,
    y: 120.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.56,
    y: 119.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 43.79,
    y: 118.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 45.24,
    y: 117.86,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48.98,
    y: 118.85,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.47,
    y: 119.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 41.52,
    y: 120.26,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-154"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.73,
    y: 82.51,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 29.21,
    y: 83.63,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 36.37,
    y: 83.6,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 29.48,
    y: 81.45,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 35.28,
    y: 81.4,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 33.84,
    y: 83.76,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 37.41,
    y: 82.64,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 28.56,
    y: 82.64,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.73,
    y: 76.83,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 29.21,
    y: 77.95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 36.37,
    y: 77.92,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 36.43,
    y: 80.44,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.73,
    y: 80.6,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 28.16,
    y: 79.28,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 29.48,
    y: 75.76,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 35.28,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.38,
    y: 79.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 33.84,
    y: 78.07,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 37.41,
    y: 76.95,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 37.58,
    y: 79.07,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 28.56,
    y: 76.95,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 35.07,
    y: 79.43,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 30.12,
    y: 80.48,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 29.21,
    y: 72.27,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 36.37,
    y: 72.24,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 36.43,
    y: 74.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.73,
    y: 74.92,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 28.16,
    y: 73.6,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.38,
    y: 73.48,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 33.84,
    y: 72.39,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 37.58,
    y: 73.39,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 35.07,
    y: 73.75,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 30.12,
    y: 74.79,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-169"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.73,
    y: 93.88,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 29.21,
    y: 95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 36.37,
    y: 94.97,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 29.48,
    y: 92.81,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 35.28,
    y: 92.77,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 33.84,
    y: 95.12,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 37.41,
    y: 94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 28.56,
    y: 94,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.73,
    y: 88.2,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 29.21,
    y: 89.32,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 36.37,
    y: 89.29,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 36.43,
    y: 91.8,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.73,
    y: 91.97,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 28.16,
    y: 90.65,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 29.48,
    y: 87.13,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 35.28,
    y: 87.09,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.38,
    y: 90.53,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 33.84,
    y: 89.44,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 37.41,
    y: 88.32,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 37.58,
    y: 90.44,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 28.56,
    y: 88.32,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 35.07,
    y: 90.8,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 30.12,
    y: 91.84,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 29.21,
    y: 83.63,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 36.37,
    y: 83.6,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 36.43,
    y: 86.12,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.73,
    y: 86.29,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 28.16,
    y: 84.97,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.38,
    y: 84.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 33.84,
    y: 83.76,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 37.58,
    y: 84.75,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 35.07,
    y: 85.11,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 30.12,
    y: 86.16,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-168"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.73,
    y: 105.25,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 29.21,
    y: 106.37,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 36.37,
    y: 106.34,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 29.48,
    y: 104.18,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 35.28,
    y: 104.14,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 33.84,
    y: 106.49,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 37.41,
    y: 105.37,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 28.56,
    y: 105.37,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.73,
    y: 99.57,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 29.21,
    y: 100.68,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 36.37,
    y: 100.65,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 36.43,
    y: 103.17,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.73,
    y: 103.34,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 28.16,
    y: 102.02,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 29.48,
    y: 98.5,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 35.28,
    y: 98.45,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.38,
    y: 101.89,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 33.84,
    y: 100.81,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 37.41,
    y: 99.69,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 37.58,
    y: 101.8,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 28.56,
    y: 99.69,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 35.07,
    y: 102.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 30.12,
    y: 103.21,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 29.21,
    y: 95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 36.37,
    y: 94.97,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 36.43,
    y: 97.49,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.73,
    y: 97.65,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 28.16,
    y: 96.34,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.38,
    y: 96.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 33.84,
    y: 95.12,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 37.58,
    y: 96.12,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 35.07,
    y: 96.48,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 30.12,
    y: 97.53,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-171"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.73,
    y: 116.62,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 29.21,
    y: 117.74,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 36.37,
    y: 117.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 29.48,
    y: 115.55,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 35.28,
    y: 115.51,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 33.84,
    y: 117.86,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 37.41,
    y: 116.74,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 28.56,
    y: 116.74,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.73,
    y: 110.93,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 29.21,
    y: 112.05,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 36.37,
    y: 112.02,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 36.43,
    y: 114.54,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.73,
    y: 114.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 28.16,
    y: 113.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 29.48,
    y: 109.86,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 35.28,
    y: 109.82,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.38,
    y: 113.26,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 33.84,
    y: 112.17,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 37.41,
    y: 111.05,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 37.58,
    y: 113.17,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 28.56,
    y: 111.05,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 35.07,
    y: 113.53,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 30.12,
    y: 114.58,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 29.21,
    y: 106.37,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 36.37,
    y: 106.34,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 36.43,
    y: 108.85,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.73,
    y: 109.02,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 28.16,
    y: 107.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.38,
    y: 107.58,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 33.84,
    y: 106.49,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 37.58,
    y: 107.49,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 35.07,
    y: 107.85,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 30.12,
    y: 108.89,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-173"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.73,
    y: 127.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 29.21,
    y: 129.1,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 36.37,
    y: 129.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 29.48,
    y: 126.91,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 35.28,
    y: 126.87,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 33.84,
    y: 129.22,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 37.41,
    y: 128.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 28.56,
    y: 128.1,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.73,
    y: 122.3,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 29.21,
    y: 123.42,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 36.37,
    y: 123.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 36.43,
    y: 125.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.73,
    y: 126.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 28.16,
    y: 124.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 29.48,
    y: 121.23,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 35.28,
    y: 121.19,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.38,
    y: 124.63,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 33.84,
    y: 123.54,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 37.41,
    y: 122.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 37.58,
    y: 124.54,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 28.56,
    y: 122.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 35.07,
    y: 124.9,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 30.12,
    y: 125.94,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 29.21,
    y: 117.74,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 36.37,
    y: 117.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 36.43,
    y: 120.22,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.73,
    y: 120.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 28.16,
    y: 119.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.38,
    y: 118.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 33.84,
    y: 117.86,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 37.58,
    y: 118.85,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 35.07,
    y: 119.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 30.12,
    y: 120.26,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-155"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 21.33,
    y: 82.51,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 17.8,
    y: 83.63,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 24.96,
    y: 83.6,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 18.08,
    y: 81.45,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 23.88,
    y: 81.4,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 22.43,
    y: 83.76,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 26,
    y: 82.64,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 17.16,
    y: 82.64,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 21.33,
    y: 76.83,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 17.8,
    y: 77.95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 24.96,
    y: 77.92,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 25.03,
    y: 80.44,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 21.33,
    y: 80.6,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 16.76,
    y: 79.28,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 18.08,
    y: 75.76,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 23.88,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 20.98,
    y: 79.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 22.43,
    y: 78.07,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 26,
    y: 76.95,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 26.18,
    y: 79.07,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 17.16,
    y: 76.95,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 23.67,
    y: 79.43,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 18.71,
    y: 80.48,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 17.8,
    y: 72.27,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 24.96,
    y: 72.24,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 25.03,
    y: 74.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 21.33,
    y: 74.92,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 16.76,
    y: 73.6,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 20.98,
    y: 73.48,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 22.43,
    y: 72.39,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 26.18,
    y: 73.39,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 23.67,
    y: 73.75,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 18.71,
    y: 74.79,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-170"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 21.33,
    y: 93.88,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 17.8,
    y: 95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 24.96,
    y: 94.97,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 18.08,
    y: 92.81,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 23.88,
    y: 92.77,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 22.43,
    y: 95.12,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 26,
    y: 94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 17.16,
    y: 94,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 21.33,
    y: 88.2,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 17.8,
    y: 89.32,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 24.96,
    y: 89.29,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 25.03,
    y: 91.8,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 21.33,
    y: 91.97,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 16.76,
    y: 90.65,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 18.08,
    y: 87.13,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 23.88,
    y: 87.09,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 20.98,
    y: 90.53,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 22.43,
    y: 89.44,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 26,
    y: 88.32,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 26.18,
    y: 90.44,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 17.16,
    y: 88.32,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 23.67,
    y: 90.8,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 18.71,
    y: 91.84,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 17.8,
    y: 83.63,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 24.96,
    y: 83.6,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 25.03,
    y: 86.12,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 21.33,
    y: 86.29,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 16.76,
    y: 84.97,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 20.98,
    y: 84.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 22.43,
    y: 83.76,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 26.18,
    y: 84.75,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 23.67,
    y: 85.11,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 18.71,
    y: 86.16,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-172"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 21.33,
    y: 105.25,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 17.8,
    y: 106.37,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 24.96,
    y: 106.34,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 18.08,
    y: 104.18,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 23.88,
    y: 104.14,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 22.43,
    y: 106.49,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 26,
    y: 105.37,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 17.16,
    y: 105.37,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 21.33,
    y: 99.57,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 17.8,
    y: 100.68,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 24.96,
    y: 100.65,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 25.03,
    y: 103.17,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 21.33,
    y: 103.34,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 16.76,
    y: 102.02,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 18.08,
    y: 98.5,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 23.88,
    y: 98.45,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 20.98,
    y: 101.89,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 22.43,
    y: 100.81,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 26,
    y: 99.69,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 26.18,
    y: 101.8,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 17.16,
    y: 99.69,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 23.67,
    y: 102.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 18.71,
    y: 103.21,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 17.8,
    y: 95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 24.96,
    y: 94.97,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 25.03,
    y: 97.49,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 21.33,
    y: 97.65,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 16.76,
    y: 96.34,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 20.98,
    y: 96.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 22.43,
    y: 95.12,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 26.18,
    y: 96.12,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 23.67,
    y: 96.48,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 18.71,
    y: 97.53,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-156"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 21.33,
    y: 116.62,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 17.8,
    y: 117.74,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 24.96,
    y: 117.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 18.08,
    y: 115.55,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 23.88,
    y: 115.51,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 22.43,
    y: 117.86,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 26,
    y: 116.74,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 17.16,
    y: 116.74,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 21.33,
    y: 110.93,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 17.8,
    y: 112.05,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 24.96,
    y: 112.02,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 25.03,
    y: 114.54,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 21.33,
    y: 114.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 16.76,
    y: 113.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 18.08,
    y: 109.86,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 23.88,
    y: 109.82,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 20.98,
    y: 113.26,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 22.43,
    y: 112.17,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 26,
    y: 111.05,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 26.18,
    y: 113.17,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 17.16,
    y: 111.05,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 23.67,
    y: 113.53,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 18.71,
    y: 114.58,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 17.8,
    y: 106.37,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 24.96,
    y: 106.34,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 25.03,
    y: 108.85,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 21.33,
    y: 109.02,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 16.76,
    y: 107.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 20.98,
    y: 107.58,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 22.43,
    y: 106.49,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 26.18,
    y: 107.49,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 23.67,
    y: 107.85,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 18.71,
    y: 108.89,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-110"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 21.33,
    y: 127.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 17.8,
    y: 129.1,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 24.96,
    y: 129.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 18.08,
    y: 126.91,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 23.88,
    y: 126.87,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 22.43,
    y: 129.22,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 26,
    y: 128.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 17.16,
    y: 128.1,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 21.33,
    y: 122.3,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 17.8,
    y: 123.42,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 24.96,
    y: 123.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 25.03,
    y: 125.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 21.33,
    y: 126.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 16.76,
    y: 124.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 18.08,
    y: 121.23,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 23.88,
    y: 121.19,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 20.98,
    y: 124.63,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 22.43,
    y: 123.54,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 26,
    y: 122.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 26.18,
    y: 124.54,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 17.16,
    y: 122.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 23.67,
    y: 124.9,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 18.71,
    y: 125.94,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 17.8,
    y: 117.74,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 24.96,
    y: 117.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 25.03,
    y: 120.22,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 21.33,
    y: 120.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 16.76,
    y: 119.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 20.98,
    y: 118.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 22.43,
    y: 117.86,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 26.18,
    y: 118.85,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 23.67,
    y: 119.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 18.71,
    y: 120.26,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-111"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.92,
    y: 82.51,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.4,
    y: 83.63,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 13.56,
    y: 83.6,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.67,
    y: 81.45,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 12.47,
    y: 81.4,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 11.03,
    y: 83.76,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 14.6,
    y: 82.64,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 5.76,
    y: 82.64,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.92,
    y: 76.83,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.4,
    y: 77.95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 13.56,
    y: 77.92,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 13.63,
    y: 80.44,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.92,
    y: 80.6,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 5.36,
    y: 79.28,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.67,
    y: 75.76,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 12.47,
    y: 75.72,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.58,
    y: 79.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 11.03,
    y: 78.07,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 14.6,
    y: 76.95,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 14.78,
    y: 79.07,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 5.76,
    y: 76.95,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 12.26,
    y: 79.43,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 7.31,
    y: 80.48,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.4,
    y: 72.27,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 13.56,
    y: 72.24,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 13.63,
    y: 74.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.92,
    y: 74.92,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 5.36,
    y: 73.6,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.58,
    y: 73.48,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 11.03,
    y: 72.39,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 14.78,
    y: 73.39,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 12.26,
    y: 73.75,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 7.31,
    y: 74.79,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-114"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.92,
    y: 93.88,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.4,
    y: 95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 13.56,
    y: 94.97,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.67,
    y: 92.81,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 12.47,
    y: 92.77,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 11.03,
    y: 95.12,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 14.6,
    y: 94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 5.76,
    y: 94,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.92,
    y: 88.2,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.4,
    y: 89.32,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 13.56,
    y: 89.29,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 13.63,
    y: 91.8,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.92,
    y: 91.97,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 5.36,
    y: 90.65,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.67,
    y: 87.13,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 12.47,
    y: 87.09,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.58,
    y: 90.53,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 11.03,
    y: 89.44,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 14.6,
    y: 88.32,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 14.78,
    y: 90.44,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 5.76,
    y: 88.32,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 12.26,
    y: 90.8,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 7.31,
    y: 91.84,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.4,
    y: 83.63,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 13.56,
    y: 83.6,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 13.63,
    y: 86.12,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.92,
    y: 86.29,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 5.36,
    y: 84.97,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.58,
    y: 84.84,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 11.03,
    y: 83.76,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 14.78,
    y: 84.75,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 12.26,
    y: 85.11,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 7.31,
    y: 86.16,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-108"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.92,
    y: 105.25,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.4,
    y: 106.37,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 13.56,
    y: 106.34,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.67,
    y: 104.18,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 12.47,
    y: 104.14,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 11.03,
    y: 106.49,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 14.6,
    y: 105.37,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 5.76,
    y: 105.37,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.92,
    y: 99.57,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.4,
    y: 100.68,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 13.56,
    y: 100.65,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 13.63,
    y: 103.17,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.92,
    y: 103.34,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 5.36,
    y: 102.02,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.67,
    y: 98.5,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 12.47,
    y: 98.45,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.58,
    y: 101.89,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 11.03,
    y: 100.81,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 14.6,
    y: 99.69,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 14.78,
    y: 101.8,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 5.76,
    y: 99.69,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 12.26,
    y: 102.16,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 7.31,
    y: 103.21,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.4,
    y: 95,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 13.56,
    y: 94.97,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 13.63,
    y: 97.49,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.92,
    y: 97.65,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 5.36,
    y: 96.34,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.58,
    y: 96.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 11.03,
    y: 95.12,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 14.78,
    y: 96.12,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 12.26,
    y: 96.48,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 7.31,
    y: 97.53,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-116"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.92,
    y: 116.62,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.4,
    y: 117.74,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 13.56,
    y: 117.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.67,
    y: 115.55,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 12.47,
    y: 115.51,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 11.03,
    y: 117.86,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 14.6,
    y: 116.74,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 5.76,
    y: 116.74,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.92,
    y: 110.93,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.4,
    y: 112.05,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 13.56,
    y: 112.02,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 13.63,
    y: 114.54,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.92,
    y: 114.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 5.36,
    y: 113.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.67,
    y: 109.86,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 12.47,
    y: 109.82,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.58,
    y: 113.26,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 11.03,
    y: 112.17,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 14.6,
    y: 111.05,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 14.78,
    y: 113.17,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 5.76,
    y: 111.05,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 12.26,
    y: 113.53,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 7.31,
    y: 114.58,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.4,
    y: 106.37,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 13.56,
    y: 106.34,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 13.63,
    y: 108.85,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.92,
    y: 109.02,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 5.36,
    y: 107.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.58,
    y: 107.58,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 11.03,
    y: 106.49,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 14.78,
    y: 107.49,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 12.26,
    y: 107.85,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 7.31,
    y: 108.89,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-109"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.92,
    y: 127.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.4,
    y: 129.1,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 13.56,
    y: 129.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.67,
    y: 126.91,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 12.47,
    y: 126.87,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 11.03,
    y: 129.22,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 14.6,
    y: 128.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 5.76,
    y: 128.1,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.92,
    y: 122.3,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.4,
    y: 123.42,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 13.56,
    y: 123.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 13.63,
    y: 125.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.92,
    y: 126.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 5.36,
    y: 124.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.67,
    y: 121.23,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 12.47,
    y: 121.19,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.58,
    y: 124.63,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 11.03,
    y: 123.54,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 14.6,
    y: 122.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 14.78,
    y: 124.54,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 5.76,
    y: 122.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 12.26,
    y: 124.9,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 7.31,
    y: 125.94,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.4,
    y: 117.74,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 13.56,
    y: 117.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 13.63,
    y: 120.22,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.92,
    y: 120.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 5.36,
    y: 119.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.58,
    y: 118.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 11.03,
    y: 117.86,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 14.78,
    y: 118.85,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 12.26,
    y: 119.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 7.31,
    y: 120.26,
    width: 1.98,
    height: 0.72
  })))))), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M6.09,81.47h90.52c-15.18-10.4-30.36-20.8-45.55-31.2-14.99,10.4-29.98,20.8-44.97,31.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 11.84,
    y: 125.5,
    width: 79.01,
    height: 6.9,
    transform: "translate(102.69 257.91) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-117"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-113"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.78,
    y: 127.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.26,
    y: 129.1,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.41,
    y: 129.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.53,
    y: 126.91,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.33,
    y: 126.87,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.88,
    y: 129.22,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.46,
    y: 128.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.61,
    y: 128.1,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.78,
    y: 122.3,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.26,
    y: 123.42,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.41,
    y: 123.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.48,
    y: 125.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.78,
    y: 126.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.21,
    y: 124.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.53,
    y: 121.23,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.33,
    y: 121.19,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.43,
    y: 124.63,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.88,
    y: 123.54,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.46,
    y: 122.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.63,
    y: 124.54,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.61,
    y: 122.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.12,
    y: 124.9,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 87.16,
    y: 125.94,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.26,
    y: 117.74,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.41,
    y: 117.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.48,
    y: 120.22,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.78,
    y: 120.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.21,
    y: 119.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.43,
    y: 118.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.88,
    y: 117.86,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.63,
    y: 118.85,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.12,
    y: 119.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 87.16,
    y: 120.26,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-112"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.78,
    y: 139.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.26,
    y: 140.47,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.41,
    y: 140.44,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.53,
    y: 138.28,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.33,
    y: 138.24,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.88,
    y: 140.59,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.46,
    y: 139.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.61,
    y: 139.47,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.78,
    y: 133.67,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.26,
    y: 134.79,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.41,
    y: 134.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.48,
    y: 137.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.78,
    y: 137.44,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.21,
    y: 136.12,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.53,
    y: 132.6,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.33,
    y: 132.56,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.43,
    y: 135.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.88,
    y: 134.91,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.46,
    y: 133.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.63,
    y: 135.9,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.61,
    y: 133.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.12,
    y: 136.26,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 87.16,
    y: 137.31,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 86.26,
    y: 129.1,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.41,
    y: 129.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 93.48,
    y: 131.59,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.78,
    y: 131.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 85.21,
    y: 130.44,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 89.43,
    y: 130.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.88,
    y: 129.22,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 94.63,
    y: 130.22,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.12,
    y: 130.58,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 87.16,
    y: 131.63,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-115"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.38,
    y: 127.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.85,
    y: 129.1,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 82.01,
    y: 129.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.13,
    y: 126.91,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.93,
    y: 126.87,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 79.48,
    y: 129.22,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.05,
    y: 128.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.21,
    y: 128.1,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.38,
    y: 122.3,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.85,
    y: 123.42,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 82.01,
    y: 123.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 82.08,
    y: 125.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.38,
    y: 126.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.81,
    y: 124.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.13,
    y: 121.23,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.93,
    y: 121.19,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.03,
    y: 124.63,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 79.48,
    y: 123.54,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.05,
    y: 122.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.23,
    y: 124.54,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.21,
    y: 122.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.72,
    y: 124.9,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.76,
    y: 125.94,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.85,
    y: 117.74,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 82.01,
    y: 117.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 82.08,
    y: 120.22,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.38,
    y: 120.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.81,
    y: 119.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.03,
    y: 118.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 79.48,
    y: 117.86,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.23,
    y: 118.85,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.72,
    y: 119.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.76,
    y: 120.26,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-152"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.38,
    y: 139.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.85,
    y: 140.47,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 82.01,
    y: 140.44,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.13,
    y: 138.28,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.93,
    y: 138.24,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 79.48,
    y: 140.59,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.05,
    y: 139.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.21,
    y: 139.47,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.38,
    y: 133.67,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.85,
    y: 134.79,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 82.01,
    y: 134.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 82.08,
    y: 137.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.38,
    y: 137.44,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.81,
    y: 136.12,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.13,
    y: 132.6,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.93,
    y: 132.56,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.03,
    y: 135.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 79.48,
    y: 134.91,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.05,
    y: 133.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.23,
    y: 135.9,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.21,
    y: 133.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.72,
    y: 136.26,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.76,
    y: 137.31,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 74.85,
    y: 129.1,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 82.01,
    y: 129.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 82.08,
    y: 131.59,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.38,
    y: 131.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 73.81,
    y: 130.44,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 78.03,
    y: 130.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 79.48,
    y: 129.22,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 83.23,
    y: 130.22,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 80.72,
    y: 130.58,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 75.76,
    y: 131.63,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-121"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.97,
    y: 127.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.45,
    y: 129.1,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.61,
    y: 129.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.72,
    y: 126.91,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.52,
    y: 126.87,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.08,
    y: 129.22,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 71.65,
    y: 128.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.8,
    y: 128.1,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.97,
    y: 122.3,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.45,
    y: 123.42,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.61,
    y: 123.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.68,
    y: 125.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.97,
    y: 126.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.4,
    y: 124.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.72,
    y: 121.23,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.52,
    y: 121.19,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.63,
    y: 124.63,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.08,
    y: 123.54,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 71.65,
    y: 122.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 71.83,
    y: 124.54,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.8,
    y: 122.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.31,
    y: 124.9,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 64.36,
    y: 125.94,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.45,
    y: 117.74,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.61,
    y: 117.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.68,
    y: 120.22,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.97,
    y: 120.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.4,
    y: 119.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.63,
    y: 118.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.08,
    y: 117.86,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 71.83,
    y: 118.85,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.31,
    y: 119.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 64.36,
    y: 120.26,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-120"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.97,
    y: 139.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.45,
    y: 140.47,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.61,
    y: 140.44,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.72,
    y: 138.28,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.52,
    y: 138.24,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.08,
    y: 140.59,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 71.65,
    y: 139.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.8,
    y: 139.47,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.97,
    y: 133.67,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.45,
    y: 134.79,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.61,
    y: 134.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.68,
    y: 137.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.97,
    y: 137.44,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.4,
    y: 136.12,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.72,
    y: 132.6,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.52,
    y: 132.56,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.63,
    y: 135.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.08,
    y: 134.91,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 71.65,
    y: 133.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 71.83,
    y: 135.9,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.8,
    y: 133.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.31,
    y: 136.26,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 64.36,
    y: 137.31,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.45,
    y: 129.1,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.61,
    y: 129.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 70.68,
    y: 131.59,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.97,
    y: 131.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 62.4,
    y: 130.44,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 66.63,
    y: 130.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 68.08,
    y: 129.22,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 71.83,
    y: 130.22,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 69.31,
    y: 130.58,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 64.36,
    y: 131.63,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-123"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.57,
    y: 127.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.05,
    y: 129.1,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.21,
    y: 129.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.32,
    y: 126.91,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 58.12,
    y: 126.87,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 56.68,
    y: 129.22,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 60.25,
    y: 128.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 51.4,
    y: 128.1,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.57,
    y: 122.3,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.05,
    y: 123.42,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.21,
    y: 123.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.27,
    y: 125.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.57,
    y: 126.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 51,
    y: 124.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.32,
    y: 121.23,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 58.12,
    y: 121.19,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.22,
    y: 124.63,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 56.68,
    y: 123.54,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 60.25,
    y: 122.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 60.42,
    y: 124.54,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 51.4,
    y: 122.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.91,
    y: 124.9,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.96,
    y: 125.94,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.05,
    y: 117.74,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.21,
    y: 117.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.27,
    y: 120.22,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.57,
    y: 120.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 51,
    y: 119.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.22,
    y: 118.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 56.68,
    y: 117.86,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 60.42,
    y: 118.85,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.91,
    y: 119.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.96,
    y: 120.26,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-119"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.57,
    y: 139.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.05,
    y: 140.47,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.21,
    y: 140.44,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.32,
    y: 138.28,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 58.12,
    y: 138.24,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 56.68,
    y: 140.59,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 60.25,
    y: 139.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 51.4,
    y: 139.47,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.57,
    y: 133.67,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.05,
    y: 134.79,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.21,
    y: 134.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.27,
    y: 137.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.57,
    y: 137.44,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 51,
    y: 136.12,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.32,
    y: 132.6,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 58.12,
    y: 132.56,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.22,
    y: 135.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 56.68,
    y: 134.91,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 60.25,
    y: 133.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 60.42,
    y: 135.9,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 51.4,
    y: 133.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.91,
    y: 136.26,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.96,
    y: 137.31,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.05,
    y: 129.1,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.21,
    y: 129.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.27,
    y: 131.59,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.57,
    y: 131.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 51,
    y: 130.44,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.22,
    y: 130.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 56.68,
    y: 129.22,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 60.42,
    y: 130.22,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 57.91,
    y: 130.58,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 52.96,
    y: 131.63,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-125"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.17,
    y: 127.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.65,
    y: 129.1,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.8,
    y: 129.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.92,
    y: 126.91,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.72,
    y: 126.87,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 45.27,
    y: 129.22,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48.85,
    y: 128.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40,
    y: 128.1,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.17,
    y: 122.3,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.65,
    y: 123.42,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.8,
    y: 123.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.87,
    y: 125.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.17,
    y: 126.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.6,
    y: 124.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.92,
    y: 121.23,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.72,
    y: 121.19,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 43.82,
    y: 124.63,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 45.27,
    y: 123.54,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48.85,
    y: 122.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 49.02,
    y: 124.54,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40,
    y: 122.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.51,
    y: 124.9,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 41.55,
    y: 125.94,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.65,
    y: 117.74,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.8,
    y: 117.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.87,
    y: 120.22,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.17,
    y: 120.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.6,
    y: 119.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 43.82,
    y: 118.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 45.27,
    y: 117.86,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 49.02,
    y: 118.85,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.51,
    y: 119.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 41.55,
    y: 120.26,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-124"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.17,
    y: 139.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.65,
    y: 140.47,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.8,
    y: 140.44,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.92,
    y: 138.28,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.72,
    y: 138.24,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 45.27,
    y: 140.59,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48.85,
    y: 139.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40,
    y: 139.47,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.17,
    y: 133.67,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.65,
    y: 134.79,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.8,
    y: 134.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.87,
    y: 137.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.17,
    y: 137.44,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.6,
    y: 136.12,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.92,
    y: 132.6,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.72,
    y: 132.56,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 43.82,
    y: 135.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 45.27,
    y: 134.91,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48.85,
    y: 133.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 49.02,
    y: 135.9,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40,
    y: 133.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.51,
    y: 136.26,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 41.55,
    y: 137.31,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 40.65,
    y: 129.1,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.8,
    y: 129.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 47.87,
    y: 131.59,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 44.17,
    y: 131.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 39.6,
    y: 130.44,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 43.82,
    y: 130.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 45.27,
    y: 129.22,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 49.02,
    y: 130.22,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 46.51,
    y: 130.58,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 41.55,
    y: 131.63,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-153"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.77,
    y: 127.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 29.24,
    y: 129.1,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 36.4,
    y: 129.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 29.52,
    y: 126.91,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 35.32,
    y: 126.87,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 33.87,
    y: 129.22,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 37.44,
    y: 128.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 28.6,
    y: 128.1,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.77,
    y: 122.3,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 29.24,
    y: 123.42,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 36.4,
    y: 123.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 36.47,
    y: 125.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.77,
    y: 126.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 28.2,
    y: 124.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 29.52,
    y: 121.23,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 35.32,
    y: 121.19,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.42,
    y: 124.63,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 33.87,
    y: 123.54,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 37.44,
    y: 122.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 37.62,
    y: 124.54,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 28.6,
    y: 122.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 35.11,
    y: 124.9,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 30.15,
    y: 125.94,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 29.24,
    y: 117.74,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 36.4,
    y: 117.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 36.47,
    y: 120.22,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.77,
    y: 120.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 28.2,
    y: 119.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.42,
    y: 118.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 33.87,
    y: 117.86,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 37.62,
    y: 118.85,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 35.11,
    y: 119.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 30.15,
    y: 120.26,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-118"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.77,
    y: 139.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 29.24,
    y: 140.47,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 36.4,
    y: 140.44,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 29.52,
    y: 138.28,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 35.32,
    y: 138.24,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 33.87,
    y: 140.59,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 37.44,
    y: 139.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 28.6,
    y: 139.47,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.77,
    y: 133.67,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 29.24,
    y: 134.79,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 36.4,
    y: 134.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 36.47,
    y: 137.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.77,
    y: 137.44,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 28.2,
    y: 136.12,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 29.52,
    y: 132.6,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 35.32,
    y: 132.56,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.42,
    y: 135.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 33.87,
    y: 134.91,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 37.44,
    y: 133.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 37.62,
    y: 135.9,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 28.6,
    y: 133.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 35.11,
    y: 136.26,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 30.15,
    y: 137.31,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 29.24,
    y: 129.1,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 36.4,
    y: 129.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 36.47,
    y: 131.59,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.77,
    y: 131.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 28.2,
    y: 130.44,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 32.42,
    y: 130.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 33.87,
    y: 129.22,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 37.62,
    y: 130.22,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 35.11,
    y: 130.58,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 30.15,
    y: 131.63,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 21.36,
    y: 127.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 17.84,
    y: 129.1,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 25,
    y: 129.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 18.11,
    y: 126.91,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 23.91,
    y: 126.87,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 22.47,
    y: 129.22,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 26.04,
    y: 128.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 17.19,
    y: 128.1,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 21.36,
    y: 122.3,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 17.84,
    y: 123.42,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 25,
    y: 123.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 25.07,
    y: 125.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 21.36,
    y: 126.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 16.79,
    y: 124.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 18.11,
    y: 121.23,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 23.91,
    y: 121.19,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 21.02,
    y: 124.63,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 22.47,
    y: 123.54,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 26.04,
    y: 122.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 26.22,
    y: 124.54,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 17.19,
    y: 122.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 23.7,
    y: 124.9,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 18.75,
    y: 125.94,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 17.84,
    y: 117.74,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 25,
    y: 117.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 25.07,
    y: 120.22,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 21.36,
    y: 120.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 16.79,
    y: 119.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 21.02,
    y: 118.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 22.47,
    y: 117.86,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 26.22,
    y: 118.85,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 23.7,
    y: 119.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 18.75,
    y: 120.26,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-131"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 21.36,
    y: 139.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 17.84,
    y: 140.47,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 25,
    y: 140.44,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 18.11,
    y: 138.28,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 23.91,
    y: 138.24,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 22.47,
    y: 140.59,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 26.04,
    y: 139.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 17.19,
    y: 139.47,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 21.36,
    y: 133.67,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 17.84,
    y: 134.79,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 25,
    y: 134.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 25.07,
    y: 137.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 21.36,
    y: 137.44,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 16.79,
    y: 136.12,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 18.11,
    y: 132.6,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 23.91,
    y: 132.56,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 21.02,
    y: 135.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 22.47,
    y: 134.91,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 26.04,
    y: 133.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 26.22,
    y: 135.9,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 17.19,
    y: 133.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 23.7,
    y: 136.26,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 18.75,
    y: 137.31,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 17.84,
    y: 129.1,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 25,
    y: 129.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 25.07,
    y: 131.59,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 21.36,
    y: 131.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 16.79,
    y: 130.44,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 21.02,
    y: 130.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 22.47,
    y: 129.22,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 26.22,
    y: 130.22,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 23.7,
    y: 130.58,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 18.75,
    y: 131.63,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-128"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.96,
    y: 127.98,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.44,
    y: 129.1,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 13.6,
    y: 129.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.71,
    y: 126.91,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 12.51,
    y: 126.87,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 11.07,
    y: 129.22,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 14.64,
    y: 128.1,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 5.79,
    y: 128.1,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.96,
    y: 122.3,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.44,
    y: 123.42,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 13.6,
    y: 123.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 13.66,
    y: 125.9,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.96,
    y: 126.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 5.39,
    y: 124.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.71,
    y: 121.23,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 12.51,
    y: 121.19,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.61,
    y: 124.63,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 11.07,
    y: 123.54,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 14.64,
    y: 122.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 14.81,
    y: 124.54,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 5.79,
    y: 122.42,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 12.3,
    y: 124.9,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 7.35,
    y: 125.94,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.44,
    y: 117.74,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 13.6,
    y: 117.7,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 13.66,
    y: 120.22,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.96,
    y: 120.39,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 5.39,
    y: 119.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.61,
    y: 118.94,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 11.07,
    y: 117.86,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 14.81,
    y: 118.85,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 12.3,
    y: 119.21,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 7.35,
    y: 120.26,
    width: 1.98,
    height: 0.72
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-126"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.96,
    y: 139.35,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.44,
    y: 140.47,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 13.6,
    y: 140.44,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.71,
    y: 138.28,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 12.51,
    y: 138.24,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 11.07,
    y: 140.59,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 14.64,
    y: 139.47,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 5.79,
    y: 139.47,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.96,
    y: 133.67,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.44,
    y: 134.79,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 13.6,
    y: 134.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 13.66,
    y: 137.27,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.96,
    y: 137.44,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 5.39,
    y: 136.12,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.71,
    y: 132.6,
    width: 2.9,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 12.51,
    y: 132.56,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.61,
    y: 135.99,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 11.07,
    y: 134.91,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 14.64,
    y: 133.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 14.81,
    y: 135.9,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 5.79,
    y: 133.79,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 12.3,
    y: 136.26,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 7.35,
    y: 137.31,
    width: 1.98,
    height: 0.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.44,
    y: 129.1,
    width: 3.18,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 13.6,
    y: 129.07,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 13.66,
    y: 131.59,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.96,
    y: 131.75,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 5.39,
    y: 130.44,
    width: 2.64,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 9.61,
    y: 130.31,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 11.07,
    y: 129.22,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 14.81,
    y: 130.22,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 12.3,
    y: 130.58,
    width: 1.98,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 7.35,
    y: 131.63,
    width: 1.98,
    height: 0.72
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 78.17,
    y: 88.34,
    width: 4.68,
    height: 51.69,
    transform: "translate(161.02 228.38) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 74.49,
    y: 118.72,
    width: 12.03,
    height: 23.53,
    transform: "translate(161.02 260.96) rotate(180)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 75.31,
    y: 88.75,
    width: 10.39,
    height: 2.83,
    transform: "translate(161.02 180.33) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 77.09,
    y: 91.19,
    width: 6.83,
    height: 1.8,
    transform: "translate(161.02 184.18) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 19.84,
    y: 88.34,
    width: 4.68,
    height: 51.69,
    transform: "translate(44.36 228.38) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 16.16,
    y: 118.72,
    width: 12.03,
    height: 23.53,
    transform: "translate(44.36 260.96) rotate(180)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 16.98,
    y: 88.75,
    width: 10.39,
    height: 2.83,
    transform: "translate(44.36 180.33) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 18.76,
    y: 91.19,
    width: 6.83,
    height: 1.8,
    transform: "translate(44.36 184.18) rotate(180)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M51.92,77.93c-4.6,0-8.35-3.73-8.35-8.32s3.74-8.32,8.35-8.32,8.35,3.73,8.35,8.32-3.74,8.32-8.35,8.32ZM51.92,61.79c-4.33,0-7.85,3.51-7.85,7.82s3.52,7.82,7.85,7.82,7.85-3.51,7.85-7.82-3.52-7.82-7.85-7.82Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 38.65,
    y: 90.92,
    width: 26.53,
    height: 34.46,
    transform: "translate(103.84 216.3) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 54.36,
    y: 92.11,
    width: 9.35,
    height: 22.82,
    transform: "translate(118.06 207.05) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.78,
    y: 92.11,
    width: 0.5,
    height: 22.82
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 54.36,
    y: 96.11,
    width: 9.35,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.36,
    y: 100.63,
    width: 9.35,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 54.36,
    y: 105.03,
    width: 9.35,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.36,
    y: 109.55,
    width: 9.35,
    height: 0.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 39.63,
    y: 92.11,
    width: 9.35,
    height: 22.82,
    transform: "translate(88.6 207.05) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.05,
    y: 92.11,
    width: 0.5,
    height: 22.82
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 39.63,
    y: 96.11,
    width: 9.35,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.63,
    y: 100.63,
    width: 9.35,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 39.63,
    y: 105.03,
    width: 9.35,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.63,
    y: 109.55,
    width: 9.35,
    height: 0.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M51.72,124.78c-.07,0-.12-.06-.12-.12v-33.25c0-.07.06-.12.12-.12s.12.06.12.12v33.25c0,.07-.06.12-.12.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.53,110.88c-.07,0-.12-.06-.12-.12v-4.28c0-.07.06-.12.12-.12s.12.06.12.12v4.28c0,.07-.06.12-.12.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.77,110.88c-.07,0-.12-.06-.12-.12v-4.37c0-.07.06-.12.12-.12s.12.06.12.12v4.37c0,.07-.06.12-.12.12Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 28.19,
    y: 125.38,
    width: 46.3,
    height: 16.86,
    transform: "translate(102.69 267.63) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.21,128.01H29.54c-.07,0-.12-.06-.12-.12s.06-.12.12-.12h44.67c.07,0,.12.06.12.12s-.06.12-.12.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.21,131.01H29.54c-.07,0-.12-.06-.12-.12s.06-.12.12-.12h44.67c.07,0,.12.06.12.12s-.06.12-.12.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.26,134.44H29.58c-.07,0-.12-.06-.12-.12s.06-.12.12-.12h44.67c.07,0,.12.06.12.12s-.06.12-.12.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.78,138.33H30.1c-.07,0-.12-.06-.12-.12s.06-.12.12-.12h44.67c.07,0,.12.06.12.12s-.06.12-.12.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.85,128.16c-.07,0-.12-.06-.12-.12v-2.65c0-.07.06-.12.12-.12s.12.06.12.12v2.65c0,.07-.06.12-.12.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.85,125.51h-2.22c-.07,0-.12-.06-.12-.12s.06-.12.12-.12h2.22c.07,0,.12.06.12.12s-.06.12-.12.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.63,121.59c-.07,0-.12-.06-.12-.12v-32.71c0-.07.06-.12.12-.12s.12.06.12.12v32.71c0,.07-.06.12-.12.12Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 56.7,
    y: 19.22,
    width: 9.82,
    height: 14.61,
    transform: "translate(123.23 53.05) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-130"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-129"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 58.59,
    y: 22.71,
    width: 3.85,
    height: 1.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.32,
    y: 24.03,
    width: 3.85,
    height: 1.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63,
    y: 23.99,
    width: 3.2,
    height: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.65,
    y: 21.44,
    width: 3.52,
    height: 1.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 61.68,
    y: 21.39,
    width: 3.85,
    height: 1.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.93,
    y: 24.18,
    width: 2.4,
    height: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 64.26,
    y: 22.85,
    width: 2.4,
    height: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 53.54,
    y: 22.85,
    width: 2.4,
    height: 0.85
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 58.59,
    y: 15.98,
    width: 3.85,
    height: 1.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.32,
    y: 17.3,
    width: 3.85,
    height: 1.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63,
    y: 17.26,
    width: 3.2,
    height: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.08,
    y: 20.24,
    width: 3.2,
    height: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 58.59,
    y: 20.44,
    width: 3.2,
    height: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 53.05,
    y: 18.88,
    width: 3.2,
    height: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.65,
    y: 14.71,
    width: 3.52,
    height: 1.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 61.68,
    y: 14.66,
    width: 3.85,
    height: 1.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 58.17,
    y: 18.74,
    width: 2.4,
    height: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.93,
    y: 17.45,
    width: 2.4,
    height: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 64.26,
    y: 16.12,
    width: 2.4,
    height: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 64.48,
    y: 18.63,
    width: 2.4,
    height: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 53.54,
    y: 16.12,
    width: 2.4,
    height: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 61.43,
    y: 19.05,
    width: 2.4,
    height: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.42,
    y: 20.29,
    width: 2.4,
    height: 0.85
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.32,
    y: 10.58,
    width: 3.85,
    height: 1.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63,
    y: 10.54,
    width: 3.2,
    height: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.08,
    y: 13.52,
    width: 3.2,
    height: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 58.59,
    y: 13.71,
    width: 3.2,
    height: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 53.05,
    y: 12.15,
    width: 3.2,
    height: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 58.17,
    y: 12.01,
    width: 2.4,
    height: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.93,
    y: 10.72,
    width: 2.4,
    height: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 64.48,
    y: 11.9,
    width: 2.4,
    height: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 61.43,
    y: 12.33,
    width: 2.4,
    height: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.42,
    y: 13.56,
    width: 2.4,
    height: 0.85
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-127"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 58.59,
    y: 36.16,
    width: 3.85,
    height: 1.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.32,
    y: 37.49,
    width: 3.85,
    height: 1.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63,
    y: 37.45,
    width: 3.2,
    height: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.65,
    y: 34.9,
    width: 3.52,
    height: 1.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 61.68,
    y: 34.85,
    width: 3.85,
    height: 1.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.93,
    y: 37.63,
    width: 2.4,
    height: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 64.26,
    y: 36.31,
    width: 2.4,
    height: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 53.54,
    y: 36.31,
    width: 2.4,
    height: 0.85
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 58.59,
    y: 29.43,
    width: 3.85,
    height: 1.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.32,
    y: 30.76,
    width: 3.85,
    height: 1.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63,
    y: 30.72,
    width: 3.2,
    height: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.08,
    y: 33.7,
    width: 3.2,
    height: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 58.59,
    y: 33.9,
    width: 3.2,
    height: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 53.05,
    y: 32.34,
    width: 3.2,
    height: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.65,
    y: 28.17,
    width: 3.52,
    height: 1.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 61.68,
    y: 28.12,
    width: 3.85,
    height: 1.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 58.17,
    y: 32.19,
    width: 2.4,
    height: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.93,
    y: 30.9,
    width: 2.4,
    height: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 64.26,
    y: 29.58,
    width: 2.4,
    height: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 64.48,
    y: 32.08,
    width: 2.4,
    height: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 53.54,
    y: 29.58,
    width: 2.4,
    height: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 61.43,
    y: 32.51,
    width: 2.4,
    height: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.42,
    y: 33.75,
    width: 2.4,
    height: 0.85
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 54.32,
    y: 24.03,
    width: 3.85,
    height: 1.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63,
    y: 23.99,
    width: 3.2,
    height: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 63.08,
    y: 26.97,
    width: 3.2,
    height: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 58.59,
    y: 27.17,
    width: 3.2,
    height: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 53.05,
    y: 25.61,
    width: 3.2,
    height: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 58.17,
    y: 25.46,
    width: 2.4,
    height: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 59.93,
    y: 24.18,
    width: 2.4,
    height: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 64.48,
    y: 25.35,
    width: 2.4,
    height: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 61.43,
    y: 25.78,
    width: 2.4,
    height: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 55.42,
    y: 27.02,
    width: 2.4,
    height: 0.85
  })))))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 54.02,
    y: 18.02,
    width: 15.18,
    height: 2.98,
    transform: "translate(123.23 39.02) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M66.51,125.54h5.27c.32-.78.68-1.91.81-3.31.14-1.58-.07-2.89-.28-3.77h-6.17c-.23.93-.46,2.3-.32,3.96.11,1.28.4,2.34.69,3.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M63.79,113.21c0-.42.24-.78.6-.96-.28,0-.5-.23-.5-.51,0-.2.11-.36.28-.45-.15-.21-.24-.48-.24-.76,0-.62.43-1.14,1.01-1.28-.09-.17-.15-.36-.15-.57,0-.66.54-1.2,1.2-1.2.05-.31.25-.58.53-.69-.06-.11-.1-.23-.1-.36,0-.44.36-.8.8-.8.26,0,.48.13.63.33.11-.06.22-.11.34-.15.16-.42.56-.73,1.04-.73.42,0,.78.23.97.57.26.04.46.23.53.48.43,0,.75.31.75.71,0,.02,0,.03-.01.05.26.32.48.69.66,1.1.42.16.73.57.73,1.05,0,.16-.04.32-.1.46.06.09.1.2.1.32,0,.07-.02.14-.04.2.4.2.67.61.67,1.09,0,.33-.13.63-.34.85.03.07.04.14.04.21.31.04.54.27.6.57.12.09.21.23.21.4s-.08.3-.2.39c.08-.02.17-.06.26-.06.26,0,.47.21.47.47s-.2.45-.44.46c0,.05.02.1.02.14.25.22.42.56.42.94s-.16.7-.4.92c.06.1.1.2.1.32,0,.29-.2.53-.47.61-.11.18-.28.3-.49.35-.12.15-.24.28-.38.41.06.12.1.26.1.4,0,.48-.39.87-.88.87-.28,0-.53-.13-.69-.34-.55.22-1.15.34-1.78.34-.88,0-1.69-.24-2.39-.64-.22.24-.54.39-.9.39-.65,0-1.18-.51-1.22-1.15-.12-.17-.2-.38-.2-.61,0-.11.02-.22.05-.32-.33-.07-.58-.35-.58-.7,0-.27.15-.5.37-.63-.15-.13-.25-.32-.25-.53,0-.07.02-.14.04-.21-.28-.16-.47-.46-.47-.8,0-.07.01-.14.03-.21-.19-.19-.31-.46-.31-.75Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M17.84,144.17h-8.4c-.51-1.25-1.08-3.04-1.28-5.27-.23-2.52.1-4.61.44-6h9.82c.37,1.48.74,3.67.52,6.31-.17,2.04-.64,3.72-1.1,4.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M22.18,124.53c0-.67-.39-1.24-.95-1.52.44,0,.8-.37.8-.81,0-.31-.18-.58-.44-.71.24-.34.38-.76.38-1.21,0-.99-.69-1.82-1.61-2.04.15-.27.24-.58.24-.91,0-1.05-.85-1.9-1.91-1.9-.02,0-.05,0-.07,0,0-.51-.32-.93-.77-1.11.09-.18.16-.37.16-.58,0-.7-.57-1.27-1.28-1.27-.42,0-.77.21-1,.52-.18-.09-.36-.17-.54-.24-.25-.67-.89-1.15-1.65-1.15-.66,0-1.24.37-1.54.91-.42.07-.74.36-.84.77-.02,0-.03,0-.05,0-.63,0-1.14.51-1.14,1.13,0,.03.01.05.02.08-.41.51-.76,1.1-1.05,1.75-.68.26-1.16.91-1.16,1.67,0,.26.06.51.16.73-.09.15-.16.31-.16.5,0,.11.03.22.07.32-.63.33-1.06.97-1.06,1.73,0,.52.21,1,.54,1.35-.04.11-.07.22-.07.34-.49.07-.87.43-.96.9-.2.15-.33.37-.33.63s.13.48.33.63c-.13-.04-.27-.09-.42-.09-.41,0-.74.33-.74.74s.32.72.71.73c-.02.07-.02.15-.04.23-.41.35-.67.89-.67,1.5s.25,1.12.64,1.47c-.09.15-.15.32-.15.51,0,.47.32.84.74.97.18.28.45.48.79.56.19.23.38.45.6.66-.1.19-.16.41-.16.64,0,.77.62,1.39,1.4,1.39.45,0,.84-.21,1.1-.54.87.35,1.83.54,2.84.54,1.4,0,2.7-.38,3.8-1.02.36.38.86.62,1.43.62,1.04,0,1.88-.81,1.94-1.84.2-.27.32-.6.32-.96,0-.18-.04-.35-.09-.51.53-.12.93-.56.93-1.12,0-.43-.25-.79-.6-1,.24-.21.4-.51.4-.85,0-.12-.03-.23-.07-.34.45-.26.75-.73.75-1.28,0-.11-.02-.23-.04-.33.3-.31.49-.73.49-1.2Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 9.18,
    y: 80.99,
    width: 84.32,
    height: 8.4,
    transform: "translate(102.69 170.37) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-197",
    points: "95.6 82.92 97.61 80.01 51.05 48.12 5.08 80.02 7.1 82.92 51.07 52.41 95.6 82.92"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCare5);
export default __webpack_public_path__ + "static/media/care5.bd2a3b2515040311b063975f0c3b6472.svg";
export { ForwardRef as ReactComponent };